/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 13);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cnConst_cnConst__ = __webpack_require__(28);
var Const=__WEBPACK_IMPORTED_MODULE_0__cnConst_cnConst__["a" /* default */];/* harmony default export */ __webpack_exports__["a"] = (Const);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export propTypes */
/* unused harmony export PropTypes */
/* unused harmony export onError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return observer; });
/* unused harmony export Observer */
/* unused harmony export renderReporter */
/* unused harmony export componentByNodeRegistery */
/* unused harmony export componentByNodeRegistry */
/* unused harmony export trackComponents */
/* unused harmony export useStaticRendering */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return inject; });
/* unused harmony export disposeOnUnmount */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);




function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

// These functions can be stubbed out in specific environments

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x.default : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var reactIs_production_min = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.placeholder"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&("function"===typeof a.then||a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};
exports.isForwardRef=function(a){return q(a)===m};exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};
});

unwrapExports(reactIs_production_min);
var reactIs_production_min_1 = reactIs_production_min.typeOf;
var reactIs_production_min_2 = reactIs_production_min.AsyncMode;
var reactIs_production_min_3 = reactIs_production_min.ContextConsumer;
var reactIs_production_min_4 = reactIs_production_min.ContextProvider;
var reactIs_production_min_5 = reactIs_production_min.Element;
var reactIs_production_min_6 = reactIs_production_min.ForwardRef;
var reactIs_production_min_7 = reactIs_production_min.Fragment;
var reactIs_production_min_8 = reactIs_production_min.Profiler;
var reactIs_production_min_9 = reactIs_production_min.Portal;
var reactIs_production_min_10 = reactIs_production_min.StrictMode;
var reactIs_production_min_11 = reactIs_production_min.isValidElementType;
var reactIs_production_min_12 = reactIs_production_min.isAsyncMode;
var reactIs_production_min_13 = reactIs_production_min.isContextConsumer;
var reactIs_production_min_14 = reactIs_production_min.isContextProvider;
var reactIs_production_min_15 = reactIs_production_min.isElement;
var reactIs_production_min_16 = reactIs_production_min.isForwardRef;
var reactIs_production_min_17 = reactIs_production_min.isFragment;
var reactIs_production_min_18 = reactIs_production_min.isProfiler;
var reactIs_production_min_19 = reactIs_production_min.isPortal;
var reactIs_production_min_20 = reactIs_production_min.isStrictMode;

var reactIs = createCommonjsModule(function (module) {

{
  module.exports = reactIs_production_min;
}
});

var _ReactIs$ForwardRef;

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var TYPE_STATICS = _defineProperty$1({}, reactIs.ForwardRef, (_ReactIs$ForwardRef = {}, _defineProperty$1(_ReactIs$ForwardRef, '$$typeof', true), _defineProperty$1(_ReactIs$ForwardRef, 'render', true), _ReactIs$ForwardRef));

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = TYPE_STATICS[targetComponent['$$typeof']] || REACT_STATICS;
        var sourceStatics = TYPE_STATICS[sourceComponent['$$typeof']] || REACT_STATICS;

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

var hoistNonReactStatics_cjs = hoistNonReactStatics;

var EventEmitter =
/*#__PURE__*/
function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.listeners = [];
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(cb) {
      var _this = this;

      this.listeners.push(cb);
      return function () {
        var index = _this.listeners.indexOf(cb);

        if (index !== -1) _this.listeners.splice(index, 1);
      };
    }
  }, {
    key: "emit",
    value: function emit(data) {
      this.listeners.forEach(function (fn) {
        return fn(data);
      });
    }
  }]);

  return EventEmitter;
}();

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["o" /* untracked */])(function () {
      componentName = componentName || "<<anonymous>>";
      propFullName = propFullName || propName;

      if (props[propName] == null) {
        if (isRequired) {
          var actual = props[propName] === null ? "null" : "undefined";
          return new Error("The " + location + " `" + propFullName + "` is marked as required " + "in `" + componentName + "`, but its value is `" + actual + "`.");
        }

        return null;
      } else {
        return validate.apply(void 0, [props, propName, componentName, location, propFullName].concat(rest));
      }
    });
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
} // Copied from React.PropTypes


function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === "symbol") {
    return true;
  } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


  if (propValue["@@toStringTag"] === "Symbol") {
    return true;
  } // Fallback for non-spec compliant Symbols which are polyfilled.


  if (typeof Symbol === "function" && propValue instanceof Symbol) {
    return true;
  }

  return false;
} // Copied from React.PropTypes


function getPropType(propValue) {
  var propType = _typeof(propValue);

  if (Array.isArray(propValue)) {
    return "array";
  }

  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }

  if (isSymbol(propType, propValue)) {
    return "symbol";
  }

  return propType;
} // This handles more types than `getPropType`. Only used for error messages.
// Copied from React.PropTypes


function getPreciseType(propValue) {
  var propType = getPropType(propValue);

  if (propType === "object") {
    if (propValue instanceof Date) {
      return "date";
    } else if (propValue instanceof RegExp) {
      return "regexp";
    }
  }

  return propType;
}

function createObservableTypeCheckerCreator(allowNativeType, mobxType) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["o" /* untracked */])(function () {
      if (allowNativeType) {
        if (getPropType(props[propName]) === mobxType.toLowerCase()) return null;
      }

      var mobxChecker;

      switch (mobxType) {
        case "Array":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["i" /* isObservableArray */];
          break;

        case "Object":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["k" /* isObservableObject */];
          break;

        case "Map":
          mobxChecker = __WEBPACK_IMPORTED_MODULE_1_mobx__["j" /* isObservableMap */];
          break;

        default:
          throw new Error("Unexpected mobxType: ".concat(mobxType));
      }

      var propValue = props[propName];

      if (!mobxChecker(propValue)) {
        var preciseType = getPreciseType(propValue);
        var nativeTypeExpectationMessage = allowNativeType ? " or javascript `" + mobxType.toLowerCase() + "`" : "";
        return new Error("Invalid prop `" + propFullName + "` of type `" + preciseType + "` supplied to" + " `" + componentName + "`, expected `mobx.Observable" + mobxType + "`" + nativeTypeExpectationMessage + ".");
      }

      return null;
    });
  });
}

function createObservableArrayOfTypeChecker(allowNativeType, typeChecker) {
  return createChainableTypeChecker(function (props, propName, componentName, location, propFullName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
      rest[_key2 - 5] = arguments[_key2];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["o" /* untracked */])(function () {
      if (typeof typeChecker !== "function") {
        return new Error("Property `" + propFullName + "` of component `" + componentName + "` has " + "invalid PropType notation.");
      }

      var error = createObservableTypeCheckerCreator(allowNativeType, "Array")(props, propName, componentName);
      if (error instanceof Error) return error;
      var propValue = props[propName];

      for (var i = 0; i < propValue.length; i++) {
        error = typeChecker.apply(void 0, [propValue, i, componentName, location, propFullName + "[" + i + "]"].concat(rest));
        if (error instanceof Error) return error;
      }

      return null;
    });
  });
}

var observableArray = createObservableTypeCheckerCreator(false, "Array");
var observableArrayOf = createObservableArrayOfTypeChecker.bind(null, false);
var observableMap = createObservableTypeCheckerCreator(false, "Map");
var observableObject = createObservableTypeCheckerCreator(false, "Object");
var arrayOrObservableArray = createObservableTypeCheckerCreator(true, "Array");
var arrayOrObservableArrayOf = createObservableArrayOfTypeChecker.bind(null, true);
var objectOrObservableObject = createObservableTypeCheckerCreator(true, "Object");

var propTypes = /*#__PURE__*/Object.freeze({
  observableArray: observableArray,
  observableArrayOf: observableArrayOf,
  observableMap: observableMap,
  observableObject: observableObject,
  arrayOrObservableArray: arrayOrObservableArray,
  arrayOrObservableArrayOf: arrayOrObservableArrayOf,
  objectOrObservableObject: objectOrObservableObject
});

function isStateless(component) {
  // `function() {}` has prototype, but `() => {}` doesn't
  // `() => {}` via Babel has prototype too.
  return !(component.prototype && component.prototype.render);
}
var symbolId = 0;
function newSymbol(name) {
  if (typeof Symbol === "function") {
    return Symbol(name);
  }

  var symbol = "__$mobx-react ".concat(name, " (").concat(symbolId, ")");
  symbolId++;
  return symbol;
}
var mobxMixins = newSymbol("patchMixins");
var mobxPatchedDefinition = newSymbol("patchedDefinition");

function getMixins(target, methodName) {
  var mixins = target[mobxMixins] = target[mobxMixins] || {};
  var methodMixins = mixins[methodName] = mixins[methodName] || {};
  methodMixins.locks = methodMixins.locks || 0;
  methodMixins.methods = methodMixins.methods || [];
  return methodMixins;
}

function wrapper(realMethod, mixins) {
  var _this = this;

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  // locks are used to ensure that mixins are invoked only once per invocation, even on recursive calls
  mixins.locks++;

  try {
    var retVal;

    if (realMethod !== undefined && realMethod !== null) {
      retVal = realMethod.apply(this, args);
    }

    return retVal;
  } finally {
    mixins.locks--;

    if (mixins.locks === 0) {
      mixins.methods.forEach(function (mx) {
        mx.apply(_this, args);
      });
    }
  }
}

function wrapFunction(realMethod, mixins) {
  var fn = function fn() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    wrapper.call.apply(wrapper, [this, realMethod, mixins].concat(args));
  };

  return fn;
}

function patch(target, methodName) {
  var mixins = getMixins(target, methodName);

  for (var _len3 = arguments.length, mixinMethods = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    mixinMethods[_key3 - 2] = arguments[_key3];
  }

  for (var _i = 0; _i < mixinMethods.length; _i++) {
    var mixinMethod = mixinMethods[_i];

    if (mixins.methods.indexOf(mixinMethod) < 0) {
      mixins.methods.push(mixinMethod);
    }
  }

  var oldDefinition = Object.getOwnPropertyDescriptor(target, methodName);

  if (oldDefinition && oldDefinition[mobxPatchedDefinition]) {
    // already patched definition, do not repatch
    return;
  }

  var originalMethod = target[methodName];
  var newDefinition = createDefinition(target, methodName, oldDefinition ? oldDefinition.enumerable : undefined, mixins, originalMethod);
  Object.defineProperty(target, methodName, newDefinition);
}

function createDefinition(target, methodName, enumerable, mixins, originalMethod) {
  var _ref;

  var wrappedFunc = wrapFunction(originalMethod, mixins);
  return _ref = {}, _defineProperty(_ref, mobxPatchedDefinition, true), _defineProperty(_ref, "get", function get() {
    return wrappedFunc;
  }), _defineProperty(_ref, "set", function set(value) {
    if (this === target) {
      wrappedFunc = wrapFunction(value, mixins);
    } else {
      // when it is an instance of the prototype/a child prototype patch that particular case again separately
      // since we need to store separate values depending on wether it is the actual instance, the prototype, etc
      // e.g. the method for super might not be the same as the method for the prototype which might be not the same
      // as the method for the instance
      var newDefinition = createDefinition(this, methodName, enumerable, mixins, value);
      Object.defineProperty(this, methodName, newDefinition);
    }
  }), _defineProperty(_ref, "configurable", true), _defineProperty(_ref, "enumerable", enumerable), _ref;
}

var injectorContextTypes = {
  mobxStores: objectOrObservableObject
};
Object.seal(injectorContextTypes);
var proxiedInjectorProps = {
  contextTypes: {
    get: function get() {
      return injectorContextTypes;
    },
    set: function set(_) {
      console.warn("Mobx Injector: you are trying to attach `contextTypes` on an component decorated with `inject` (or `observer`) HOC. Please specify the contextTypes on the wrapped component instead. It is accessible through the `wrappedComponent`");
    },
    configurable: true,
    enumerable: false
  },
  isMobxInjector: {
    value: true,
    writable: true,
    configurable: true,
    enumerable: true
  }
  /**
   * Store Injection
   */

};

function createStoreInjector(grabStoresFn, component, injectNames) {
  var displayName = "inject-" + (component.displayName || component.name || component.constructor && component.constructor.name || "Unknown");
  if (injectNames) displayName += "-with-" + injectNames;

  var Injector =
  /*#__PURE__*/
  function (_Component) {
    _inherits(Injector, _Component);

    function Injector() {
      var _getPrototypeOf2;

      var _this;

      _classCallCheck(this, Injector);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Injector)).call.apply(_getPrototypeOf2, [this].concat(args)));

      _this.storeRef = function (instance) {
        _this.wrappedInstance = instance;
      };

      return _this;
    }

    _createClass(Injector, [{
      key: "render",
      value: function render() {
        // Optimization: it might be more efficient to apply the mapper function *outside* the render method
        // (if the mapper is a function), that could avoid expensive(?) re-rendering of the injector component
        // See this test: 'using a custom injector is not too reactive' in inject.js
        var newProps = {};

        for (var key in this.props) {
          if (this.props.hasOwnProperty(key)) {
            newProps[key] = this.props[key];
          }
        }

        var additionalProps = grabStoresFn(this.context.mobxStores || {}, newProps, this.context) || {};

        for (var _key2 in additionalProps) {
          newProps[_key2] = additionalProps[_key2];
        }

        if (!isStateless(component)) {
          newProps.ref = this.storeRef;
        }

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, newProps);
      }
    }]);

    return Injector;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]); // Static fields from component should be visible on the generated Injector


  Injector.displayName = displayName;
  hoistNonReactStatics_cjs(Injector, component);
  Injector.wrappedComponent = component;
  Object.defineProperties(Injector, proxiedInjectorProps);
  return Injector;
}

function grabStoresByName(storeNames) {
  return function (baseStores, nextProps) {
    storeNames.forEach(function (storeName) {
      if (storeName in nextProps // prefer props over stores
      ) return;
      if (!(storeName in baseStores)) throw new Error("MobX injector: Store '" + storeName + "' is not available! Make sure it is provided by some Provider");
      nextProps[storeName] = baseStores[storeName];
    });
    return nextProps;
  };
}
/**
 * higher order component that injects stores to a child.
 * takes either a varargs list of strings, which are stores read from the context,
 * or a function that manually maps the available stores from the context to props:
 * storesToProps(mobxStores, props, context) => newProps
 */


function inject()
/* fn(stores, nextProps) or ...storeNames */
{
  var grabStoresFn;

  if (typeof arguments[0] === "function") {
    grabStoresFn = arguments[0];
    return function (componentClass) {
      var injected = createStoreInjector(grabStoresFn, componentClass);
      injected.isMobxInjector = false; // supress warning
      // mark the Injector as observer, to make it react to expressions in `grabStoresFn`,
      // see #111

      injected = observer(injected);
      injected.isMobxInjector = true; // restore warning

      return injected;
    };
  } else {
    var storeNames = [];

    for (var i = 0; i < arguments.length; i++) {
      storeNames[i] = arguments[i];
    }

    grabStoresFn = grabStoresByName(storeNames);
    return function (componentClass) {
      return createStoreInjector(grabStoresFn, componentClass, storeNames.join("-"));
    };
  }
}

var mobxAdminProperty = __WEBPACK_IMPORTED_MODULE_1_mobx__["a" /* $mobx */] || "$mobx";
var mobxIsUnmounted = newSymbol("isUnmounted");
/**
 * dev tool support
 */

var isDevtoolsEnabled = false;
var isUsingStaticRendering = false;
var warnedAboutObserverInjectDeprecation = false; // WeakMap<Node, Object>;

var componentByNodeRegistry = typeof WeakMap !== "undefined" ? new WeakMap() : undefined;
var renderReporter = new EventEmitter();
var skipRenderKey = newSymbol("skipRender");
var isForcingUpdateKey = newSymbol("isForcingUpdate");
/**
 * Helper to set `prop` to `this` as non-enumerable (hidden prop)
 * @param target
 * @param prop
 * @param value
 */

function setHiddenProp(target, prop, value) {
  if (!Object.hasOwnProperty.call(target, prop)) {
    Object.defineProperty(target, prop, {
      enumerable: false,
      configurable: true,
      writable: true,
      value: value
    });
  } else {
    target[prop] = value;
  }
}

function findDOMNode$2(component) {
  if (__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"]) {
    try {
      return Object(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(component);
    } catch (e) {
      // findDOMNode will throw in react-test-renderer, see:
      // See https://github.com/mobxjs/mobx-react/issues/216
      // Is there a better heuristic?
      return null;
    }
  }

  return null;
}

function reportRendering(component) {
  var node = findDOMNode$2(component);
  if (node && componentByNodeRegistry) componentByNodeRegistry.set(node, component);
  renderReporter.emit({
    event: "render",
    renderTime: component.__$mobRenderEnd - component.__$mobRenderStart,
    totalTime: Date.now() - component.__$mobRenderStart,
    component: component,
    node: node
  });
}

function trackComponents() {
  if (typeof WeakMap === "undefined") throw new Error("[mobx-react] tracking components is not supported in this browser.");
  if (!isDevtoolsEnabled) isDevtoolsEnabled = true;
}
function useStaticRendering(useStaticRendering) {
  isUsingStaticRendering = useStaticRendering;
}
/**
 * Errors reporter
 */

var errorsReporter = new EventEmitter();
/**
 * Utilities
 */

function patch$1(target, funcName) {
  patch(target, funcName, reactiveMixin[funcName]);
}

function shallowEqual(objA, objB) {
  //From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (is(objA, objB)) return true;

  if (_typeof(objA) !== "object" || objA === null || _typeof(objB) !== "object" || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

function is(x, y) {
  // From: https://github.com/facebook/fbjs/blob/c69904a511b900266935168223063dd8772dfc40/packages/fbjs/src/core/shallowEqual.js
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function makeComponentReactive(render) {
  var _this2 = this;

  if (isUsingStaticRendering === true) return render.call(this);

  function reactiveRender() {
    var _this = this;

    isRenderingPending = false;
    var exception = undefined;
    var rendering = undefined;
    reaction.track(function () {
      if (isDevtoolsEnabled) {
        _this.__$mobRenderStart = Date.now();
      }

      try {
        rendering = Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["c" /* _allowStateChanges */])(false, baseRender);
      } catch (e) {
        exception = e;
      }

      if (isDevtoolsEnabled) {
        _this.__$mobRenderEnd = Date.now();
      }
    });

    if (exception) {
      errorsReporter.emit(exception);
      throw exception;
    }

    return rendering;
  } // Generate friendly name for debugging


  var initialName = this.displayName || this.name || this.constructor && (this.constructor.displayName || this.constructor.name) || "<component>";
  var rootNodeID = this._reactInternalInstance && this._reactInternalInstance._rootNodeID || this._reactInternalInstance && this._reactInternalInstance._debugID || this._reactInternalFiber && this._reactInternalFiber._debugID;
  /**
   * If props are shallowly modified, react will render anyway,
   * so atom.reportChanged() should not result in yet another re-render
   */

  setHiddenProp(this, skipRenderKey, false);
  /**
   * forceUpdate will re-assign this.props. We don't want that to cause a loop,
   * so detect these changes
   */

  setHiddenProp(this, isForcingUpdateKey, false); // wire up reactive render

  var baseRender = render.bind(this);
  var isRenderingPending = false;
  var reaction = new __WEBPACK_IMPORTED_MODULE_1_mobx__["b" /* Reaction */]("".concat(initialName, "#").concat(rootNodeID, ".render()"), function () {
    if (!isRenderingPending) {
      // N.B. Getting here *before mounting* means that a component constructor has side effects (see the relevant test in misc.js)
      // This unidiomatic React usage but React will correctly warn about this so we continue as usual
      // See #85 / Pull #44
      isRenderingPending = true;
      if (typeof _this2.componentWillReact === "function") _this2.componentWillReact(); // TODO: wrap in action?

      if (_this2[mobxIsUnmounted] !== true) {
        // If we are unmounted at this point, componentWillReact() had a side effect causing the component to unmounted
        // TODO: remove this check? Then react will properly warn about the fact that this should not happen? See #73
        // However, people also claim this migth happen during unit tests..
        var hasError = true;

        try {
          setHiddenProp(_this2, isForcingUpdateKey, true);
          if (!_this2[skipRenderKey]) __WEBPACK_IMPORTED_MODULE_0_react__["Component"].prototype.forceUpdate.call(_this2);
          hasError = false;
        } finally {
          setHiddenProp(_this2, isForcingUpdateKey, false);
          if (hasError) reaction.dispose();
        }
      }
    }
  });
  reaction.reactComponent = this;
  reactiveRender[mobxAdminProperty] = reaction;
  this.render = reactiveRender;
  return reactiveRender.call(this);
}
/**
 * ReactiveMixin
 */


var reactiveMixin = {
  componentWillUnmount: function componentWillUnmount() {
    if (isUsingStaticRendering === true) return;
    this.render[mobxAdminProperty] && this.render[mobxAdminProperty].dispose();
    this[mobxIsUnmounted] = true;

    if (isDevtoolsEnabled) {
      var node = findDOMNode$2(this);

      if (node && componentByNodeRegistry) {
        componentByNodeRegistry.delete(node);
      }

      renderReporter.emit({
        event: "destroy",
        component: this,
        node: node
      });
    }
  },
  componentDidMount: function componentDidMount() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    if (isDevtoolsEnabled) {
      reportRendering(this);
    }
  },
  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
    if (isUsingStaticRendering) {
      console.warn("[mobx-react] It seems that a re-rendering of a React component is triggered while in static (server-side) mode. Please make sure components are rendered only once server-side.");
    } // update on any state changes (as is the default)


    if (this.state !== nextState) {
      return true;
    } // update if props are shallowly not equal, inspired by PureRenderMixin
    // we could return just 'false' here, and avoid the `skipRender` checks etc
    // however, it is nicer if lifecycle events are triggered like usually,
    // so we return true here if props are shallowly modified.


    return !shallowEqual(this.props, nextProps);
  }
};

function makeObservableProp(target, propName) {
  var valueHolderKey = newSymbol("reactProp_".concat(propName, "_valueHolder"));
  var atomHolderKey = newSymbol("reactProp_".concat(propName, "_atomHolder"));

  function getAtom() {
    if (!this[atomHolderKey]) {
      setHiddenProp(this, atomHolderKey, Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["g" /* createAtom */])("reactive " + propName));
    }

    return this[atomHolderKey];
  }

  Object.defineProperty(target, propName, {
    configurable: true,
    enumerable: true,
    get: function get() {
      getAtom.call(this).reportObserved();
      return this[valueHolderKey];
    },
    set: function set(v) {
      if (!this[isForcingUpdateKey] && !shallowEqual(this[valueHolderKey], v)) {
        setHiddenProp(this, valueHolderKey, v);
        setHiddenProp(this, skipRenderKey, true);
        getAtom.call(this).reportChanged();
        setHiddenProp(this, skipRenderKey, false);
      } else {
        setHiddenProp(this, valueHolderKey, v);
      }
    }
  });
}
/**
 * Observer function / decorator
 */


function observer(arg1, arg2) {
  if (typeof arg1 === "string") {
    throw new Error("Store names should be provided as array");
  }

  if (Array.isArray(arg1)) {
    // TODO: remove in next major
    // component needs stores
    if (!warnedAboutObserverInjectDeprecation) {
      warnedAboutObserverInjectDeprecation = true;
      console.warn('Mobx observer: Using observer to inject stores is deprecated since 4.0. Use `@inject("store1", "store2") @observer ComponentClass` or `inject("store1", "store2")(observer(componentClass))` instead of `@observer(["store1", "store2"]) ComponentClass`');
    }

    if (!arg2) {
      // invoked as decorator
      return function (componentClass) {
        return observer(arg1, componentClass);
      };
    } else {
      return inject.apply(null, arg1)(observer(arg2));
    }
  }

  var componentClass = arg1;

  if (componentClass.isMobxInjector === true) {
    console.warn("Mobx observer: You are trying to use 'observer' on a component that already has 'inject'. Please apply 'observer' before applying 'inject'");
  }

  if (componentClass.__proto__ === __WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]) {
    console.warn("Mobx observer: You are using 'observer' on React.PureComponent. These two achieve two opposite goals and should not be used together");
  } // Stateless function component:
  // If it is function but doesn't seem to be a react class constructor,
  // wrap it to a react class automatically


  if (typeof componentClass === "function" && (!componentClass.prototype || !componentClass.prototype.render) && !componentClass.isReactClass && !__WEBPACK_IMPORTED_MODULE_0_react__["Component"].isPrototypeOf(componentClass)) {
    var _class, _temp;

    var observerComponent = observer((_temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          return componentClass.call(this, this.props, this.context);
        }
      }]);

      return _class;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = componentClass.displayName || componentClass.name, _class.contextTypes = componentClass.contextTypes, _class.propTypes = componentClass.propTypes, _class.defaultProps = componentClass.defaultProps, _temp));
    hoistNonReactStatics_cjs(observerComponent, componentClass);
    return observerComponent;
  }

  if (!componentClass) {
    throw new Error("Please pass a valid component to 'observer'");
  }

  var target = componentClass.prototype || componentClass;
  mixinLifecycleEvents(target);
  componentClass.isMobXReactObserver = true;
  makeObservableProp(target, "props");
  makeObservableProp(target, "state");
  var baseRender = target.render;

  target.render = function () {
    return makeComponentReactive.call(this, baseRender);
  };

  return componentClass;
}

function mixinLifecycleEvents(target) {
  ["componentDidMount", "componentWillUnmount", "componentDidUpdate"].forEach(function (funcName) {
    patch$1(target, funcName);
  });

  if (!target.shouldComponentUpdate) {
    target.shouldComponentUpdate = reactiveMixin.shouldComponentUpdate;
  } else {
    if (target.shouldComponentUpdate !== reactiveMixin.shouldComponentUpdate) {
      // TODO: make throw in next major
      console.warn("Use `shouldComponentUpdate` in an `observer` based component breaks the behavior of `observer` and might lead to unexpected results. Manually implementing `sCU` should not be needed when using mobx-react.");
    }
  }
}

var Observer = observer(function (_ref) {
  var children = _ref.children,
      observerInject = _ref.inject,
      render = _ref.render;
  var component = children || render;

  if (typeof component === "undefined") {
    return null;
  }

  if (!observerInject) {
    return component();
  } // TODO: remove in next major


  console.warn("<Observer inject=.../> is no longer supported. Please use inject on the enclosing component instead");
  var InjectComponent = inject(observerInject)(component);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InjectComponent, null);
});
Observer.displayName = "Observer";

var ObserverPropsCheck = function ObserverPropsCheck(props, key, componentName, location, propFullName) {
  var extraKey = key === "children" ? "render" : "children";

  if (typeof props[key] === "function" && typeof props[extraKey] === "function") {
    return new Error("Invalid prop,do not use children and render in the same time in`" + componentName);
  }

  if (typeof props[key] === "function" || typeof props[extraKey] === "function") {
    return;
  }

  return new Error("Invalid prop `" + propFullName + "` of type `" + _typeof(props[key]) + "` supplied to" + " `" + componentName + "`, expected `function`.");
};

Observer.propTypes = {
  render: ObserverPropsCheck,
  children: ObserverPropsCheck
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component$$1) {
  var prototype = Component$$1.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component$$1.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component$$1;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component$$1.displayName || Component$$1.name;
    var newApiName =
      typeof Component$$1.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component$$1.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component$$1;
}

var specialReactKeys = {
  children: true,
  key: true,
  ref: true
};

var Provider =
/*#__PURE__*/
function (_Component) {
  _inherits(Provider, _Component);

  function Provider(props, context) {
    var _this;

    _classCallCheck(this, Provider);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Provider).call(this, props, context));
    _this.state = {};
    copyStores(props, _this.state);
    return _this;
  }

  _createClass(Provider, [{
    key: "render",
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    }
  }, {
    key: "getChildContext",
    value: function getChildContext() {
      var stores = {}; // inherit stores

      copyStores(this.context.mobxStores, stores); // add own stores

      copyStores(this.props, stores);
      return {
        mobxStores: stores
      };
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (!nextProps) return null;
      if (!prevState) return nextProps; // Maybe this warning is too aggressive?

      if (Object.keys(nextProps).filter(validStoreName).length !== Object.keys(prevState).filter(validStoreName).length) console.warn("MobX Provider: The set of provided stores has changed. Please avoid changing stores as the change might not propagate to all children");
      if (!nextProps.suppressChangedStoreWarning) for (var key in nextProps) {
        if (validStoreName(key) && prevState[key] !== nextProps[key]) console.warn("MobX Provider: Provided store '" + key + "' has changed. Please avoid replacing stores as the change might not propagate to all children");
      }
      return nextProps;
    }
  }]);

  return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Provider.contextTypes = {
  mobxStores: objectOrObservableObject
};
Provider.childContextTypes = {
  mobxStores: objectOrObservableObject.isRequired
};

function copyStores(from, to) {
  if (!from) return;

  for (var key in from) {
    if (validStoreName(key)) to[key] = from[key];
  }
}

function validStoreName(key) {
  return !specialReactKeys[key] && key !== "suppressChangedStoreWarning";
} // TODO: kill in next major


polyfill(Provider);

var storeKey = newSymbol("disposeOnUnmount");

function runDisposersOnWillUnmount() {
  var _this = this;

  if (!this[storeKey]) {
    // when disposeOnUnmount is only set to some instances of a component it will still patch the prototype
    return;
  }

  this[storeKey].forEach(function (propKeyOrFunction) {
    var prop = typeof propKeyOrFunction === "string" ? _this[propKeyOrFunction] : propKeyOrFunction;

    if (prop !== undefined && prop !== null) {
      if (typeof prop !== "function") {
        throw new Error("[mobx-react] disposeOnUnmount only works on functions such as disposers returned by reactions, autorun, etc.");
      }

      prop();
    }
  });
  this[storeKey] = [];
}

function disposeOnUnmount(target, propertyKeyOrFunction) {
  if (Array.isArray(propertyKeyOrFunction)) {
    return propertyKeyOrFunction.map(function (fn) {
      return disposeOnUnmount(target, fn);
    });
  }

  if (!target instanceof __WEBPACK_IMPORTED_MODULE_0_react__["Component"]) {
    throw new Error("[mobx-react] disposeOnUnmount only works on class based React components.");
  }

  if (typeof propertyKeyOrFunction !== "string" && typeof propertyKeyOrFunction !== "function") {
    throw new Error("[mobx-react] disposeOnUnmount only works if the parameter is either a property key or a function.");
  } // add property key / function we want run (disposed) to the store


  var componentWasAlreadyModified = !!target[storeKey];
  var store = target[storeKey] || (target[storeKey] = []);
  store.push(propertyKeyOrFunction); // tweak the component class componentWillUnmount if not done already

  if (!componentWasAlreadyModified) {
    patch(target, "componentWillUnmount", runDisposersOnWillUnmount);
  } // return the disposer as is if invoked as a non decorator


  if (typeof propertyKeyOrFunction !== "string") {
    return propertyKeyOrFunction;
  }
}

if (!__WEBPACK_IMPORTED_MODULE_0_react__["Component"]) throw new Error("mobx-react requires React to be available");
if (!__WEBPACK_IMPORTED_MODULE_1_mobx__["n" /* spy */]) throw new Error("mobx-react requires mobx to be available");
if (typeof __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"] === "function") Object(__WEBPACK_IMPORTED_MODULE_1_mobx__["f" /* configure */])({
  reactionScheduler: __WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"]
});
var onError = function onError(fn) {
  return errorsReporter.on(fn);
};

if ((typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "undefined" ? "undefined" : _typeof(__MOBX_DEVTOOLS_GLOBAL_HOOK__)) === "object") {
  var mobx = {
    spy: __WEBPACK_IMPORTED_MODULE_1_mobx__["n" /* spy */],
    extras: {
      getDebugName: __WEBPACK_IMPORTED_MODULE_1_mobx__["h" /* getDebugName */]
    }
  };
  var mobxReact = {
    renderReporter: renderReporter,
    componentByNodeRegistry: componentByNodeRegistry,
    componentByNodeRegistery: componentByNodeRegistry,
    trackComponents: trackComponents
  };

  __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobxReact(mobxReact, mobx);
}




/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var inputKey={clear:"clear",clearList:"clearList",clearInput:"clearInput",open:"open",search:"search"//
,baidu:"baidu"//
,ecosia:"ecosia",google:"google",yahoo:"yahoo",bing:"bing",qihu:"qihu",sougou:"sougou",soso:"soso",video:"video"//
,youku:"youku"//
,qqVideo:"qqVideo",iqiyi:"iqiyi",bilibili:"bilibili",mgtv:"mgtv",sohutv:"sohutv",le:"le",acfun:"acfun",tudou:"tudou",nico:"nico",youtube:"youtube",music:"music",qqmusic:"qqmusic",xiamimusic:"xiamimusic",netmusic:"netmusic",kugoumusic:"kugoumusic",youtubemusic:"youtubemusic",baidumusic:"baidumusic",mv:"mv",yinyuetai:"yinyuetai",qqmusicmv:"qqmusicmv",play:"play",playQQMusic:"playQQMusic",playMv:"playMv",playQQMusicMv:"playQQMusicMv",question:"question",zhihu:"zhihu",baiduzhidao:"baiduzhidao",wiki:"wiki",sougoubaike:"sougoubaike",baidubaike:"baidubaike",hudongbaike:"hudongbaike",qihubaike:"qihubaike",wikibaike:"wikibaike",baidubaikeSearch:"baidubaikeSearch",news:"news",baiduxinwen:"baiduxinwen",qqxinwen:"qqxinwen",sohuxinwen:"sohuxinwen",sinaxinwen:"sinaxinwen",buy:"buy",taobao:"taobao",tmall:"tmall",jd:"jd",amazon:"amazon",amazoncn:"amazoncn",code:"code",github:"github",oschina:"oschina",segmentfault:"segmentfault",stackoverflow:"stackoverflow",download:"download"//?
,airticket:"airticket",ctripairticket:"ctripairticket",feizhuairticket:"feizhuairticket",trainticket:"trainticket",ctriptrainticket:"ctriptrainticket",feizhutrainticket:"feizhutrainticket",link:"link",fanyi:"fanyi",jisuanqi:"jisuanqi",note:"note",table:"table",ppt:"ppt",mindmap:"mindmap",express:"express",qq:"qq",hao123:"hao123",sohu:"sohu",sina:"sina",googletranslate:"googletranslate",baiduwenku:"baiduwenku",baiduwangpan:"baiduwangpan",yaoyaowu:"yaoyaowu",xinhuawang:"xinhuawang",sinablog:"sinablog",renminribao:"renminribao",gmw:"gmw",tianya:"tianya",youth:"youth",china:"china",cctv:"cctv",alipay:"alipay",babytree:"babytree",huanqiu:"huanqiu",csdn:"csdn",mamawang:"mamawang",zol:"zol",net163:"net163",douyu:"douyu",bitauto:"bitauto",douban:"douban",caijing:"caijing",yesky:"yesky",dianying1905:"dianying1905",cnnic:"cnnic",cnblogs:"cnblogs",zhongguoribao:"zhongguoribao",alibaba:"alibaba",apple:"apple",facebook:"facebook",microsoft:"microsoft",dongfangwang:"dongfangwang",chaoshitmall:"chaoshitmall",youdaonote:"youdaonote",hongwang:"hongwang",instagram:"instagram",aliyun:"aliyun",chinaz:"chinaz",huaban:"huaban",ifeng:"ifeng",linkedin:"linkedin",suning:"suning",cnmo:"cnmo",zhanqi:"zhanqi",k618:"k618",wuba:"wuba",stockstar:"stockstar",jb51:"jb51",pk52:"pk52",toutiao:"toutiao",xunlei:"xunlei",bbc:"bbc",twitter:"twitter",ebay:"ebay",tumblr:"tumblr",mi:"mi",zhaopin:"zhaopin",ly:"ly",jia:"jia",adobe:"adobe",hupu:"hupu",jianshu:"jianshu",mail126:"mail126",mail163:"mail163",sisanjiujiu:"sisanjiujiu",dianping:"dianping",sandm:"sandm",gamersky:"gamersky",duba:"duba",panda:"panda",steampowered:"steampowered",to8to:"to8to",feng:"feng",ngacn:"ngacn",yaoqiyaoqisan:"yaoqiyaoqisan",wordpress:"wordpress",cto51:"cto51",smzdm:"smzdm",w3school:"w3school",w3schools:"w3schools",renren:"renren",v2ex:"v2ex",runoob:"runoob",paypal:"paypal",tieba:"tieba",gome:"gome",autohome:"autohome",fang:"fang",ctrip:"ctrip",yaoersanlingliu:"yaoersanlingliu",guazi:"guazi",qunar:"qunar",booking:"booking",tuniu:"tuniu",mafengwo:"mafengwo",feizhu:"feizhu",qidian:"qidian",jinjiang:"jinjiang",pconline:"pconline",ithome:"ithome",zealer:"zealer",huya:"huya",longzhu:"longzhu",ganji:"ganji",baixing:"baixing",beike:"beike",lianjia:"lianjia",woaiwojia:"woaiwojia",meituan:"meituan",huajun:"huajun",qianchengwuyou:"qianchengwuyou",lagou:"lagou",mailqq:"mailqq",mailsina:"mailsina",xiachufang:"xiachufang",qiushibaike:"qiushibaike",tianyancha:"tianyancha",netstudy:"netstudy",imooc:"imooc",qqweb:"qqweb",weixinweb:"weixinweb",tencentcloud:"tencentcloud",aws:"aws",azure:"azure",googlecloud:"googlecloud",anjuke:"anjuke",bcy:"bcy",guoguo:"guoguo",dianxin:"dianxin",yidong:"yidong",liantong:"liantong",gaode:"gaode",baidumap:"baidumap",tencentmap:"tencentmap",googlemap:"googlemap",didi:"didi",eleme:"eleme",meituanwaimai:"meituanwaimai",koubei:"koubei",gmail:"gmail",baidutranslate:"baidutranslate",youdaotranslate:"youdaotranslate",ximalaya:"ximalaya",weibo:"weibo",guoke:"guoke",tencentstudy:"tencentstudy"};/* harmony default export */ __webpack_exports__["a"] = (inputKey);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Reaction$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return untracked$$1; });
/* unused harmony export IDerivationState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createAtom$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return spy$$1; });
/* unused harmony export comparer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isObservableObject$$1; });
/* unused harmony export isBoxedObservable */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isObservableArray$$1; });
/* unused harmony export ObservableMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isObservableMap$$1; });
/* unused harmony export transaction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return observable$$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return computed$$1; });
/* unused harmony export isObservable */
/* unused harmony export isObservableProp */
/* unused harmony export isComputed */
/* unused harmony export isComputedProp */
/* unused harmony export extendObservable */
/* unused harmony export observe */
/* unused harmony export intercept */
/* unused harmony export autorun */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return reaction$$1; });
/* unused harmony export when */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return action$$1; });
/* unused harmony export isAction */
/* unused harmony export runInAction */
/* unused harmony export keys */
/* unused harmony export values */
/* unused harmony export entries */
/* unused harmony export set */
/* unused harmony export remove */
/* unused harmony export has */
/* unused harmony export get */
/* unused harmony export decorate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return configure$$1; });
/* unused harmony export onBecomeObserved */
/* unused harmony export onBecomeUnobserved */
/* unused harmony export flow */
/* unused harmony export toJS */
/* unused harmony export trace */
/* unused harmony export getDependencyTree */
/* unused harmony export getObserverTree */
/* unused harmony export _resetGlobalState */
/* unused harmony export _getGlobalState */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getDebugName$$1; });
/* unused harmony export getAtom */
/* unused harmony export _getAdministration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return allowStateChanges$$1; });
/* unused harmony export _allowStateChangesInsideComputed */
/* unused harmony export isArrayLike */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return $mobx$$1; });
/* unused harmony export _isComputingDerivation */
/* unused harmony export onReactionError */
/* unused harmony export _interceptReads */
/** MobX - (c) Michel Weststrate 2015 - 2018 - MIT Licensed */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};















function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var OBFUSCATED_ERROR$$1 = "An invariant failed, however the error is obfuscated because this is an production build.";
var EMPTY_ARRAY$$1 = [];
Object.freeze(EMPTY_ARRAY$$1);
var EMPTY_OBJECT$$1 = {};
Object.freeze(EMPTY_OBJECT$$1);
function getNextId$$1() {
    return ++globalState$$1.mobxGuid;
}
function fail$$1(message) {
    invariant$$1(false, message);
    throw "X"; // unreachable
}
function invariant$$1(check, message) {
    if (!check)
        throw new Error("[mobx] " + (message || OBFUSCATED_ERROR$$1));
}
/**
 * Prints a deprecation message, but only one time.
 * Returns false if the deprecated message was already printed before
 */
var deprecatedMessages = [];
function deprecated$$1(msg, thing) {
    if (true)
        return false;
    if (thing) {
        return deprecated$$1("'" + msg + "', use '" + thing + "' instead.");
    }
    if (deprecatedMessages.indexOf(msg) !== -1)
        return false;
    deprecatedMessages.push(msg);
    console.error("[mobx] Deprecated: " + msg);
    return true;
}
/**
 * Makes sure that the provided function is invoked at most once.
 */
function once$$1(func) {
    var invoked = false;
    return function () {
        if (invoked)
            return;
        invoked = true;
        return func.apply(this, arguments);
    };
}
var noop$$1 = function () { };
function unique$$1(list) {
    var res = [];
    list.forEach(function (item) {
        if (res.indexOf(item) === -1)
            res.push(item);
    });
    return res;
}
function isObject$$1(value) {
    return value !== null && typeof value === "object";
}
function isPlainObject$$1(value) {
    if (value === null || typeof value !== "object")
        return false;
    var proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
}

function addHiddenProp$$1(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: true,
        configurable: true,
        value: value
    });
}
function addHiddenFinalProp$$1(object, propName, value) {
    Object.defineProperty(object, propName, {
        enumerable: false,
        writable: false,
        configurable: true,
        value: value
    });
}
function isPropertyConfigurable$$1(object, prop) {
    var descriptor = Object.getOwnPropertyDescriptor(object, prop);
    return !descriptor || (descriptor.configurable !== false && descriptor.writable !== false);
}
function assertPropertyConfigurable$$1(object, prop) {
    if (false)
        fail$$1("Cannot make property '" + prop.toString() + "' observable, it is not configurable and writable in the target object");
}
function createInstanceofPredicate$$1(name, clazz) {
    var propName = "isMobX" + name;
    clazz.prototype[propName] = true;
    return function (x) {
        return isObject$$1(x) && x[propName] === true;
    };
}
/**
 * Returns whether the argument is an array, disregarding observability.
 */
function isArrayLike$$1(x) {
    return Array.isArray(x) || isObservableArray$$1(x);
}
function isES6Map$$1(thing) {
    return thing instanceof Map;
}
function getMapLikeKeys$$1(map) {
    if (isPlainObject$$1(map))
        return Object.keys(map);
    if (Array.isArray(map))
        return map.map(function (_a) {
            var _b = __read(_a, 1), key = _b[0];
            return key;
        });
    if (isES6Map$$1(map) || isObservableMap$$1(map))
        return Array.from(map.keys());
    return fail$$1("Cannot get keys from '" + map + "'");
}
function toPrimitive$$1(value) {
    return value === null ? null : typeof value === "object" ? "" + value : value;
}

var $mobx$$1 = Symbol("mobx administration");
var Atom$$1 = /** @class */ (function () {
    /**
     * Create a new atom. For debugging purposes it is recommended to give it a name.
     * The onBecomeObserved and onBecomeUnobserved callbacks can be used for resource management.
     */
    function Atom$$1(name) {
        if (name === void 0) { name = "Atom@" + getNextId$$1(); }
        this.name = name;
        this.isPendingUnobservation = false; // for effective unobserving. BaseAtom has true, for extra optimization, so its onBecomeUnobserved never gets called, because it's not needed
        this.isBeingObserved = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.NOT_TRACKING;
    }
    Atom$$1.prototype.onBecomeUnobserved = function () {
        // noop
    };
    Atom$$1.prototype.onBecomeObserved = function () {
        /* noop */
    };
    /**
     * Invoke this method to notify mobx that your atom has been used somehow.
     * Returns true if there is currently a reactive context.
     */
    Atom$$1.prototype.reportObserved = function () {
        return reportObserved$$1(this);
    };
    /**
     * Invoke this method _after_ this method has changed to signal mobx that all its observers should invalidate.
     */
    Atom$$1.prototype.reportChanged = function () {
        startBatch$$1();
        propagateChanged$$1(this);
        endBatch$$1();
    };
    Atom$$1.prototype.toString = function () {
        return this.name;
    };
    return Atom$$1;
}());
var isAtom$$1 = createInstanceofPredicate$$1("Atom", Atom$$1);
function createAtom$$1(name, onBecomeObservedHandler, onBecomeUnobservedHandler) {
    if (onBecomeObservedHandler === void 0) { onBecomeObservedHandler = noop$$1; }
    if (onBecomeUnobservedHandler === void 0) { onBecomeUnobservedHandler = noop$$1; }
    var atom = new Atom$$1(name);
    onBecomeObserved$$1(atom, onBecomeObservedHandler);
    onBecomeUnobserved$$1(atom, onBecomeUnobservedHandler);
    return atom;
}

function identityComparer(a, b) {
    return a === b;
}
function structuralComparer(a, b) {
    return deepEqual$$1(a, b);
}
function defaultComparer(a, b) {
    return Object.is(a, b);
}
var comparer$$1 = {
    identity: identityComparer,
    structural: structuralComparer,
    default: defaultComparer
};

var mobxDidRunLazyInitializersSymbol$$1 = Symbol("mobx did run lazy initializers");
var mobxPendingDecorators$$1 = Symbol("mobx pending decorators");
var enumerableDescriptorCache = {};
var nonEnumerableDescriptorCache = {};
function createPropertyInitializerDescriptor(prop, enumerable) {
    var cache = enumerable ? enumerableDescriptorCache : nonEnumerableDescriptorCache;
    return (cache[prop] ||
        (cache[prop] = {
            configurable: true,
            enumerable: enumerable,
            get: function () {
                initializeInstance$$1(this);
                return this[prop];
            },
            set: function (value) {
                initializeInstance$$1(this);
                this[prop] = value;
            }
        }));
}
function initializeInstance$$1(target) {
    if (target[mobxDidRunLazyInitializersSymbol$$1] === true)
        return;
    var decorators = target[mobxPendingDecorators$$1];
    if (decorators) {
        addHiddenProp$$1(target, mobxDidRunLazyInitializersSymbol$$1, true);
        for (var key in decorators) {
            var d = decorators[key];
            d.propertyCreator(target, d.prop, d.descriptor, d.decoratorTarget, d.decoratorArguments);
        }
    }
}
function createPropDecorator$$1(propertyInitiallyEnumerable, propertyCreator) {
    return function decoratorFactory() {
        var decoratorArguments;
        var decorator = function decorate$$1(target, prop, descriptor, applyImmediately
        // This is a special parameter to signal the direct application of a decorator, allow extendObservable to skip the entire type decoration part,
        // as the instance to apply the decorator to equals the target
        ) {
            if (applyImmediately === true) {
                propertyCreator(target, prop, descriptor, target, decoratorArguments);
                return null;
            }
            if (false)
                fail$$1("This function is a decorator, but it wasn't invoked like a decorator");
            if (!Object.prototype.hasOwnProperty.call(target, mobxPendingDecorators$$1)) {
                var inheritedDecorators = target[mobxPendingDecorators$$1];
                addHiddenProp$$1(target, mobxPendingDecorators$$1, __assign({}, inheritedDecorators));
            }
            target[mobxPendingDecorators$$1][prop] = {
                prop: prop,
                propertyCreator: propertyCreator,
                descriptor: descriptor,
                decoratorTarget: target,
                decoratorArguments: decoratorArguments
            };
            return createPropertyInitializerDescriptor(prop, propertyInitiallyEnumerable);
        };
        if (quacksLikeADecorator$$1(arguments)) {
            // @decorator
            decoratorArguments = EMPTY_ARRAY$$1;
            return decorator.apply(null, arguments);
        }
        else {
            // @decorator(args)
            decoratorArguments = Array.prototype.slice.call(arguments);
            return decorator;
        }
    };
}
function quacksLikeADecorator$$1(args) {
    return (((args.length === 2 || args.length === 3) && typeof args[1] === "string") ||
        (args.length === 4 && args[3] === true));
}

function deepEnhancer$$1(v, _, name) {
    // it is an observable already, done
    if (isObservable$$1(v))
        return v;
    // something that can be converted and mutated?
    if (Array.isArray(v))
        return observable$$1.array(v, { name: name });
    if (isPlainObject$$1(v))
        return observable$$1.object(v, undefined, { name: name });
    if (isES6Map$$1(v))
        return observable$$1.map(v, { name: name });
    return v;
}
function shallowEnhancer$$1(v, _, name) {
    if (v === undefined || v === null)
        return v;
    if (isObservableObject$$1(v) || isObservableArray$$1(v) || isObservableMap$$1(v))
        return v;
    if (Array.isArray(v))
        return observable$$1.array(v, { name: name, deep: false });
    if (isPlainObject$$1(v))
        return observable$$1.object(v, undefined, { name: name, deep: false });
    if (isES6Map$$1(v))
        return observable$$1.map(v, { name: name, deep: false });
    return fail$$1("production" !== "production" &&
        "The shallow modifier / decorator can only used in combination with arrays, objects and maps");
}
function referenceEnhancer$$1(newValue) {
    // never turn into an observable
    return newValue;
}
function refStructEnhancer$$1(v, oldValue, name) {
    if (false)
        throw "observable.struct should not be used with observable values";
    if (deepEqual$$1(v, oldValue))
        return oldValue;
    return v;
}

function createDecoratorForEnhancer$$1(enhancer) {
    invariant$$1(enhancer);
    var decorator = createPropDecorator$$1(true, function (target, propertyName, descriptor, _decoratorTarget, decoratorArgs) {
        if (false) {
            invariant$$1(!descriptor || !descriptor.get, "@observable cannot be used on getter (property \"" + propertyName + "\"), use @computed instead.");
        }
        var initialValue = descriptor
            ? descriptor.initializer
                ? descriptor.initializer.call(target)
                : descriptor.value
            : undefined;
        asObservableObject$$1(target).addObservableProp(propertyName, initialValue, enhancer);
    });
    var res = 
    // Extra process checks, as this happens during module initialization
    typeof process !== "undefined" && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_BABEL_STAGE_0":"true;","REACT_APP_CSS_MODULES":"true;","REACT_APP_DECORATORS":"true;","REACT_APP_LESS":"true;","REACT_APP_LESS_MODULES":"true;","REACT_APP_SASS":"true;","REACT_APP_SASS_MODULES":"true;","REACT_APP_STYLUS":"true;","REACT_APP_STYLUS_MODULES":"true;","REACT_APP_WEBPACK_DASHBOARD":"true;"}) && "production" !== "production"
        ? function observableDecorator() {
            // This wrapper function is just to detect illegal decorator invocations, deprecate in a next version
            // and simply return the created prop decorator
            if (arguments.length < 2)
                return fail$$1("Incorrect decorator invocation. @observable decorator doesn't expect any arguments");
            return decorator.apply(null, arguments);
        }
        : decorator;
    res.enhancer = enhancer;
    return res;
}

// Predefined bags of create observable options, to avoid allocating temporarily option objects
// in the majority of cases
var defaultCreateObservableOptions$$1 = {
    deep: true,
    name: undefined,
    defaultDecorator: undefined,
    proxy: true
};
Object.freeze(defaultCreateObservableOptions$$1);
function assertValidOption(key) {
    if (!/^(deep|name|defaultDecorator|proxy)$/.test(key))
        fail$$1("invalid option for (extend)observable: " + key);
}
function asCreateObservableOptions$$1(thing) {
    if (thing === null || thing === undefined)
        return defaultCreateObservableOptions$$1;
    if (typeof thing === "string")
        return { name: thing, deep: true, proxy: true };
    if (false) {
        if (typeof thing !== "object")
            return fail$$1("expected options object");
        Object.keys(thing).forEach(assertValidOption);
    }
    return thing;
}
var deepDecorator$$1 = createDecoratorForEnhancer$$1(deepEnhancer$$1);
var shallowDecorator = createDecoratorForEnhancer$$1(shallowEnhancer$$1);
var refDecorator$$1 = createDecoratorForEnhancer$$1(referenceEnhancer$$1);
var refStructDecorator = createDecoratorForEnhancer$$1(refStructEnhancer$$1);
function getEnhancerFromOptions(options) {
    return options.defaultDecorator
        ? options.defaultDecorator.enhancer
        : options.deep === false
            ? referenceEnhancer$$1
            : deepEnhancer$$1;
}
/**
 * Turns an object, array or function into a reactive structure.
 * @param v the value which should become observable.
 */
function createObservable(v, arg2, arg3) {
    // @observable someProp;
    if (typeof arguments[1] === "string") {
        return deepDecorator$$1.apply(null, arguments);
    }
    // it is an observable already, done
    if (isObservable$$1(v))
        return v;
    // something that can be converted and mutated?
    var res = isPlainObject$$1(v)
        ? observable$$1.object(v, arg2, arg3)
        : Array.isArray(v)
            ? observable$$1.array(v, arg2)
            : isES6Map$$1(v)
                ? observable$$1.map(v, arg2)
                : v;
    // this value could be converted to a new observable data structure, return it
    if (res !== v)
        return res;
    // otherwise, just box it
    fail$$1("production" !== "production" &&
        "The provided value could not be converted into an observable. If you want just create an observable reference to the object use 'observable.box(value)'");
}
var observableFactories = {
    box: function (value, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("box");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableValue$$1(value, getEnhancerFromOptions(o), o.name);
    },
    array: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("array");
        var o = asCreateObservableOptions$$1(options);
        return createObservableArray$$1(initialValues, getEnhancerFromOptions(o), o.name);
    },
    map: function (initialValues, options) {
        if (arguments.length > 2)
            incorrectlyUsedAsDecorator("map");
        var o = asCreateObservableOptions$$1(options);
        return new ObservableMap$$1(initialValues, getEnhancerFromOptions(o), o.name);
    },
    object: function (props, decorators, options) {
        if (typeof arguments[1] === "string")
            incorrectlyUsedAsDecorator("object");
        var o = asCreateObservableOptions$$1(options);
        if (o.proxy === false) {
            return extendObservable$$1({}, props, decorators, o);
        }
        else {
            var defaultDecorator = getDefaultDecoratorFromObjectOptions$$1(o);
            var base = extendObservable$$1({}, undefined, undefined, o);
            var proxy = createDynamicObservableObject$$1(base);
            extendObservableObjectWithProperties$$1(proxy, props, decorators, defaultDecorator);
            return proxy;
        }
    },
    ref: refDecorator$$1,
    shallow: shallowDecorator,
    deep: deepDecorator$$1,
    struct: refStructDecorator
};
var observable$$1 = createObservable;
// weird trick to keep our typings nicely with our funcs, and still extend the observable function
Object.keys(observableFactories).forEach(function (name) { return (observable$$1[name] = observableFactories[name]); });
function incorrectlyUsedAsDecorator(methodName) {
    fail$$1(
    // process.env.NODE_ENV !== "production" &&
    "Expected one or two arguments to observable." + methodName + ". Did you accidentally try to use observable." + methodName + " as decorator?");
}

var computedDecorator$$1 = createPropDecorator$$1(false, function (instance, propertyName, descriptor, decoratorTarget, decoratorArgs) {
    var get$$1 = descriptor.get, set$$1 = descriptor.set; // initialValue is the descriptor for get / set props
    // Optimization: faster on decorator target or instance? Assuming target
    // Optimization: find out if declaring on instance isn't just faster. (also makes the property descriptor simpler). But, more memory usage..
    var options = decoratorArgs[0] || {};
    asObservableObject$$1(instance).addComputedProp(decoratorTarget, propertyName, __assign({ get: get$$1,
        set: set$$1, context: instance }, options));
});
var computedStructDecorator = computedDecorator$$1({ equals: comparer$$1.structural });
/**
 * Decorator for class properties: @computed get value() { return expr; }.
 * For legacy purposes also invokable as ES5 observable created: `computed(() => expr)`;
 */
var computed$$1 = function computed$$1(arg1, arg2, arg3) {
    if (typeof arg2 === "string") {
        // @computed
        return computedDecorator$$1.apply(null, arguments);
    }
    if (arg1 !== null && typeof arg1 === "object" && arguments.length === 1) {
        // @computed({ options })
        return computedDecorator$$1.apply(null, arguments);
    }
    // computed(expr, options?)
    if (false) {
        invariant$$1(typeof arg1 === "function", "First argument to `computed` should be an expression.");
        invariant$$1(arguments.length < 3, "Computed takes one or two arguments if used as function");
    }
    var opts = typeof arg2 === "object" ? arg2 : {};
    opts.get = arg1;
    opts.set = typeof arg2 === "function" ? arg2 : opts.set;
    opts.name = opts.name || arg1.name || ""; /* for generated name */
    return new ComputedValue$$1(opts);
};
computed$$1.struct = computedStructDecorator;

function createAction$$1(actionName, fn) {
    if (false) {
        invariant$$1(typeof fn === "function", "`action` can only be invoked on functions");
        if (typeof actionName !== "string" || !actionName)
            fail$$1("actions should have valid names, got: '" + actionName + "'");
    }
    var res = function () {
        return executeAction$$1(actionName, fn, this, arguments);
    };
    res.isMobxAction = true;
    return res;
}
function executeAction$$1(actionName, fn, scope, args) {
    var runInfo = startAction(actionName, fn, scope, args);
    try {
        return fn.apply(scope, args);
    }
    finally {
        endAction(runInfo);
    }
}
function startAction(actionName, fn, scope, args) {
    var notifySpy = isSpyEnabled$$1() && !!actionName;
    var startTime = 0;
    if (notifySpy && "production" !== "production") {
        startTime = Date.now();
        var l = (args && args.length) || 0;
        var flattendArgs = new Array(l);
        if (l > 0)
            for (var i = 0; i < l; i++)
                flattendArgs[i] = args[i];
        spyReportStart$$1({
            type: "action",
            name: actionName,
            object: scope,
            arguments: flattendArgs
        });
    }
    var prevDerivation = untrackedStart$$1();
    startBatch$$1();
    var prevAllowStateChanges = allowStateChangesStart$$1(true);
    return {
        prevDerivation: prevDerivation,
        prevAllowStateChanges: prevAllowStateChanges,
        notifySpy: notifySpy,
        startTime: startTime
    };
}
function endAction(runInfo) {
    allowStateChangesEnd$$1(runInfo.prevAllowStateChanges);
    endBatch$$1();
    untrackedEnd$$1(runInfo.prevDerivation);
    if (runInfo.notifySpy && "production" !== "production")
        spyReportEnd$$1({ time: Date.now() - runInfo.startTime });
}
function allowStateChanges$$1(allowStateChanges$$1, func) {
    var prev = allowStateChangesStart$$1(allowStateChanges$$1);
    var res;
    try {
        res = func();
    }
    finally {
        allowStateChangesEnd$$1(prev);
    }
    return res;
}
function allowStateChangesStart$$1(allowStateChanges$$1) {
    var prev = globalState$$1.allowStateChanges;
    globalState$$1.allowStateChanges = allowStateChanges$$1;
    return prev;
}
function allowStateChangesEnd$$1(prev) {
    globalState$$1.allowStateChanges = prev;
}
function allowStateChangesInsideComputed$$1(func) {
    var prev = globalState$$1.computationDepth;
    globalState$$1.computationDepth = 0;
    var res;
    try {
        res = func();
    }
    finally {
        globalState$$1.computationDepth = prev;
    }
    return res;
}

var UNCHANGED$$1 = {};
var ObservableValue$$1 = /** @class */ (function (_super) {
    __extends(ObservableValue$$1, _super);
    function ObservableValue$$1(value, enhancer, name, notifySpy) {
        if (name === void 0) { name = "ObservableValue@" + getNextId$$1(); }
        if (notifySpy === void 0) { notifySpy = true; }
        var _this = _super.call(this, name) || this;
        _this.enhancer = enhancer;
        _this.hasUnreportedChange = false;
        _this.value = enhancer(value, undefined, name);
        if (notifySpy && isSpyEnabled$$1() && "production" !== "production") {
            // only notify spy if this is a stand-alone observable
            spyReport$$1({ type: "create", name: _this.name, newValue: "" + _this.value });
        }
        return _this;
    }
    ObservableValue$$1.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableValue$$1.prototype.set = function (newValue) {
        var oldValue = this.value;
        newValue = this.prepareNewValue(newValue);
        if (newValue !== UNCHANGED$$1) {
            var notifySpy = isSpyEnabled$$1();
            if (notifySpy && "production" !== "production") {
                spyReportStart$$1({
                    type: "update",
                    name: this.name,
                    newValue: newValue,
                    oldValue: oldValue
                });
            }
            this.setNewValue(newValue);
            if (notifySpy && "production" !== "production")
                spyReportEnd$$1();
        }
    };
    ObservableValue$$1.prototype.prepareNewValue = function (newValue) {
        checkIfStateModificationsAreAllowed$$1(this);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this,
                type: "update",
                newValue: newValue
            });
            if (!change)
                return UNCHANGED$$1;
            newValue = change.newValue;
        }
        // apply modifier
        newValue = this.enhancer(newValue, this.value, this.name);
        return this.value !== newValue ? newValue : UNCHANGED$$1;
    };
    ObservableValue$$1.prototype.setNewValue = function (newValue) {
        var oldValue = this.value;
        this.value = newValue;
        this.reportChanged();
        if (hasListeners$$1(this)) {
            notifyListeners$$1(this, {
                type: "update",
                object: this,
                newValue: newValue,
                oldValue: oldValue
            });
        }
    };
    ObservableValue$$1.prototype.get = function () {
        this.reportObserved();
        return this.dehanceValue(this.value);
    };
    ObservableValue$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableValue$$1.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately)
            listener({
                object: this,
                type: "update",
                newValue: this.value,
                oldValue: undefined
            });
        return registerListener$$1(this, listener);
    };
    ObservableValue$$1.prototype.toJSON = function () {
        return this.get();
    };
    ObservableValue$$1.prototype.toString = function () {
        return this.name + "[" + this.value + "]";
    };
    ObservableValue$$1.prototype.valueOf = function () {
        return toPrimitive$$1(this.get());
    };
    ObservableValue$$1.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ObservableValue$$1;
}(Atom$$1));
var isObservableValue$$1 = createInstanceofPredicate$$1("ObservableValue", ObservableValue$$1);

/**
 * A node in the state dependency root that observes other nodes, and can be observed itself.
 *
 * ComputedValue will remember the result of the computation for the duration of the batch, or
 * while being observed.
 *
 * During this time it will recompute only when one of its direct dependencies changed,
 * but only when it is being accessed with `ComputedValue.get()`.
 *
 * Implementation description:
 * 1. First time it's being accessed it will compute and remember result
 *    give back remembered result until 2. happens
 * 2. First time any deep dependency change, propagate POSSIBLY_STALE to all observers, wait for 3.
 * 3. When it's being accessed, recompute if any shallow dependency changed.
 *    if result changed: propagate STALE to all observers, that were POSSIBLY_STALE from the last step.
 *    go to step 2. either way
 *
 * If at any point it's outside batch and it isn't observed: reset everything and go to 1.
 */
var ComputedValue$$1 = /** @class */ (function () {
    /**
     * Create a new computed value based on a function expression.
     *
     * The `name` property is for debug purposes only.
     *
     * The `equals` property specifies the comparer function to use to determine if a newly produced
     * value differs from the previous value. Two comparers are provided in the library; `defaultComparer`
     * compares based on identity comparison (===), and `structualComparer` deeply compares the structure.
     * Structural comparison can be convenient if you always produce a new aggregated object and
     * don't want to notify observers if it is structurally the same.
     * This is useful for working with vectors, mouse coordinates etc.
     */
    function ComputedValue$$1(options) {
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = null; // during tracking it's an array with new observed observers
        this.isBeingObserved = false;
        this.isPendingUnobservation = false;
        this.observers = new Set();
        this.diffValue = 0;
        this.runId = 0;
        this.lastAccessedBy = 0;
        this.lowestObserverState = IDerivationState.UP_TO_DATE;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId$$1();
        this.value = new CaughtException$$1(null);
        this.isComputing = false; // to check for cycles
        this.isRunningSetter = false;
        this.isTracing = TraceMode$$1.NONE;
        this.firstGet = true;
        if (false)
            throw "[mobx] missing option for computed: get";
        this.derivation = options.get;
        this.name = options.name || "ComputedValue@" + getNextId$$1();
        if (options.set)
            this.setter = createAction$$1(this.name + "-setter", options.set);
        this.equals =
            options.equals ||
                (options.compareStructural || options.struct
                    ? comparer$$1.structural
                    : comparer$$1.default);
        this.scope = options.context;
        this.requiresReaction = !!options.requiresReaction;
        this.keepAlive = !!options.keepAlive;
    }
    ComputedValue$$1.prototype.onBecomeStale = function () {
        propagateMaybeChanged$$1(this);
    };
    ComputedValue$$1.prototype.onBecomeUnobserved = function () { };
    ComputedValue$$1.prototype.onBecomeObserved = function () { };
    /**
     * Returns the current value of this computed value.
     * Will evaluate its computation first if needed.
     */
    ComputedValue$$1.prototype.get = function () {
        var _this = this;
        if (this.keepAlive && this.firstGet) {
            this.firstGet = false;
            autorun$$1(function () { return _this.get(); });
        }
        if (this.isComputing)
            fail$$1("Cycle detected in computation " + this.name + ": " + this.derivation);
        if (globalState$$1.inBatch === 0 && this.observers.size === 0) {
            if (shouldCompute$$1(this)) {
                this.warnAboutUntrackedRead();
                startBatch$$1(); // See perf test 'computed memoization'
                this.value = this.computeValue(false);
                endBatch$$1();
            }
        }
        else {
            reportObserved$$1(this);
            if (shouldCompute$$1(this))
                if (this.trackAndCompute())
                    propagateChangeConfirmed$$1(this);
        }
        var result = this.value;
        if (isCaughtException$$1(result))
            throw result.cause;
        return result;
    };
    ComputedValue$$1.prototype.peek = function () {
        var res = this.computeValue(false);
        if (isCaughtException$$1(res))
            throw res.cause;
        return res;
    };
    ComputedValue$$1.prototype.set = function (value) {
        if (this.setter) {
            invariant$$1(!this.isRunningSetter, "The setter of computed value '" + this.name + "' is trying to update itself. Did you intend to update an _observable_ value, instead of the computed property?");
            this.isRunningSetter = true;
            try {
                this.setter.call(this.scope, value);
            }
            finally {
                this.isRunningSetter = false;
            }
        }
        else
            invariant$$1(false, "production" !== "production" &&
                "[ComputedValue '" + this.name + "'] It is not possible to assign a new value to a computed value.");
    };
    ComputedValue$$1.prototype.trackAndCompute = function () {
        if (isSpyEnabled$$1() && "production" !== "production") {
            spyReport$$1({
                object: this.scope,
                type: "compute",
                name: this.name
            });
        }
        var oldValue = this.value;
        var wasSuspended = 
        /* see #1208 */ this.dependenciesState === IDerivationState.NOT_TRACKING;
        var newValue = this.computeValue(true);
        var changed = wasSuspended ||
            isCaughtException$$1(oldValue) ||
            isCaughtException$$1(newValue) ||
            !this.equals(oldValue, newValue);
        if (changed) {
            this.value = newValue;
        }
        return changed;
    };
    ComputedValue$$1.prototype.computeValue = function (track) {
        this.isComputing = true;
        globalState$$1.computationDepth++;
        var res;
        if (track) {
            res = trackDerivedFunction$$1(this, this.derivation, this.scope);
        }
        else {
            if (globalState$$1.disableErrorBoundaries === true) {
                res = this.derivation.call(this.scope);
            }
            else {
                try {
                    res = this.derivation.call(this.scope);
                }
                catch (e) {
                    res = new CaughtException$$1(e);
                }
            }
        }
        globalState$$1.computationDepth--;
        this.isComputing = false;
        return res;
    };
    ComputedValue$$1.prototype.suspend = function () {
        clearObserving$$1(this);
        this.value = undefined; // don't hold on to computed value!
    };
    ComputedValue$$1.prototype.observe = function (listener, fireImmediately) {
        var _this = this;
        var firstTime = true;
        var prevValue = undefined;
        return autorun$$1(function () {
            var newValue = _this.get();
            if (!firstTime || fireImmediately) {
                var prevU = untrackedStart$$1();
                listener({
                    type: "update",
                    object: _this,
                    newValue: newValue,
                    oldValue: prevValue
                });
                untrackedEnd$$1(prevU);
            }
            firstTime = false;
            prevValue = newValue;
        });
    };
    ComputedValue$$1.prototype.warnAboutUntrackedRead = function () {
        if (true)
            return;
        if (this.requiresReaction === true) {
            fail$$1("[mobx] Computed value " + this.name + " is read outside a reactive context");
        }
        if (this.isTracing !== TraceMode$$1.NONE) {
            console.log("[mobx.trace] '" + this.name + "' is being read outside a reactive context. Doing a full recompute");
        }
        if (globalState$$1.computedRequiresReaction) {
            console.warn("[mobx] Computed value " + this.name + " is being read outside a reactive context. Doing a full recompute");
        }
    };
    ComputedValue$$1.prototype.toJSON = function () {
        return this.get();
    };
    ComputedValue$$1.prototype.toString = function () {
        return this.name + "[" + this.derivation.toString() + "]";
    };
    ComputedValue$$1.prototype.valueOf = function () {
        return toPrimitive$$1(this.get());
    };
    ComputedValue$$1.prototype[Symbol.toPrimitive] = function () {
        return this.valueOf();
    };
    return ComputedValue$$1;
}());
var isComputedValue$$1 = createInstanceofPredicate$$1("ComputedValue", ComputedValue$$1);

var IDerivationState;
(function (IDerivationState$$1) {
    // before being run or (outside batch and not being observed)
    // at this point derivation is not holding any data about dependency tree
    IDerivationState$$1[IDerivationState$$1["NOT_TRACKING"] = -1] = "NOT_TRACKING";
    // no shallow dependency changed since last computation
    // won't recalculate derivation
    // this is what makes mobx fast
    IDerivationState$$1[IDerivationState$$1["UP_TO_DATE"] = 0] = "UP_TO_DATE";
    // some deep dependency changed, but don't know if shallow dependency changed
    // will require to check first if UP_TO_DATE or POSSIBLY_STALE
    // currently only ComputedValue will propagate POSSIBLY_STALE
    //
    // having this state is second big optimization:
    // don't have to recompute on every dependency change, but only when it's needed
    IDerivationState$$1[IDerivationState$$1["POSSIBLY_STALE"] = 1] = "POSSIBLY_STALE";
    // A shallow dependency has changed since last computation and the derivation
    // will need to recompute when it's needed next.
    IDerivationState$$1[IDerivationState$$1["STALE"] = 2] = "STALE";
})(IDerivationState || (IDerivationState = {}));
var TraceMode$$1;
(function (TraceMode$$1) {
    TraceMode$$1[TraceMode$$1["NONE"] = 0] = "NONE";
    TraceMode$$1[TraceMode$$1["LOG"] = 1] = "LOG";
    TraceMode$$1[TraceMode$$1["BREAK"] = 2] = "BREAK";
})(TraceMode$$1 || (TraceMode$$1 = {}));
var CaughtException$$1 = /** @class */ (function () {
    function CaughtException$$1(cause) {
        this.cause = cause;
        // Empty
    }
    return CaughtException$$1;
}());
function isCaughtException$$1(e) {
    return e instanceof CaughtException$$1;
}
/**
 * Finds out whether any dependency of the derivation has actually changed.
 * If dependenciesState is 1 then it will recalculate dependencies,
 * if any dependency changed it will propagate it by changing dependenciesState to 2.
 *
 * By iterating over the dependencies in the same order that they were reported and
 * stopping on the first change, all the recalculations are only called for ComputedValues
 * that will be tracked by derivation. That is because we assume that if the first x
 * dependencies of the derivation doesn't change then the derivation should run the same way
 * up until accessing x-th dependency.
 */
function shouldCompute$$1(derivation) {
    switch (derivation.dependenciesState) {
        case IDerivationState.UP_TO_DATE:
            return false;
        case IDerivationState.NOT_TRACKING:
        case IDerivationState.STALE:
            return true;
        case IDerivationState.POSSIBLY_STALE: {
            var prevUntracked = untrackedStart$$1(); // no need for those computeds to be reported, they will be picked up in trackDerivedFunction.
            var obs = derivation.observing, l = obs.length;
            for (var i = 0; i < l; i++) {
                var obj = obs[i];
                if (isComputedValue$$1(obj)) {
                    if (globalState$$1.disableErrorBoundaries) {
                        obj.get();
                    }
                    else {
                        try {
                            obj.get();
                        }
                        catch (e) {
                            // we are not interested in the value *or* exception at this moment, but if there is one, notify all
                            untrackedEnd$$1(prevUntracked);
                            return true;
                        }
                    }
                    // if ComputedValue `obj` actually changed it will be computed and propagated to its observers.
                    // and `derivation` is an observer of `obj`
                    // invariantShouldCompute(derivation)
                    if (derivation.dependenciesState === IDerivationState.STALE) {
                        untrackedEnd$$1(prevUntracked);
                        return true;
                    }
                }
            }
            changeDependenciesStateTo0$$1(derivation);
            untrackedEnd$$1(prevUntracked);
            return false;
        }
    }
}
// function invariantShouldCompute(derivation: IDerivation) {
//     const newDepState = (derivation as any).dependenciesState
//     if (
//         process.env.NODE_ENV === "production" &&
//         (newDepState === IDerivationState.POSSIBLY_STALE ||
//             newDepState === IDerivationState.NOT_TRACKING)
//     )
//         fail("Illegal dependency state")
// }
function isComputingDerivation$$1() {
    return globalState$$1.trackingDerivation !== null; // filter out actions inside computations
}
function checkIfStateModificationsAreAllowed$$1(atom) {
    var hasObservers$$1 = atom.observers.size > 0;
    // Should never be possible to change an observed observable from inside computed, see #798
    if (globalState$$1.computationDepth > 0 && hasObservers$$1)
        fail$$1("production" !== "production" &&
            "Computed values are not allowed to cause side effects by changing observables that are already being observed. Tried to modify: " + atom.name);
    // Should not be possible to change observed state outside strict mode, except during initialization, see #563
    if (!globalState$$1.allowStateChanges && (hasObservers$$1 || globalState$$1.enforceActions === "strict"))
        fail$$1("production" !== "production" &&
            (globalState$$1.enforceActions
                ? "Since strict-mode is enabled, changing observed observable values outside actions is not allowed. Please wrap the code in an `action` if this change is intended. Tried to modify: "
                : "Side effects like changing state are not allowed at this point. Are you trying to modify state from, for example, the render function of a React component? Tried to modify: ") +
                atom.name);
}
/**
 * Executes the provided function `f` and tracks which observables are being accessed.
 * The tracking information is stored on the `derivation` object and the derivation is registered
 * as observer of any of the accessed observables.
 */
function trackDerivedFunction$$1(derivation, f, context) {
    // pre allocate array allocation + room for variation in deps
    // array will be trimmed by bindDependencies
    changeDependenciesStateTo0$$1(derivation);
    derivation.newObserving = new Array(derivation.observing.length + 100);
    derivation.unboundDepsCount = 0;
    derivation.runId = ++globalState$$1.runId;
    var prevTracking = globalState$$1.trackingDerivation;
    globalState$$1.trackingDerivation = derivation;
    var result;
    if (globalState$$1.disableErrorBoundaries === true) {
        result = f.call(context);
    }
    else {
        try {
            result = f.call(context);
        }
        catch (e) {
            result = new CaughtException$$1(e);
        }
    }
    globalState$$1.trackingDerivation = prevTracking;
    bindDependencies(derivation);
    return result;
}
/**
 * diffs newObserving with observing.
 * update observing to be newObserving with unique observables
 * notify observers that become observed/unobserved
 */
function bindDependencies(derivation) {
    // invariant(derivation.dependenciesState !== IDerivationState.NOT_TRACKING, "INTERNAL ERROR bindDependencies expects derivation.dependenciesState !== -1");
    var prevObserving = derivation.observing;
    var observing = (derivation.observing = derivation.newObserving);
    var lowestNewObservingDerivationState = IDerivationState.UP_TO_DATE;
    // Go through all new observables and check diffValue: (this list can contain duplicates):
    //   0: first occurrence, change to 1 and keep it
    //   1: extra occurrence, drop it
    var i0 = 0, l = derivation.unboundDepsCount;
    for (var i = 0; i < l; i++) {
        var dep = observing[i];
        if (dep.diffValue === 0) {
            dep.diffValue = 1;
            if (i0 !== i)
                observing[i0] = dep;
            i0++;
        }
        // Upcast is 'safe' here, because if dep is IObservable, `dependenciesState` will be undefined,
        // not hitting the condition
        if (dep.dependenciesState > lowestNewObservingDerivationState) {
            lowestNewObservingDerivationState = dep.dependenciesState;
        }
    }
    observing.length = i0;
    derivation.newObserving = null; // newObserving shouldn't be needed outside tracking (statement moved down to work around FF bug, see #614)
    // Go through all old observables and check diffValue: (it is unique after last bindDependencies)
    //   0: it's not in new observables, unobserve it
    //   1: it keeps being observed, don't want to notify it. change to 0
    l = prevObserving.length;
    while (l--) {
        var dep = prevObserving[l];
        if (dep.diffValue === 0) {
            removeObserver$$1(dep, derivation);
        }
        dep.diffValue = 0;
    }
    // Go through all new observables and check diffValue: (now it should be unique)
    //   0: it was set to 0 in last loop. don't need to do anything.
    //   1: it wasn't observed, let's observe it. set back to 0
    while (i0--) {
        var dep = observing[i0];
        if (dep.diffValue === 1) {
            dep.diffValue = 0;
            addObserver$$1(dep, derivation);
        }
    }
    // Some new observed derivations may become stale during this derivation computation
    // so they have had no chance to propagate staleness (#916)
    if (lowestNewObservingDerivationState !== IDerivationState.UP_TO_DATE) {
        derivation.dependenciesState = lowestNewObservingDerivationState;
        derivation.onBecomeStale();
    }
}
function clearObserving$$1(derivation) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR clearObserving should be called only inside batch");
    var obs = derivation.observing;
    derivation.observing = [];
    var i = obs.length;
    while (i--)
        removeObserver$$1(obs[i], derivation);
    derivation.dependenciesState = IDerivationState.NOT_TRACKING;
}
function untracked$$1(action$$1) {
    var prev = untrackedStart$$1();
    try {
        return action$$1();
    }
    finally {
        untrackedEnd$$1(prev);
    }
}
function untrackedStart$$1() {
    var prev = globalState$$1.trackingDerivation;
    globalState$$1.trackingDerivation = null;
    return prev;
}
function untrackedEnd$$1(prev) {
    globalState$$1.trackingDerivation = prev;
}
/**
 * needed to keep `lowestObserverState` correct. when changing from (2 or 1) to 0
 *
 */
function changeDependenciesStateTo0$$1(derivation) {
    if (derivation.dependenciesState === IDerivationState.UP_TO_DATE)
        return;
    derivation.dependenciesState = IDerivationState.UP_TO_DATE;
    var obs = derivation.observing;
    var i = obs.length;
    while (i--)
        obs[i].lowestObserverState = IDerivationState.UP_TO_DATE;
}

/**
 * These values will persist if global state is reset
 */
var persistentKeys = [
    "mobxGuid",
    "spyListeners",
    "enforceActions",
    "computedRequiresReaction",
    "disableErrorBoundaries",
    "runId"
];
var MobXGlobals$$1 = /** @class */ (function () {
    function MobXGlobals$$1() {
        /**
         * MobXGlobals version.
         * MobX compatiblity with other versions loaded in memory as long as this version matches.
         * It indicates that the global state still stores similar information
         *
         * N.B: this version is unrelated to the package version of MobX, and is only the version of the
         * internal state storage of MobX, and can be the same across many different package versions
         */
        this.version = 5;
        /**
         * Currently running derivation
         */
        this.trackingDerivation = null;
        /**
         * Are we running a computation currently? (not a reaction)
         */
        this.computationDepth = 0;
        /**
         * Each time a derivation is tracked, it is assigned a unique run-id
         */
        this.runId = 0;
        /**
         * 'guid' for general purpose. Will be persisted amongst resets.
         */
        this.mobxGuid = 0;
        /**
         * Are we in a batch block? (and how many of them)
         */
        this.inBatch = 0;
        /**
         * Observables that don't have observers anymore, and are about to be
         * suspended, unless somebody else accesses it in the same batch
         *
         * @type {IObservable[]}
         */
        this.pendingUnobservations = [];
        /**
         * List of scheduled, not yet executed, reactions.
         */
        this.pendingReactions = [];
        /**
         * Are we currently processing reactions?
         */
        this.isRunningReactions = false;
        /**
         * Is it allowed to change observables at this point?
         * In general, MobX doesn't allow that when running computations and React.render.
         * To ensure that those functions stay pure.
         */
        this.allowStateChanges = true;
        /**
         * If strict mode is enabled, state changes are by default not allowed
         */
        this.enforceActions = false;
        /**
         * Spy callbacks
         */
        this.spyListeners = [];
        /**
         * Globally attached error handlers that react specifically to errors in reactions
         */
        this.globalReactionErrorHandlers = [];
        /**
         * Warn if computed values are accessed outside a reactive context
         */
        this.computedRequiresReaction = false;
        /*
         * Don't catch and rethrow exceptions. This is useful for inspecting the state of
         * the stack when an exception occurs while debugging.
         */
        this.disableErrorBoundaries = false;
    }
    return MobXGlobals$$1;
}());
var canMergeGlobalState = true;
var isolateCalled = false;
var globalState$$1 = (function () {
    var global = getGlobal$$1();
    if (global.__mobxInstanceCount > 0 && !global.__mobxGlobals)
        canMergeGlobalState = false;
    if (global.__mobxGlobals && global.__mobxGlobals.version !== new MobXGlobals$$1().version)
        canMergeGlobalState = false;
    if (!canMergeGlobalState) {
        setTimeout(function () {
            if (!isolateCalled) {
                fail$$1("There are multiple, different versions of MobX active. Make sure MobX is loaded only once or use `configure({ isolateGlobalState: true })`");
            }
        }, 1);
        return new MobXGlobals$$1();
    }
    else if (global.__mobxGlobals) {
        global.__mobxInstanceCount += 1;
        return global.__mobxGlobals;
    }
    else {
        global.__mobxInstanceCount = 1;
        return (global.__mobxGlobals = new MobXGlobals$$1());
    }
})();
function isolateGlobalState$$1() {
    if (globalState$$1.pendingReactions.length ||
        globalState$$1.inBatch ||
        globalState$$1.isRunningReactions)
        fail$$1("isolateGlobalState should be called before MobX is running any reactions");
    isolateCalled = true;
    if (canMergeGlobalState) {
        if (--getGlobal$$1().__mobxInstanceCount === 0)
            getGlobal$$1().__mobxGlobals = undefined;
        globalState$$1 = new MobXGlobals$$1();
    }
}
function getGlobalState$$1() {
    return globalState$$1;
}
/**
 * For testing purposes only; this will break the internal state of existing observables,
 * but can be used to get back at a stable state after throwing errors
 */
function resetGlobalState$$1() {
    var defaultGlobals = new MobXGlobals$$1();
    for (var key in defaultGlobals)
        if (persistentKeys.indexOf(key) === -1)
            globalState$$1[key] = defaultGlobals[key];
    globalState$$1.allowStateChanges = !globalState$$1.enforceActions;
}
function getGlobal$$1() {
    return typeof window !== "undefined" ? window : global;
}

function hasObservers$$1(observable$$1) {
    return observable$$1.observers && observable$$1.observers.size > 0;
}
function getObservers$$1(observable$$1) {
    return observable$$1.observers;
}
// function invariantObservers(observable: IObservable) {
//     const list = observable.observers
//     const map = observable.observersIndexes
//     const l = list.length
//     for (let i = 0; i < l; i++) {
//         const id = list[i].__mapid
//         if (i) {
//             invariant(map[id] === i, "INTERNAL ERROR maps derivation.__mapid to index in list") // for performance
//         } else {
//             invariant(!(id in map), "INTERNAL ERROR observer on index 0 shouldn't be held in map.") // for performance
//         }
//     }
//     invariant(
//         list.length === 0 || Object.keys(map).length === list.length - 1,
//         "INTERNAL ERROR there is no junk in map"
//     )
// }
function addObserver$$1(observable$$1, node) {
    // invariant(node.dependenciesState !== -1, "INTERNAL ERROR, can add only dependenciesState !== -1");
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR add already added node");
    // invariantObservers(observable);
    observable$$1.observers.add(node);
    if (observable$$1.lowestObserverState > node.dependenciesState)
        observable$$1.lowestObserverState = node.dependenciesState;
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR didn't add node");
}
function removeObserver$$1(observable$$1, node) {
    // invariant(globalState.inBatch > 0, "INTERNAL ERROR, remove should be called only inside batch");
    // invariant(observable._observers.indexOf(node) !== -1, "INTERNAL ERROR remove already removed node");
    // invariantObservers(observable);
    observable$$1.observers.delete(node);
    if (observable$$1.observers.size === 0) {
        // deleting last observer
        queueForUnobservation$$1(observable$$1);
    }
    // invariantObservers(observable);
    // invariant(observable._observers.indexOf(node) === -1, "INTERNAL ERROR remove already removed node2");
}
function queueForUnobservation$$1(observable$$1) {
    if (observable$$1.isPendingUnobservation === false) {
        // invariant(observable._observers.length === 0, "INTERNAL ERROR, should only queue for unobservation unobserved observables");
        observable$$1.isPendingUnobservation = true;
        globalState$$1.pendingUnobservations.push(observable$$1);
    }
}
/**
 * Batch starts a transaction, at least for purposes of memoizing ComputedValues when nothing else does.
 * During a batch `onBecomeUnobserved` will be called at most once per observable.
 * Avoids unnecessary recalculations.
 */
function startBatch$$1() {
    globalState$$1.inBatch++;
}
function endBatch$$1() {
    if (--globalState$$1.inBatch === 0) {
        runReactions$$1();
        // the batch is actually about to finish, all unobserving should happen here.
        var list = globalState$$1.pendingUnobservations;
        for (var i = 0; i < list.length; i++) {
            var observable$$1 = list[i];
            observable$$1.isPendingUnobservation = false;
            if (observable$$1.observers.size === 0) {
                if (observable$$1.isBeingObserved) {
                    // if this observable had reactive observers, trigger the hooks
                    observable$$1.isBeingObserved = false;
                    observable$$1.onBecomeUnobserved();
                }
                if (observable$$1 instanceof ComputedValue$$1) {
                    // computed values are automatically teared down when the last observer leaves
                    // this process happens recursively, this computed might be the last observabe of another, etc..
                    observable$$1.suspend();
                }
            }
        }
        globalState$$1.pendingUnobservations = [];
    }
}
function reportObserved$$1(observable$$1) {
    var derivation = globalState$$1.trackingDerivation;
    if (derivation !== null) {
        /**
         * Simple optimization, give each derivation run an unique id (runId)
         * Check if last time this observable was accessed the same runId is used
         * if this is the case, the relation is already known
         */
        if (derivation.runId !== observable$$1.lastAccessedBy) {
            observable$$1.lastAccessedBy = derivation.runId;
            // Tried storing newObserving, or observing, or both as Set, but performance didn't come close...
            derivation.newObserving[derivation.unboundDepsCount++] = observable$$1;
            if (!observable$$1.isBeingObserved) {
                observable$$1.isBeingObserved = true;
                observable$$1.onBecomeObserved();
            }
        }
        return true;
    }
    else if (observable$$1.observers.size === 0 && globalState$$1.inBatch > 0) {
        queueForUnobservation$$1(observable$$1);
    }
    return false;
}
// function invariantLOS(observable: IObservable, msg: string) {
//     // it's expensive so better not run it in produciton. but temporarily helpful for testing
//     const min = getObservers(observable).reduce((a, b) => Math.min(a, b.dependenciesState), 2)
//     if (min >= observable.lowestObserverState) return // <- the only assumption about `lowestObserverState`
//     throw new Error(
//         "lowestObserverState is wrong for " +
//             msg +
//             " because " +
//             min +
//             " < " +
//             observable.lowestObserverState
//     )
// }
/**
 * NOTE: current propagation mechanism will in case of self reruning autoruns behave unexpectedly
 * It will propagate changes to observers from previous run
 * It's hard or maybe impossible (with reasonable perf) to get it right with current approach
 * Hopefully self reruning autoruns aren't a feature people should depend on
 * Also most basic use cases should be ok
 */
// Called by Atom when its value changes
function propagateChanged$$1(observable$$1) {
    // invariantLOS(observable, "changed start");
    if (observable$$1.lowestObserverState === IDerivationState.STALE)
        return;
    observable$$1.lowestObserverState = IDerivationState.STALE;
    // Ideally we use for..of here, but the downcompiled version is really slow...
    observable$$1.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            if (d.isTracing !== TraceMode$$1.NONE) {
                logTraceInfo(d, observable$$1);
            }
            d.onBecomeStale();
        }
        d.dependenciesState = IDerivationState.STALE;
    });
    // invariantLOS(observable, "changed end");
}
// Called by ComputedValue when it recalculate and its value changed
function propagateChangeConfirmed$$1(observable$$1) {
    // invariantLOS(observable, "confirmed start");
    if (observable$$1.lowestObserverState === IDerivationState.STALE)
        return;
    observable$$1.lowestObserverState = IDerivationState.STALE;
    observable$$1.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.POSSIBLY_STALE)
            d.dependenciesState = IDerivationState.STALE;
        else if (d.dependenciesState === IDerivationState.UP_TO_DATE // this happens during computing of `d`, just keep lowestObserverState up to date.
        )
            observable$$1.lowestObserverState = IDerivationState.UP_TO_DATE;
    });
    // invariantLOS(observable, "confirmed end");
}
// Used by computed when its dependency changed, but we don't wan't to immediately recompute.
function propagateMaybeChanged$$1(observable$$1) {
    // invariantLOS(observable, "maybe start");
    if (observable$$1.lowestObserverState !== IDerivationState.UP_TO_DATE)
        return;
    observable$$1.lowestObserverState = IDerivationState.POSSIBLY_STALE;
    observable$$1.observers.forEach(function (d) {
        if (d.dependenciesState === IDerivationState.UP_TO_DATE) {
            d.dependenciesState = IDerivationState.POSSIBLY_STALE;
            if (d.isTracing !== TraceMode$$1.NONE) {
                logTraceInfo(d, observable$$1);
            }
            d.onBecomeStale();
        }
    });
    // invariantLOS(observable, "maybe end");
}
function logTraceInfo(derivation, observable$$1) {
    console.log("[mobx.trace] '" + derivation.name + "' is invalidated due to a change in: '" + observable$$1.name + "'");
    if (derivation.isTracing === TraceMode$$1.BREAK) {
        var lines = [];
        printDepTree(getDependencyTree$$1(derivation), lines, 1);
        // prettier-ignore
        new Function("debugger;\n/*\nTracing '" + derivation.name + "'\n\nYou are entering this break point because derivation '" + derivation.name + "' is being traced and '" + observable$$1.name + "' is now forcing it to update.\nJust follow the stacktrace you should now see in the devtools to see precisely what piece of your code is causing this update\nThe stackframe you are looking for is at least ~6-8 stack-frames up.\n\n" + (derivation instanceof ComputedValue$$1 ? derivation.derivation.toString() : "") + "\n\nThe dependencies for this derivation are:\n\n" + lines.join("\n") + "\n*/\n    ")();
    }
}
function printDepTree(tree, lines, depth) {
    if (lines.length >= 1000) {
        lines.push("(and many more)");
        return;
    }
    lines.push("" + new Array(depth).join("\t") + tree.name); // MWE: not the fastest, but the easiest way :)
    if (tree.dependencies)
        tree.dependencies.forEach(function (child) { return printDepTree(child, lines, depth + 1); });
}

var Reaction$$1 = /** @class */ (function () {
    function Reaction$$1(name, onInvalidate, errorHandler) {
        if (name === void 0) { name = "Reaction@" + getNextId$$1(); }
        this.name = name;
        this.onInvalidate = onInvalidate;
        this.errorHandler = errorHandler;
        this.observing = []; // nodes we are looking at. Our value depends on these nodes
        this.newObserving = [];
        this.dependenciesState = IDerivationState.NOT_TRACKING;
        this.diffValue = 0;
        this.runId = 0;
        this.unboundDepsCount = 0;
        this.__mapid = "#" + getNextId$$1();
        this.isDisposed = false;
        this._isScheduled = false;
        this._isTrackPending = false;
        this._isRunning = false;
        this.isTracing = TraceMode$$1.NONE;
    }
    Reaction$$1.prototype.onBecomeStale = function () {
        this.schedule();
    };
    Reaction$$1.prototype.schedule = function () {
        if (!this._isScheduled) {
            this._isScheduled = true;
            globalState$$1.pendingReactions.push(this);
            runReactions$$1();
        }
    };
    Reaction$$1.prototype.isScheduled = function () {
        return this._isScheduled;
    };
    /**
     * internal, use schedule() if you intend to kick off a reaction
     */
    Reaction$$1.prototype.runReaction = function () {
        if (!this.isDisposed) {
            startBatch$$1();
            this._isScheduled = false;
            if (shouldCompute$$1(this)) {
                this._isTrackPending = true;
                try {
                    this.onInvalidate();
                    if (this._isTrackPending &&
                        isSpyEnabled$$1() &&
                        "production" !== "production") {
                        // onInvalidate didn't trigger track right away..
                        spyReport$$1({
                            name: this.name,
                            type: "scheduled-reaction"
                        });
                    }
                }
                catch (e) {
                    this.reportExceptionInDerivation(e);
                }
            }
            endBatch$$1();
        }
    };
    Reaction$$1.prototype.track = function (fn) {
        startBatch$$1();
        var notify = isSpyEnabled$$1();
        var startTime;
        if (notify && "production" !== "production") {
            startTime = Date.now();
            spyReportStart$$1({
                name: this.name,
                type: "reaction"
            });
        }
        this._isRunning = true;
        var result = trackDerivedFunction$$1(this, fn, undefined);
        this._isRunning = false;
        this._isTrackPending = false;
        if (this.isDisposed) {
            // disposed during last run. Clean up everything that was bound after the dispose call.
            clearObserving$$1(this);
        }
        if (isCaughtException$$1(result))
            this.reportExceptionInDerivation(result.cause);
        if (notify && "production" !== "production") {
            spyReportEnd$$1({
                time: Date.now() - startTime
            });
        }
        endBatch$$1();
    };
    Reaction$$1.prototype.reportExceptionInDerivation = function (error) {
        var _this = this;
        if (this.errorHandler) {
            this.errorHandler(error, this);
            return;
        }
        if (globalState$$1.disableErrorBoundaries)
            throw error;
        var message = "[mobx] Encountered an uncaught exception that was thrown by a reaction or observer component, in: '" + this;
        console.error(message, error);
        /** If debugging brought you here, please, read the above message :-). Tnx! */
        if (isSpyEnabled$$1()) {
            spyReport$$1({
                type: "error",
                name: this.name,
                message: message,
                error: "" + error
            });
        }
        globalState$$1.globalReactionErrorHandlers.forEach(function (f) { return f(error, _this); });
    };
    Reaction$$1.prototype.dispose = function () {
        if (!this.isDisposed) {
            this.isDisposed = true;
            if (!this._isRunning) {
                // if disposed while running, clean up later. Maybe not optimal, but rare case
                startBatch$$1();
                clearObserving$$1(this);
                endBatch$$1();
            }
        }
    };
    Reaction$$1.prototype.getDisposer = function () {
        var r = this.dispose.bind(this);
        r[$mobx$$1] = this;
        return r;
    };
    Reaction$$1.prototype.toString = function () {
        return "Reaction[" + this.name + "]";
    };
    Reaction$$1.prototype.trace = function (enterBreakPoint) {
        if (enterBreakPoint === void 0) { enterBreakPoint = false; }
        trace$$1(this, enterBreakPoint);
    };
    return Reaction$$1;
}());
function onReactionError$$1(handler) {
    globalState$$1.globalReactionErrorHandlers.push(handler);
    return function () {
        var idx = globalState$$1.globalReactionErrorHandlers.indexOf(handler);
        if (idx >= 0)
            globalState$$1.globalReactionErrorHandlers.splice(idx, 1);
    };
}
/**
 * Magic number alert!
 * Defines within how many times a reaction is allowed to re-trigger itself
 * until it is assumed that this is gonna be a never ending loop...
 */
var MAX_REACTION_ITERATIONS = 100;
var reactionScheduler = function (f) { return f(); };
function runReactions$$1() {
    // Trampolining, if runReactions are already running, new reactions will be picked up
    if (globalState$$1.inBatch > 0 || globalState$$1.isRunningReactions)
        return;
    reactionScheduler(runReactionsHelper);
}
function runReactionsHelper() {
    globalState$$1.isRunningReactions = true;
    var allReactions = globalState$$1.pendingReactions;
    var iterations = 0;
    // While running reactions, new reactions might be triggered.
    // Hence we work with two variables and check whether
    // we converge to no remaining reactions after a while.
    while (allReactions.length > 0) {
        if (++iterations === MAX_REACTION_ITERATIONS) {
            console.error("Reaction doesn't converge to a stable state after " + MAX_REACTION_ITERATIONS + " iterations." +
                (" Probably there is a cycle in the reactive function: " + allReactions[0]));
            allReactions.splice(0); // clear reactions
        }
        var remainingReactions = allReactions.splice(0);
        for (var i = 0, l = remainingReactions.length; i < l; i++)
            remainingReactions[i].runReaction();
    }
    globalState$$1.isRunningReactions = false;
}
var isReaction$$1 = createInstanceofPredicate$$1("Reaction", Reaction$$1);
function setReactionScheduler$$1(fn) {
    var baseScheduler = reactionScheduler;
    reactionScheduler = function (f) { return fn(function () { return baseScheduler(f); }); };
}

function isSpyEnabled$$1() {
    return "production" !== "production" && !!globalState$$1.spyListeners.length;
}
function spyReport$$1(event) {
    if (true)
        return; // dead code elimination can do the rest
    if (!globalState$$1.spyListeners.length)
        return;
    var listeners = globalState$$1.spyListeners;
    for (var i = 0, l = listeners.length; i < l; i++)
        listeners[i](event);
}
function spyReportStart$$1(event) {
    if (true)
        return;
    var change = __assign({}, event, { spyReportStart: true });
    spyReport$$1(change);
}
var END_EVENT = { spyReportEnd: true };
function spyReportEnd$$1(change) {
    if (true)
        return;
    if (change)
        spyReport$$1(__assign({}, change, { spyReportEnd: true }));
    else
        spyReport$$1(END_EVENT);
}
function spy$$1(listener) {
    if (true) {
        console.warn("[mobx.spy] Is a no-op in production builds");
        return function () { };
    }
    else {
        globalState$$1.spyListeners.push(listener);
        return once$$1(function () {
            globalState$$1.spyListeners = globalState$$1.spyListeners.filter(function (l) { return l !== listener; });
        });
    }
}

function dontReassignFields() {
    fail$$1("production" !== "production" && "@action fields are not reassignable");
}
function namedActionDecorator$$1(name) {
    return function (target, prop, descriptor) {
        if (descriptor) {
            if (false) {
                return fail$$1("@action cannot be used with getters");
            }
            // babel / typescript
            // @action method() { }
            if (descriptor.value) {
                // typescript
                return {
                    value: createAction$$1(name, descriptor.value),
                    enumerable: false,
                    configurable: true,
                    writable: true // for typescript, this must be writable, otherwise it cannot inherit :/ (see inheritable actions test)
                };
            }
            // babel only: @action method = () => {}
            var initializer_1 = descriptor.initializer;
            return {
                enumerable: false,
                configurable: true,
                writable: true,
                initializer: function () {
                    // N.B: we can't immediately invoke initializer; this would be wrong
                    return createAction$$1(name, initializer_1.call(this));
                }
            };
        }
        // bound instance methods
        return actionFieldDecorator$$1(name).apply(this, arguments);
    };
}
function actionFieldDecorator$$1(name) {
    // Simple property that writes on first invocation to the current instance
    return function (target, prop, descriptor) {
        Object.defineProperty(target, prop, {
            configurable: true,
            enumerable: false,
            get: function () {
                return undefined;
            },
            set: function (value) {
                addHiddenProp$$1(this, prop, action$$1(name, value));
            }
        });
    };
}
function boundActionDecorator$$1(target, propertyName, descriptor, applyToInstance) {
    if (applyToInstance === true) {
        defineBoundAction$$1(target, propertyName, descriptor.value);
        return null;
    }
    if (descriptor) {
        // if (descriptor.value)
        // Typescript / Babel: @action.bound method() { }
        // also: babel @action.bound method = () => {}
        return {
            configurable: true,
            enumerable: false,
            get: function () {
                defineBoundAction$$1(this, propertyName, descriptor.value || descriptor.initializer.call(this));
                return this[propertyName];
            },
            set: dontReassignFields
        };
    }
    // field decorator Typescript @action.bound method = () => {}
    return {
        enumerable: false,
        configurable: true,
        set: function (v) {
            defineBoundAction$$1(this, propertyName, v);
        },
        get: function () {
            return undefined;
        }
    };
}

var action$$1 = function action$$1(arg1, arg2, arg3, arg4) {
    // action(fn() {})
    if (arguments.length === 1 && typeof arg1 === "function")
        return createAction$$1(arg1.name || "<unnamed action>", arg1);
    // action("name", fn() {})
    if (arguments.length === 2 && typeof arg2 === "function")
        return createAction$$1(arg1, arg2);
    // @action("name") fn() {}
    if (arguments.length === 1 && typeof arg1 === "string")
        return namedActionDecorator$$1(arg1);
    // @action fn() {}
    if (arg4 === true) {
        // apply to instance immediately
        addHiddenProp$$1(arg1, arg2, createAction$$1(arg1.name || arg2, arg3.value));
    }
    else {
        return namedActionDecorator$$1(arg2).apply(null, arguments);
    }
};
action$$1.bound = boundActionDecorator$$1;
function runInAction$$1(arg1, arg2) {
    var actionName = typeof arg1 === "string" ? arg1 : arg1.name || "<unnamed action>";
    var fn = typeof arg1 === "function" ? arg1 : arg2;
    if (false) {
        invariant$$1(typeof fn === "function" && fn.length === 0, "`runInAction` expects a function without arguments");
        if (typeof actionName !== "string" || !actionName)
            fail$$1("actions should have valid names, got: '" + actionName + "'");
    }
    return executeAction$$1(actionName, fn, this, undefined);
}
function isAction$$1(thing) {
    return typeof thing === "function" && thing.isMobxAction === true;
}
function defineBoundAction$$1(target, propertyName, fn) {
    addHiddenProp$$1(target, propertyName, createAction$$1(propertyName, fn.bind(target)));
}

/**
 * Creates a named reactive view and keeps it alive, so that the view is always
 * updated if one of the dependencies changes, even when the view is not further used by something else.
 * @param view The reactive view
 * @returns disposer function, which can be used to stop the view from being updated in the future.
 */
function autorun$$1(view, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT$$1; }
    if (false) {
        invariant$$1(typeof view === "function", "Autorun expects a function as first argument");
        invariant$$1(isAction$$1(view) === false, "Autorun does not accept actions since actions are untrackable");
    }
    var name = (opts && opts.name) || view.name || "Autorun@" + getNextId$$1();
    var runSync = !opts.scheduler && !opts.delay;
    var reaction$$1;
    if (runSync) {
        // normal autorun
        reaction$$1 = new Reaction$$1(name, function () {
            this.track(reactionRunner);
        }, opts.onError);
    }
    else {
        var scheduler_1 = createSchedulerFromOptions(opts);
        // debounced autorun
        var isScheduled_1 = false;
        reaction$$1 = new Reaction$$1(name, function () {
            if (!isScheduled_1) {
                isScheduled_1 = true;
                scheduler_1(function () {
                    isScheduled_1 = false;
                    if (!reaction$$1.isDisposed)
                        reaction$$1.track(reactionRunner);
                });
            }
        }, opts.onError);
    }
    function reactionRunner() {
        view(reaction$$1);
    }
    reaction$$1.schedule();
    return reaction$$1.getDisposer();
}
var run = function (f) { return f(); };
function createSchedulerFromOptions(opts) {
    return opts.scheduler
        ? opts.scheduler
        : opts.delay
            ? function (f) { return setTimeout(f, opts.delay); }
            : run;
}
function reaction$$1(expression, effect, opts) {
    if (opts === void 0) { opts = EMPTY_OBJECT$$1; }
    if (false) {
        invariant$$1(typeof expression === "function", "First argument to reaction should be a function");
        invariant$$1(typeof opts === "object", "Third argument of reactions should be an object");
    }
    var name = opts.name || "Reaction@" + getNextId$$1();
    var effectAction = action$$1(name, opts.onError ? wrapErrorHandler(opts.onError, effect) : effect);
    var runSync = !opts.scheduler && !opts.delay;
    var scheduler = createSchedulerFromOptions(opts);
    var firstTime = true;
    var isScheduled = false;
    var value;
    var equals = opts.compareStructural
        ? comparer$$1.structural
        : opts.equals || comparer$$1.default;
    var r = new Reaction$$1(name, function () {
        if (firstTime || runSync) {
            reactionRunner();
        }
        else if (!isScheduled) {
            isScheduled = true;
            scheduler(reactionRunner);
        }
    }, opts.onError);
    function reactionRunner() {
        isScheduled = false; // Q: move into reaction runner?
        if (r.isDisposed)
            return;
        var changed = false;
        r.track(function () {
            var nextValue = expression(r);
            changed = firstTime || !equals(value, nextValue);
            value = nextValue;
        });
        if (firstTime && opts.fireImmediately)
            effectAction(value, r);
        if (!firstTime && changed === true)
            effectAction(value, r);
        if (firstTime)
            firstTime = false;
    }
    r.schedule();
    return r.getDisposer();
}
function wrapErrorHandler(errorHandler, baseFn) {
    return function () {
        try {
            return baseFn.apply(this, arguments);
        }
        catch (e) {
            errorHandler.call(this, e);
        }
    };
}

function onBecomeObserved$$1(thing, arg2, arg3) {
    return interceptHook("onBecomeObserved", thing, arg2, arg3);
}
function onBecomeUnobserved$$1(thing, arg2, arg3) {
    return interceptHook("onBecomeUnobserved", thing, arg2, arg3);
}
function interceptHook(hook, thing, arg2, arg3) {
    var atom = typeof arg2 === "string" ? getAtom$$1(thing, arg2) : getAtom$$1(thing);
    var cb = typeof arg2 === "string" ? arg3 : arg2;
    var orig = atom[hook];
    if (typeof orig !== "function")
        return fail$$1("production" !== "production" && "Not an atom that can be (un)observed");
    atom[hook] = function () {
        orig.call(this);
        cb.call(this);
    };
    return function () {
        atom[hook] = orig;
    };
}

function configure$$1(options) {
    var enforceActions = options.enforceActions, computedRequiresReaction = options.computedRequiresReaction, disableErrorBoundaries = options.disableErrorBoundaries, reactionScheduler = options.reactionScheduler;
    if (enforceActions !== undefined) {
        if (typeof enforceActions === "boolean" || enforceActions === "strict")
            deprecated$$1("Deprecated value for 'enforceActions', use 'false' => '\"never\"', 'true' => '\"observed\"', '\"strict\"' => \"'always'\" instead");
        var ea = void 0;
        switch (enforceActions) {
            case true:
            case "observed":
                ea = true;
                break;
            case false:
            case "never":
                ea = false;
                break;
            case "strict":
            case "always":
                ea = "strict";
                break;
            default:
                fail$$1("Invalid value for 'enforceActions': '" + enforceActions + "', expected 'never', 'always' or 'observed'");
        }
        globalState$$1.enforceActions = ea;
        globalState$$1.allowStateChanges = ea === true || ea === "strict" ? false : true;
    }
    if (computedRequiresReaction !== undefined) {
        globalState$$1.computedRequiresReaction = !!computedRequiresReaction;
    }
    if (options.isolateGlobalState === true) {
        isolateGlobalState$$1();
    }
    if (disableErrorBoundaries !== undefined) {
        if (disableErrorBoundaries === true)
            console.warn("WARNING: Debug feature only. MobX will NOT recover from errors when `disableErrorBoundaries` is enabled.");
        globalState$$1.disableErrorBoundaries = !!disableErrorBoundaries;
    }
    if (reactionScheduler) {
        setReactionScheduler$$1(reactionScheduler);
    }
}

function decorate$$1(thing, decorators) {
    "production" !== "production" &&
        invariant$$1(isPlainObject$$1(decorators), "Decorators should be a key value map");
    var target = typeof thing === "function" ? thing.prototype : thing;
    var _loop_1 = function (prop) {
        var propertyDecorators = decorators[prop];
        if (!Array.isArray(propertyDecorators)) {
            propertyDecorators = [propertyDecorators];
        }
        "production" !== "production" &&
            invariant$$1(propertyDecorators.every(function (decorator) { return typeof decorator === "function"; }), "Decorate: expected a decorator function or array of decorator functions for '" + prop + "'");
        var descriptor = Object.getOwnPropertyDescriptor(target, prop);
        var newDescriptor = propertyDecorators.reduce(function (accDescriptor, decorator) { return decorator(target, prop, accDescriptor); }, descriptor);
        if (newDescriptor)
            Object.defineProperty(target, prop, newDescriptor);
    };
    for (var prop in decorators) {
        _loop_1(prop);
    }
    return thing;
}

function extendObservable$$1(target, properties, decorators, options) {
    if (false) {
        invariant$$1(arguments.length >= 2 && arguments.length <= 4, "'extendObservable' expected 2-4 arguments");
        invariant$$1(typeof target === "object", "'extendObservable' expects an object as first argument");
        invariant$$1(!isObservableMap$$1(target), "'extendObservable' should not be used on maps, use map.merge instead");
    }
    options = asCreateObservableOptions$$1(options);
    var defaultDecorator = getDefaultDecoratorFromObjectOptions$$1(options);
    initializeInstance$$1(target); // Fixes #1740
    asObservableObject$$1(target, options.name, defaultDecorator.enhancer); // make sure object is observable, even without initial props
    if (properties)
        extendObservableObjectWithProperties$$1(target, properties, decorators, defaultDecorator);
    return target;
}
function getDefaultDecoratorFromObjectOptions$$1(options) {
    return options.defaultDecorator || (options.deep === false ? refDecorator$$1 : deepDecorator$$1);
}
function extendObservableObjectWithProperties$$1(target, properties, decorators, defaultDecorator) {
    if (false) {
        invariant$$1(!isObservable$$1(properties), "Extending an object with another observable (object) is not supported. Please construct an explicit propertymap, using `toJS` if need. See issue #540");
        if (decorators)
            for (var key in decorators)
                if (!(key in properties))
                    fail$$1("Trying to declare a decorator for unspecified property '" + key + "'");
    }
    startBatch$$1();
    try {
        for (var key in properties) {
            var descriptor = Object.getOwnPropertyDescriptor(properties, key);
            if (false) {
                if (Object.getOwnPropertyDescriptor(target, key))
                    fail$$1("'extendObservable' can only be used to introduce new properties. Use 'set' or 'decorate' instead. The property '" + key + "' already exists on '" + target + "'");
                if (isComputed$$1(descriptor.value))
                    fail$$1("Passing a 'computed' as initial property value is no longer supported by extendObservable. Use a getter or decorator instead");
            }
            var decorator = decorators && key in decorators
                ? decorators[key]
                : descriptor.get
                    ? computedDecorator$$1
                    : defaultDecorator;
            if (false)
                fail$$1("Not a valid decorator for '" + key + "', got: " + decorator);
            var resultDescriptor = decorator(target, key, descriptor, true);
            if (resultDescriptor // otherwise, assume already applied, due to `applyToInstance`
            )
                Object.defineProperty(target, key, resultDescriptor);
        }
    }
    finally {
        endBatch$$1();
    }
}

function getDependencyTree$$1(thing, property) {
    return nodeToDependencyTree(getAtom$$1(thing, property));
}
function nodeToDependencyTree(node) {
    var result = {
        name: node.name
    };
    if (node.observing && node.observing.length > 0)
        result.dependencies = unique$$1(node.observing).map(nodeToDependencyTree);
    return result;
}
function getObserverTree$$1(thing, property) {
    return nodeToObserverTree(getAtom$$1(thing, property));
}
function nodeToObserverTree(node) {
    var result = {
        name: node.name
    };
    if (hasObservers$$1(node))
        result.observers = Array.from(getObservers$$1(node)).map(nodeToObserverTree);
    return result;
}

var generatorId = 0;
function flow$$1(generator) {
    if (arguments.length !== 1)
        fail$$1("production" && "Flow expects one 1 argument and cannot be used as decorator");
    var name = generator.name || "<unnamed flow>";
    // Implementation based on https://github.com/tj/co/blob/master/index.js
    return function () {
        var ctx = this;
        var args = arguments;
        var runId = ++generatorId;
        var gen = action$$1(name + " - runid: " + runId + " - init", generator).apply(ctx, args);
        var rejector;
        var pendingPromise = undefined;
        var res = new Promise(function (resolve, reject) {
            var stepId = 0;
            rejector = reject;
            function onFulfilled(res) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action$$1(name + " - runid: " + runId + " - yield " + stepId++, gen.next).call(gen, res);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function onRejected(err) {
                pendingPromise = undefined;
                var ret;
                try {
                    ret = action$$1(name + " - runid: " + runId + " - yield " + stepId++, gen.throw).call(gen, err);
                }
                catch (e) {
                    return reject(e);
                }
                next(ret);
            }
            function next(ret) {
                if (ret && typeof ret.then === "function") {
                    // an async iterator
                    ret.then(next, reject);
                    return;
                }
                if (ret.done)
                    return resolve(ret.value);
                pendingPromise = Promise.resolve(ret.value);
                return pendingPromise.then(onFulfilled, onRejected);
            }
            onFulfilled(undefined); // kick off the process
        });
        res.cancel = action$$1(name + " - runid: " + runId + " - cancel", function () {
            try {
                if (pendingPromise)
                    cancelPromise(pendingPromise);
                // Finally block can return (or yield) stuff..
                var res_1 = gen.return();
                // eat anything that promise would do, it's cancelled!
                var yieldedPromise = Promise.resolve(res_1.value);
                yieldedPromise.then(noop$$1, noop$$1);
                cancelPromise(yieldedPromise); // maybe it can be cancelled :)
                // reject our original promise
                rejector(new Error("FLOW_CANCELLED"));
            }
            catch (e) {
                rejector(e); // there could be a throwing finally block
            }
        });
        return res;
    };
}
function cancelPromise(promise) {
    if (typeof promise.cancel === "function")
        promise.cancel();
}

function interceptReads$$1(thing, propOrHandler, handler) {
    var target;
    if (isObservableMap$$1(thing) || isObservableArray$$1(thing) || isObservableValue$$1(thing)) {
        target = getAdministration$$1(thing);
    }
    else if (isObservableObject$$1(thing)) {
        if (typeof propOrHandler !== "string")
            return fail$$1("production" !== "production" &&
                "InterceptReads can only be used with a specific property, not with an object in general");
        target = getAdministration$$1(thing, propOrHandler);
    }
    else {
        return fail$$1("production" !== "production" &&
            "Expected observable map, object or array as first array");
    }
    if (target.dehancer !== undefined)
        return fail$$1("production" !== "production" && "An intercept reader was already established");
    target.dehancer = typeof propOrHandler === "function" ? propOrHandler : handler;
    return function () {
        target.dehancer = undefined;
    };
}

function intercept$$1(thing, propOrHandler, handler) {
    if (typeof handler === "function")
        return interceptProperty(thing, propOrHandler, handler);
    else
        return interceptInterceptable(thing, propOrHandler);
}
function interceptInterceptable(thing, handler) {
    return getAdministration$$1(thing).intercept(handler);
}
function interceptProperty(thing, property, handler) {
    return getAdministration$$1(thing, property).intercept(handler);
}

function _isComputed$$1(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (isObservableObject$$1(value) === false)
            return false;
        if (!value[$mobx$$1].values.has(property))
            return false;
        var atom = getAtom$$1(value, property);
        return isComputedValue$$1(atom);
    }
    return isComputedValue$$1(value);
}
function isComputed$$1(value) {
    if (arguments.length > 1)
        return fail$$1("production" !== "production" &&
            "isComputed expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isComputed$$1(value);
}
function isComputedProp$$1(value, propName) {
    if (typeof propName !== "string")
        return fail$$1("production" !== "production" &&
            "isComputed expected a property name as second argument");
    return _isComputed$$1(value, propName);
}

function _isObservable(value, property) {
    if (value === null || value === undefined)
        return false;
    if (property !== undefined) {
        if (false)
            return fail$$1("isObservable(object, propertyName) is not supported for arrays and maps. Use map.has or array.length instead.");
        if (isObservableObject$$1(value)) {
            return value[$mobx$$1].values.has(property);
        }
        return false;
    }
    // For first check, see #701
    return (isObservableObject$$1(value) ||
        !!value[$mobx$$1] ||
        isAtom$$1(value) ||
        isReaction$$1(value) ||
        isComputedValue$$1(value));
}
function isObservable$$1(value) {
    if (arguments.length !== 1)
        fail$$1("production" !== "production" &&
            "isObservable expects only 1 argument. Use isObservableProp to inspect the observability of a property");
    return _isObservable(value);
}
function isObservableProp$$1(value, propName) {
    if (typeof propName !== "string")
        return fail$$1("production" !== "production" && "expected a property name as second argument");
    return _isObservable(value, propName);
}

function keys$$1(obj) {
    if (isObservableObject$$1(obj)) {
        return obj[$mobx$$1].getKeys();
    }
    if (isObservableMap$$1(obj)) {
        return Array.from(obj.keys());
    }
    if (isObservableArray$$1(obj)) {
        return obj.map(function (_, index) { return index; });
    }
    return fail$$1("production" !== "production" &&
        "'keys()' can only be used on observable objects, arrays and maps");
}
function values$$1(obj) {
    if (isObservableObject$$1(obj)) {
        return keys$$1(obj).map(function (key) { return obj[key]; });
    }
    if (isObservableMap$$1(obj)) {
        return keys$$1(obj).map(function (key) { return obj.get(key); });
    }
    if (isObservableArray$$1(obj)) {
        return obj.slice();
    }
    return fail$$1("production" !== "production" &&
        "'values()' can only be used on observable objects, arrays and maps");
}
function entries$$1(obj) {
    if (isObservableObject$$1(obj)) {
        return keys$$1(obj).map(function (key) { return [key, obj[key]]; });
    }
    if (isObservableMap$$1(obj)) {
        return keys$$1(obj).map(function (key) { return [key, obj.get(key)]; });
    }
    if (isObservableArray$$1(obj)) {
        return obj.map(function (key, index) { return [index, key]; });
    }
    return fail$$1("production" !== "production" &&
        "'entries()' can only be used on observable objects, arrays and maps");
}
function set$$1(obj, key, value) {
    if (arguments.length === 2) {
        startBatch$$1();
        var values_1 = key;
        try {
            for (var key_1 in values_1)
                set$$1(obj, key_1, values_1[key_1]);
        }
        finally {
            endBatch$$1();
        }
        return;
    }
    if (isObservableObject$$1(obj)) {
        var adm = obj[$mobx$$1];
        var existingObservable = adm.values.get(key);
        if (existingObservable) {
            adm.write(key, value);
        }
        else {
            adm.addObservableProp(key, value, adm.defaultEnhancer);
        }
    }
    else if (isObservableMap$$1(obj)) {
        obj.set(key, value);
    }
    else if (isObservableArray$$1(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant$$1(key >= 0, "Not a valid index: '" + key + "'");
        startBatch$$1();
        if (key >= obj.length)
            obj.length = key + 1;
        obj[key] = value;
        endBatch$$1();
    }
    else {
        return fail$$1("production" !== "production" &&
            "'set()' can only be used on observable objects, arrays and maps");
    }
}
function remove$$1(obj, key) {
    if (isObservableObject$$1(obj)) {
        
        obj[$mobx$$1].remove(key);
    }
    else if (isObservableMap$$1(obj)) {
        obj.delete(key);
    }
    else if (isObservableArray$$1(obj)) {
        if (typeof key !== "number")
            key = parseInt(key, 10);
        invariant$$1(key >= 0, "Not a valid index: '" + key + "'");
        obj.splice(key, 1);
    }
    else {
        return fail$$1("production" !== "production" &&
            "'remove()' can only be used on observable objects, arrays and maps");
    }
}
function has$$1(obj, key) {
    if (isObservableObject$$1(obj)) {
        // return keys(obj).indexOf(key) >= 0
        var adm = getAdministration$$1(obj);
        return adm.has(key);
    }
    else if (isObservableMap$$1(obj)) {
        return obj.has(key);
    }
    else if (isObservableArray$$1(obj)) {
        return key >= 0 && key < obj.length;
    }
    else {
        return fail$$1("production" !== "production" &&
            "'has()' can only be used on observable objects, arrays and maps");
    }
}
function get$$1(obj, key) {
    if (!has$$1(obj, key))
        return undefined;
    if (isObservableObject$$1(obj)) {
        return obj[key];
    }
    else if (isObservableMap$$1(obj)) {
        return obj.get(key);
    }
    else if (isObservableArray$$1(obj)) {
        return obj[key];
    }
    else {
        return fail$$1("production" !== "production" &&
            "'get()' can only be used on observable objects, arrays and maps");
    }
}

function observe$$1(thing, propOrCb, cbOrFire, fireImmediately) {
    if (typeof cbOrFire === "function")
        return observeObservableProperty(thing, propOrCb, cbOrFire, fireImmediately);
    else
        return observeObservable(thing, propOrCb, cbOrFire);
}
function observeObservable(thing, listener, fireImmediately) {
    return getAdministration$$1(thing).observe(listener, fireImmediately);
}
function observeObservableProperty(thing, property, listener, fireImmediately) {
    return getAdministration$$1(thing, property).observe(listener, fireImmediately);
}

var defaultOptions = {
    detectCycles: true,
    exportMapsAsObjects: true,
    recurseEverything: false
};
function cache(map, key, value, options) {
    if (options.detectCycles)
        map.set(key, value);
    return value;
}
function toJSHelper(source, options, __alreadySeen) {
    if (!options.recurseEverything && !isObservable$$1(source))
        return source;
    if (typeof source !== "object")
        return source;
    // Directly return null if source is null
    if (source === null)
        return null;
    // Directly return the Date object itself if contained in the observable
    if (source instanceof Date)
        return source;
    if (isObservableValue$$1(source))
        return toJSHelper(source.get(), options, __alreadySeen);
    // make sure we track the keys of the object
    if (isObservable$$1(source))
        keys$$1(source);
    var detectCycles = options.detectCycles === true;
    if (detectCycles && source !== null && __alreadySeen.has(source)) {
        return __alreadySeen.get(source);
    }
    if (isObservableArray$$1(source) || Array.isArray(source)) {
        var res_1 = cache(__alreadySeen, source, [], options);
        var toAdd = source.map(function (value) { return toJSHelper(value, options, __alreadySeen); });
        res_1.length = toAdd.length;
        for (var i = 0, l = toAdd.length; i < l; i++)
            res_1[i] = toAdd[i];
        return res_1;
    }
    if (isObservableMap$$1(source) || Object.getPrototypeOf(source) === Map.prototype) {
        if (options.exportMapsAsObjects === false) {
            var res_2 = cache(__alreadySeen, source, new Map(), options);
            source.forEach(function (value, key) {
                res_2.set(key, toJSHelper(value, options, __alreadySeen));
            });
            return res_2;
        }
        else {
            var res_3 = cache(__alreadySeen, source, {}, options);
            source.forEach(function (value, key) {
                res_3[key] = toJSHelper(value, options, __alreadySeen);
            });
            return res_3;
        }
    }
    // Fallback to the situation that source is an ObservableObject or a plain object
    var res = cache(__alreadySeen, source, {}, options);
    for (var key in source) {
        res[key] = toJSHelper(source[key], options, __alreadySeen);
    }
    return res;
}
function toJS$$1(source, options) {
    // backward compatibility
    if (typeof options === "boolean")
        options = { detectCycles: options };
    if (!options)
        options = defaultOptions;
    options.detectCycles =
        options.detectCycles === undefined
            ? options.recurseEverything === true
            : options.detectCycles === true;
    var __alreadySeen;
    if (options.detectCycles)
        __alreadySeen = new Map();
    return toJSHelper(source, options, __alreadySeen);
}

function trace$$1() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var enterBreakPoint = false;
    if (typeof args[args.length - 1] === "boolean")
        enterBreakPoint = args.pop();
    var derivation = getAtomFromArgs(args);
    if (!derivation) {
        return fail$$1("production" !== "production" &&
            "'trace(break?)' can only be used inside a tracked computed value or a Reaction. Consider passing in the computed value or reaction explicitly");
    }
    if (derivation.isTracing === TraceMode$$1.NONE) {
        console.log("[mobx.trace] '" + derivation.name + "' tracing enabled");
    }
    derivation.isTracing = enterBreakPoint ? TraceMode$$1.BREAK : TraceMode$$1.LOG;
}
function getAtomFromArgs(args) {
    switch (args.length) {
        case 0:
            return globalState$$1.trackingDerivation;
        case 1:
            return getAtom$$1(args[0]);
        case 2:
            return getAtom$$1(args[0], args[1]);
    }
}

/**
 * During a transaction no views are updated until the end of the transaction.
 * The transaction will be run synchronously nonetheless.
 *
 * @param action a function that updates some reactive state
 * @returns any value that was returned by the 'action' parameter.
 */
function transaction$$1(action$$1, thisArg) {
    if (thisArg === void 0) { thisArg = undefined; }
    startBatch$$1();
    try {
        return action$$1.apply(thisArg);
    }
    finally {
        endBatch$$1();
    }
}

function when$$1(predicate, arg1, arg2) {
    if (arguments.length === 1 || (arg1 && typeof arg1 === "object"))
        return whenPromise(predicate, arg1);
    return _when(predicate, arg1, arg2 || {});
}
function _when(predicate, effect, opts) {
    var timeoutHandle;
    if (typeof opts.timeout === "number") {
        timeoutHandle = setTimeout(function () {
            if (!disposer[$mobx$$1].isDisposed) {
                disposer();
                var error = new Error("WHEN_TIMEOUT");
                if (opts.onError)
                    opts.onError(error);
                else
                    throw error;
            }
        }, opts.timeout);
    }
    opts.name = opts.name || "When@" + getNextId$$1();
    var effectAction = createAction$$1(opts.name + "-effect", effect);
    var disposer = autorun$$1(function (r) {
        if (predicate()) {
            r.dispose();
            if (timeoutHandle)
                clearTimeout(timeoutHandle);
            effectAction();
        }
    }, opts);
    return disposer;
}
function whenPromise(predicate, opts) {
    if (false)
        return fail$$1("the options 'onError' and 'promise' cannot be combined");
    var cancel;
    var res = new Promise(function (resolve, reject) {
        var disposer = _when(predicate, resolve, __assign({}, opts, { onError: reject }));
        cancel = function () {
            disposer();
            reject("WHEN_CANCELLED");
        };
    });
    res.cancel = cancel;
    return res;
}

function getAdm(target) {
    return target[$mobx$$1];
}
// Optimization: we don't need the intermediate objects and could have a completely custom administration for DynamicObjects,
// and skip either the internal values map, or the base object with its property descriptors!
var objectProxyTraps = {
    has: function (target, name) {
        if (name === $mobx$$1 || name === "constructor" || name === mobxDidRunLazyInitializersSymbol$$1)
            return true;
        var adm = getAdm(target);
        // MWE: should `in` operator be reactive? If not, below code path will be faster / more memory efficient
        // TODO: check performance stats!
        // if (adm.values.get(name as string)) return true
        if (typeof name === "string")
            return adm.has(name);
        return name in target;
    },
    get: function (target, name) {
        if (name === $mobx$$1 || name === "constructor" || name === mobxDidRunLazyInitializersSymbol$$1)
            return target[name];
        var adm = getAdm(target);
        var observable$$1 = adm.values.get(name);
        if (observable$$1 instanceof Atom$$1)
            return observable$$1.get();
        // make sure we start listening to future keys
        // note that we only do this here for optimization
        if (typeof name === "string")
            adm.has(name);
        return target[name];
    },
    set: function (target, name, value) {
        if (typeof name !== "string")
            return false;
        set$$1(target, name, value);
        return true;
    },
    deleteProperty: function (target, name) {
        if (typeof name !== "string")
            return false;
        var adm = getAdm(target);
        adm.remove(name);
        return true;
    },
    ownKeys: function (target) {
        var adm = getAdm(target);
        adm.keysAtom.reportObserved();
        return Reflect.ownKeys(target);
    },
    preventExtensions: function (target) {
        fail$$1("Dynamic observable objects cannot be frozen");
        return false;
    }
};
function createDynamicObservableObject$$1(base) {
    var proxy = new Proxy(base, objectProxyTraps);
    base[$mobx$$1].proxy = proxy;
    return proxy;
}

function hasInterceptors$$1(interceptable) {
    return interceptable.interceptors !== undefined && interceptable.interceptors.length > 0;
}
function registerInterceptor$$1(interceptable, handler) {
    var interceptors = interceptable.interceptors || (interceptable.interceptors = []);
    interceptors.push(handler);
    return once$$1(function () {
        var idx = interceptors.indexOf(handler);
        if (idx !== -1)
            interceptors.splice(idx, 1);
    });
}
function interceptChange$$1(interceptable, change) {
    var prevU = untrackedStart$$1();
    try {
        var interceptors = interceptable.interceptors;
        if (interceptors)
            for (var i = 0, l = interceptors.length; i < l; i++) {
                change = interceptors[i](change);
                invariant$$1(!change || change.type, "Intercept handlers should return nothing or a change object");
                if (!change)
                    break;
            }
        return change;
    }
    finally {
        untrackedEnd$$1(prevU);
    }
}

function hasListeners$$1(listenable) {
    return listenable.changeListeners !== undefined && listenable.changeListeners.length > 0;
}
function registerListener$$1(listenable, handler) {
    var listeners = listenable.changeListeners || (listenable.changeListeners = []);
    listeners.push(handler);
    return once$$1(function () {
        var idx = listeners.indexOf(handler);
        if (idx !== -1)
            listeners.splice(idx, 1);
    });
}
function notifyListeners$$1(listenable, change) {
    var prevU = untrackedStart$$1();
    var listeners = listenable.changeListeners;
    if (!listeners)
        return;
    listeners = listeners.slice();
    for (var i = 0, l = listeners.length; i < l; i++) {
        listeners[i](change);
    }
    untrackedEnd$$1(prevU);
}

var MAX_SPLICE_SIZE = 10000; // See e.g. https://github.com/mobxjs/mobx/issues/859
var arrayTraps = {
    get: function (target, name) {
        if (name === $mobx$$1)
            return target[$mobx$$1];
        if (name === "length")
            return target[$mobx$$1].getArrayLength();
        if (typeof name === "number") {
            return arrayExtensions.get.call(target, name);
        }
        if (typeof name === "string" && !isNaN(name)) {
            return arrayExtensions.get.call(target, parseInt(name));
        }
        if (arrayExtensions.hasOwnProperty(name)) {
            return arrayExtensions[name];
        }
        return target[name];
    },
    set: function (target, name, value) {
        if (name === "length") {
            target[$mobx$$1].setArrayLength(value);
            return true;
        }
        if (typeof name === "number") {
            arrayExtensions.set.call(target, name, value);
            return true;
        }
        if (!isNaN(name)) {
            arrayExtensions.set.call(target, parseInt(name), value);
            return true;
        }
        return false;
    },
    preventExtensions: function (target) {
        fail$$1("Observable arrays cannot be frozen");
        return false;
    }
};
function createObservableArray$$1(initialValues, enhancer, name, owned) {
    if (name === void 0) { name = "ObservableArray@" + getNextId$$1(); }
    if (owned === void 0) { owned = false; }
    var adm = new ObservableArrayAdministration(name, enhancer, owned);
    addHiddenFinalProp$$1(adm.values, $mobx$$1, adm);
    var proxy = new Proxy(adm.values, arrayTraps);
    adm.proxy = proxy;
    if (initialValues && initialValues.length) {
        var prev = allowStateChangesStart$$1(true);
        adm.spliceWithArray(0, 0, initialValues);
        allowStateChangesEnd$$1(prev);
    }
    return proxy;
}
var ObservableArrayAdministration = /** @class */ (function () {
    function ObservableArrayAdministration(name, enhancer, owned) {
        this.owned = owned;
        this.values = [];
        this.proxy = undefined;
        this.lastKnownLength = 0;
        this.atom = new Atom$$1(name || "ObservableArray@" + getNextId$$1());
        this.enhancer = function (newV, oldV) { return enhancer(newV, oldV, name + "[..]"); };
    }
    ObservableArrayAdministration.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined)
            return this.dehancer(value);
        return value;
    };
    ObservableArrayAdministration.prototype.dehanceValues = function (values$$1) {
        if (this.dehancer !== undefined && this.values.length > 0)
            return values$$1.map(this.dehancer);
        return values$$1;
    };
    ObservableArrayAdministration.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableArrayAdministration.prototype.observe = function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        if (fireImmediately) {
            listener({
                object: this.proxy,
                type: "splice",
                index: 0,
                added: this.values.slice(),
                addedCount: this.values.length,
                removed: [],
                removedCount: 0
            });
        }
        return registerListener$$1(this, listener);
    };
    ObservableArrayAdministration.prototype.getArrayLength = function () {
        this.atom.reportObserved();
        return this.values.length;
    };
    ObservableArrayAdministration.prototype.setArrayLength = function (newLength) {
        if (typeof newLength !== "number" || newLength < 0)
            throw new Error("[mobx.array] Out of range: " + newLength);
        var currentLength = this.values.length;
        if (newLength === currentLength)
            return;
        else if (newLength > currentLength) {
            var newItems = new Array(newLength - currentLength);
            for (var i = 0; i < newLength - currentLength; i++)
                newItems[i] = undefined; // No Array.fill everywhere...
            this.spliceWithArray(currentLength, 0, newItems);
        }
        else
            this.spliceWithArray(newLength, currentLength - newLength);
    };
    ObservableArrayAdministration.prototype.updateArrayLength = function (oldLength, delta) {
        if (oldLength !== this.lastKnownLength)
            throw new Error("[mobx] Modification exception: the internal structure of an observable array was changed.");
        this.lastKnownLength += delta;
    };
    ObservableArrayAdministration.prototype.spliceWithArray = function (index, deleteCount, newItems) {
        var _this = this;
        checkIfStateModificationsAreAllowed$$1(this.atom);
        var length = this.values.length;
        if (index === undefined)
            index = 0;
        else if (index > length)
            index = length;
        else if (index < 0)
            index = Math.max(0, length + index);
        if (arguments.length === 1)
            deleteCount = length - index;
        else if (deleteCount === undefined || deleteCount === null)
            deleteCount = 0;
        else
            deleteCount = Math.max(0, Math.min(deleteCount, length - index));
        if (newItems === undefined)
            newItems = EMPTY_ARRAY$$1;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this.proxy,
                type: "splice",
                index: index,
                removedCount: deleteCount,
                added: newItems
            });
            if (!change)
                return EMPTY_ARRAY$$1;
            deleteCount = change.removedCount;
            newItems = change.added;
        }
        newItems = newItems.length === 0 ? newItems : newItems.map(function (v) { return _this.enhancer(v, undefined); });
        if (false) {
            var lengthDelta = newItems.length - deleteCount;
            this.updateArrayLength(length, lengthDelta); // checks if internal array wasn't modified
        }
        var res = this.spliceItemsIntoValues(index, deleteCount, newItems);
        if (deleteCount !== 0 || newItems.length !== 0)
            this.notifyArraySplice(index, newItems, res);
        return this.dehanceValues(res);
    };
    ObservableArrayAdministration.prototype.spliceItemsIntoValues = function (index, deleteCount, newItems) {
        var _a;
        if (newItems.length < MAX_SPLICE_SIZE) {
            return (_a = this.values).splice.apply(_a, __spread([index, deleteCount], newItems));
        }
        else {
            var res = this.values.slice(index, index + deleteCount);
            this.values = this.values
                .slice(0, index)
                .concat(newItems, this.values.slice(index + deleteCount));
            return res;
        }
    };
    ObservableArrayAdministration.prototype.notifyArrayChildUpdate = function (index, newValue, oldValue) {
        var notifySpy = !this.owned && isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "update",
                index: index,
                newValue: newValue,
                oldValue: oldValue
            }
            : null;
        // The reason why this is on right hand side here (and not above), is this way the uglifier will drop it, but it won't
        // cause any runtime overhead in development mode without NODE_ENV set, unless spying is enabled
        if (notifySpy && "production" !== "production")
            spyReportStart$$1(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd$$1();
    };
    ObservableArrayAdministration.prototype.notifyArraySplice = function (index, added, removed) {
        var notifySpy = !this.owned && isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                object: this.proxy,
                type: "splice",
                index: index,
                removed: removed,
                added: added,
                removedCount: removed.length,
                addedCount: added.length
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart$$1(__assign({}, change, { name: this.atom.name }));
        this.atom.reportChanged();
        // conform: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/observe
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd$$1();
    };
    return ObservableArrayAdministration;
}());
var arrayExtensions = {
    intercept: function (handler) {
        return this[$mobx$$1].intercept(handler);
    },
    observe: function (listener, fireImmediately) {
        if (fireImmediately === void 0) { fireImmediately = false; }
        var adm = this[$mobx$$1];
        return adm.observe(listener, fireImmediately);
    },
    clear: function () {
        return this.splice(0);
    },
    replace: function (newItems) {
        var adm = this[$mobx$$1];
        return adm.spliceWithArray(0, adm.values.length, newItems);
    },
    /**
     * Converts this array back to a (shallow) javascript structure.
     * For a deep clone use mobx.toJS
     */
    toJS: function () {
        return this.slice();
    },
    toJSON: function () {
        // Used by JSON.stringify
        return this.toJS();
    },
    /*
     * functions that do alter the internal structure of the array, (based on lib.es6.d.ts)
     * since these functions alter the inner structure of the array, the have side effects.
     * Because the have side effects, they should not be used in computed function,
     * and for that reason the do not call dependencyState.notifyObserved
     */
    splice: function (index, deleteCount) {
        var newItems = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            newItems[_i - 2] = arguments[_i];
        }
        var adm = this[$mobx$$1];
        switch (arguments.length) {
            case 0:
                return [];
            case 1:
                return adm.spliceWithArray(index);
            case 2:
                return adm.spliceWithArray(index, deleteCount);
        }
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    spliceWithArray: function (index, deleteCount, newItems) {
        var adm = this[$mobx$$1];
        return adm.spliceWithArray(index, deleteCount, newItems);
    },
    push: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx$$1];
        adm.spliceWithArray(adm.values.length, 0, items);
        return adm.values.length;
    },
    pop: function () {
        return this.splice(Math.max(this[$mobx$$1].values.length - 1, 0), 1)[0];
    },
    shift: function () {
        return this.splice(0, 1)[0];
    },
    unshift: function () {
        var items = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            items[_i] = arguments[_i];
        }
        var adm = this[$mobx$$1];
        adm.spliceWithArray(0, 0, items);
        return adm.values.length;
    },
    reverse: function () {
        // reverse by default mutates in place before returning the result
        // which makes it both a 'derivation' and a 'mutation'.
        // so we deviate from the default and just make it an dervitation
        if (false) {
            console.warn("[mobx] `observableArray.reverse()` will not update the array in place. Use `observableArray.slice().reverse()` to supress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().reverse())` to reverse & update in place");
        }
        var clone = this.slice();
        return clone.reverse.apply(clone, arguments);
    },
    sort: function (compareFn) {
        // sort by default mutates in place before returning the result
        // which goes against all good practices. Let's not change the array in place!
        if (false) {
            console.warn("[mobx] `observableArray.sort()` will not update the array in place. Use `observableArray.slice().sort()` to supress this warning and perform the operation on a copy, or `observableArray.replace(observableArray.slice().sort())` to sort & update in place");
        }
        var clone = this.slice();
        return clone.sort.apply(clone, arguments);
    },
    remove: function (value) {
        var adm = this[$mobx$$1];
        var idx = adm.dehanceValues(adm.values).indexOf(value);
        if (idx > -1) {
            this.splice(idx, 1);
            return true;
        }
        return false;
    },
    get: function (index) {
        var adm = this[$mobx$$1];
        if (adm) {
            if (index < adm.values.length) {
                adm.atom.reportObserved();
                return adm.dehanceValue(adm.values[index]);
            }
            console.warn("[mobx.array] Attempt to read an array index (" + index + ") that is out of bounds (" + adm.values.length + "). Please check length first. Out of bound indices will not be tracked by MobX");
        }
        return undefined;
    },
    set: function (index, newValue) {
        var adm = this[$mobx$$1];
        var values$$1 = adm.values;
        if (index < values$$1.length) {
            // update at index in range
            checkIfStateModificationsAreAllowed$$1(adm.atom);
            var oldValue = values$$1[index];
            if (hasInterceptors$$1(adm)) {
                var change = interceptChange$$1(adm, {
                    type: "update",
                    object: this,
                    index: index,
                    newValue: newValue
                });
                if (!change)
                    return;
                newValue = change.newValue;
            }
            newValue = adm.enhancer(newValue, oldValue);
            var changed = newValue !== oldValue;
            if (changed) {
                values$$1[index] = newValue;
                adm.notifyArrayChildUpdate(index, newValue, oldValue);
            }
        }
        else if (index === values$$1.length) {
            // add a new item
            adm.spliceWithArray(index, 0, [newValue]);
        }
        else {
            // out of bounds
            throw new Error("[mobx.array] Index out of bounds, " + index + " is larger than " + values$$1.length);
        }
    }
};
[
    "concat",
    "every",
    "filter",
    "forEach",
    "indexOf",
    "join",
    "lastIndexOf",
    "map",
    "reduce",
    "reduceRight",
    "slice",
    "some",
    "toString",
    "toLocaleString"
].forEach(function (funcName) {
    arrayExtensions[funcName] = function () {
        var adm = this[$mobx$$1];
        adm.atom.reportObserved();
        var res = adm.dehanceValues(adm.values);
        return res[funcName].apply(res, arguments);
    };
});
var isObservableArrayAdministration = createInstanceofPredicate$$1("ObservableArrayAdministration", ObservableArrayAdministration);
function isObservableArray$$1(thing) {
    return isObject$$1(thing) && isObservableArrayAdministration(thing[$mobx$$1]);
}

var _a;
var ObservableMapMarker = {};
// just extend Map? See also https://gist.github.com/nestharus/13b4d74f2ef4a2f4357dbd3fc23c1e54
// But: https://github.com/mobxjs/mobx/issues/1556
var ObservableMap$$1 = /** @class */ (function () {
    function ObservableMap$$1(initialData, enhancer, name) {
        if (enhancer === void 0) { enhancer = deepEnhancer$$1; }
        if (name === void 0) { name = "ObservableMap@" + getNextId$$1(); }
        this.enhancer = enhancer;
        this.name = name;
        this[_a] = ObservableMapMarker;
        this._keysAtom = createAtom$$1(this.name + ".keys()");
        this[Symbol.toStringTag] = "Map";
        if (typeof Map !== "function") {
            throw new Error("mobx.map requires Map polyfill for the current browser. Check babel-polyfill or core-js/es6/map.js");
        }
        this._data = new Map();
        this._hasMap = new Map();
        this.merge(initialData);
    }
    ObservableMap$$1.prototype._has = function (key) {
        return this._data.has(key);
    };
    ObservableMap$$1.prototype.has = function (key) {
        if (this._hasMap.has(key))
            return this._hasMap.get(key).get();
        return this._updateHasMapEntry(key, false).get();
    };
    ObservableMap$$1.prototype.set = function (key, value) {
        var hasKey = this._has(key);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: hasKey ? "update" : "add",
                object: this,
                newValue: value,
                name: key
            });
            if (!change)
                return this;
            value = change.newValue;
        }
        if (hasKey) {
            this._updateValue(key, value);
        }
        else {
            this._addValue(key, value);
        }
        return this;
    };
    ObservableMap$$1.prototype.delete = function (key) {
        var _this = this;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "delete",
                object: this,
                name: key
            });
            if (!change)
                return false;
        }
        if (this._has(key)) {
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "delete",
                    object: this,
                    oldValue: this._data.get(key).value,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
            transaction$$1(function () {
                _this._keysAtom.reportChanged();
                _this._updateHasMapEntry(key, false);
                var observable$$1 = _this._data.get(key);
                observable$$1.setNewValue(undefined);
                _this._data.delete(key);
            });
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd$$1();
            return true;
        }
        return false;
    };
    ObservableMap$$1.prototype._updateHasMapEntry = function (key, value) {
        // optimization; don't fill the hasMap if we are not observing, or remove entry if there are no observers anymore
        var entry = this._hasMap.get(key);
        if (entry) {
            entry.setNewValue(value);
        }
        else {
            entry = new ObservableValue$$1(value, referenceEnhancer$$1, this.name + "." + key + "?", false);
            this._hasMap.set(key, entry);
        }
        return entry;
    };
    ObservableMap$$1.prototype._updateValue = function (key, newValue) {
        var observable$$1 = this._data.get(key);
        newValue = observable$$1.prepareNewValue(newValue);
        if (newValue !== UNCHANGED$$1) {
            var notifySpy = isSpyEnabled$$1();
            var notify = hasListeners$$1(this);
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this,
                    oldValue: observable$$1.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd$$1();
        }
    };
    ObservableMap$$1.prototype._addValue = function (key, newValue) {
        var _this = this;
        checkIfStateModificationsAreAllowed$$1(this._keysAtom);
        transaction$$1(function () {
            var observable$$1 = new ObservableValue$$1(newValue, _this.enhancer, _this.name + "." + key, false);
            _this._data.set(key, observable$$1);
            newValue = observable$$1.value; // value might have been changed
            _this._updateHasMapEntry(key, true);
            _this._keysAtom.reportChanged();
        });
        var notifySpy = isSpyEnabled$$1();
        var notify = hasListeners$$1(this);
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd$$1();
    };
    ObservableMap$$1.prototype.get = function (key) {
        if (this.has(key))
            return this.dehanceValue(this._data.get(key).get());
        return this.dehanceValue(undefined);
    };
    ObservableMap$$1.prototype.dehanceValue = function (value) {
        if (this.dehancer !== undefined) {
            return this.dehancer(value);
        }
        return value;
    };
    ObservableMap$$1.prototype.keys = function () {
        this._keysAtom.reportObserved();
        return this._data.keys();
    };
    ObservableMap$$1.prototype.values = function () {
        var self = this;
        var nextIndex = 0;
        var keys$$1 = Array.from(this.keys());
        return makeIterable({
            next: function () {
                return nextIndex < keys$$1.length
                    ? { value: self.get(keys$$1[nextIndex++]), done: false }
                    : { done: true };
            }
        });
    };
    ObservableMap$$1.prototype.entries = function () {
        var self = this;
        var nextIndex = 0;
        var keys$$1 = Array.from(this.keys());
        return makeIterable({
            next: function () {
                if (nextIndex < keys$$1.length) {
                    var key = keys$$1[nextIndex++];
                    return {
                        value: [key, self.get(key)],
                        done: false
                    };
                }
                return { done: true };
            }
        });
    };
    ObservableMap$$1.prototype[(_a = $mobx$$1, Symbol.iterator)] = function () {
        return this.entries();
    };
    ObservableMap$$1.prototype.forEach = function (callback, thisArg) {
        var e_1, _a;
        try {
            for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                callback.call(thisArg, value, key, this);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /** Merge another object into this object, returns this. */
    ObservableMap$$1.prototype.merge = function (other) {
        var _this = this;
        if (isObservableMap$$1(other)) {
            other = other.toJS();
        }
        transaction$$1(function () {
            if (isPlainObject$$1(other))
                Object.keys(other).forEach(function (key) { return _this.set(key, other[key]); });
            else if (Array.isArray(other))
                other.forEach(function (_a) {
                    var _b = __read(_a, 2), key = _b[0], value = _b[1];
                    return _this.set(key, value);
                });
            else if (isES6Map$$1(other))
                other.forEach(function (value, key) { return _this.set(key, value); });
            else if (other !== null && other !== undefined)
                fail$$1("Cannot initialize map from " + other);
        });
        return this;
    };
    ObservableMap$$1.prototype.clear = function () {
        var _this = this;
        transaction$$1(function () {
            untracked$$1(function () {
                var e_2, _a;
                try {
                    for (var _b = __values(_this.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var key = _c.value;
                        _this.delete(key);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            });
        });
    };
    ObservableMap$$1.prototype.replace = function (values$$1) {
        var _this = this;
        transaction$$1(function () {
            // grab all the keys that are present in the new map but not present in the current map
            // and delete them from the map, then merge the new map
            // this will cause reactions only on changed values
            var newKeys = getMapLikeKeys$$1(values$$1);
            var oldKeys = Array.from(_this.keys());
            var missingKeys = oldKeys.filter(function (k) { return newKeys.indexOf(k) === -1; });
            missingKeys.forEach(function (k) { return _this.delete(k); });
            _this.merge(values$$1);
        });
        return this;
    };
    Object.defineProperty(ObservableMap$$1.prototype, "size", {
        get: function () {
            this._keysAtom.reportObserved();
            return this._data.size;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a plain object that represents this map.
     * Note that all the keys being stringified.
     * If there are duplicating keys after converting them to strings, behaviour is undetermined.
     */
    ObservableMap$$1.prototype.toPOJO = function () {
        var e_3, _a;
        var res = {};
        try {
            for (var _b = __values(this), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                res["" + key] = value;
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return res;
    };
    /**
     * Returns a shallow non observable object clone of this map.
     * Note that the values migth still be observable. For a deep clone use mobx.toJS.
     */
    ObservableMap$$1.prototype.toJS = function () {
        return new Map(this);
    };
    ObservableMap$$1.prototype.toJSON = function () {
        // Used by JSON.stringify
        return this.toPOJO();
    };
    ObservableMap$$1.prototype.toString = function () {
        var _this = this;
        return (this.name +
            "[{ " +
            Array.from(this.keys())
                .map(function (key) { return key + ": " + ("" + _this.get(key)); })
                .join(", ") +
            " }]");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableMap$$1.prototype.observe = function (listener, fireImmediately) {
        "production" !== "production" &&
            invariant$$1(fireImmediately !== true, "`observe` doesn't support fireImmediately=true in combination with maps.");
        return registerListener$$1(this, listener);
    };
    ObservableMap$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    return ObservableMap$$1;
}());
/* 'var' fixes small-build issue */
var isObservableMap$$1 = createInstanceofPredicate$$1("ObservableMap", ObservableMap$$1);

var ObservableObjectAdministration$$1 = /** @class */ (function () {
    function ObservableObjectAdministration$$1(target, values$$1, name, defaultEnhancer) {
        if (values$$1 === void 0) { values$$1 = new Map(); }
        this.target = target;
        this.values = values$$1;
        this.name = name;
        this.defaultEnhancer = defaultEnhancer;
        this.keysAtom = new Atom$$1(name + ".keys");
    }
    ObservableObjectAdministration$$1.prototype.read = function (key) {
        return this.values.get(key).get();
    };
    ObservableObjectAdministration$$1.prototype.write = function (key, newValue) {
        var instance = this.target;
        var observable$$1 = this.values.get(key);
        if (observable$$1 instanceof ComputedValue$$1) {
            observable$$1.set(newValue);
            return;
        }
        // intercept
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                type: "update",
                object: this.proxy || instance,
                name: key,
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        newValue = observable$$1.prepareNewValue(newValue);
        // notify spy & observers
        if (newValue !== UNCHANGED$$1) {
            var notify = hasListeners$$1(this);
            var notifySpy = isSpyEnabled$$1();
            var change = notify || notifySpy
                ? {
                    type: "update",
                    object: this.proxy || instance,
                    oldValue: observable$$1.value,
                    name: key,
                    newValue: newValue
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
            observable$$1.setNewValue(newValue);
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd$$1();
        }
    };
    ObservableObjectAdministration$$1.prototype.has = function (key) {
        var map = this.pendingKeys || (this.pendingKeys = new Map());
        var entry = map.get(key);
        if (entry)
            return entry.get();
        else {
            var exists = !!this.values.get(key);
            // Possible optimization: Don't have a separate map for non existing keys,
            // but store them in the values map instead, using a special symbol to denote "not existing"
            entry = new ObservableValue$$1(exists, referenceEnhancer$$1, this.name + "." + key.toString() + "?", false);
            map.set(key, entry);
            return entry.get(); // read to subscribe
        }
    };
    ObservableObjectAdministration$$1.prototype.addObservableProp = function (propName, newValue, enhancer) {
        if (enhancer === void 0) { enhancer = this.defaultEnhancer; }
        var target = this.target;
        assertPropertyConfigurable$$1(target, propName);
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this.proxy || target,
                name: propName,
                type: "add",
                newValue: newValue
            });
            if (!change)
                return;
            newValue = change.newValue;
        }
        var observable$$1 = new ObservableValue$$1(newValue, enhancer, this.name + "." + propName, false);
        this.values.set(propName, observable$$1);
        newValue = observable$$1.value; // observableValue might have changed it
        Object.defineProperty(target, propName, generateObservablePropConfig$$1(propName));
        this.notifyPropertyAddition(propName, newValue);
    };
    ObservableObjectAdministration$$1.prototype.addComputedProp = function (propertyOwner, // where is the property declared?
    propName, options) {
        var target = this.target;
        options.name = options.name || this.name + "." + propName;
        this.values.set(propName, new ComputedValue$$1(options));
        if (propertyOwner === target || isPropertyConfigurable$$1(propertyOwner, propName))
            Object.defineProperty(propertyOwner, propName, generateComputedPropConfig$$1(propName));
    };
    ObservableObjectAdministration$$1.prototype.remove = function (key) {
        if (!this.values.has(key))
            return;
        var target = this.target;
        if (hasInterceptors$$1(this)) {
            var change = interceptChange$$1(this, {
                object: this.proxy || target,
                name: key,
                type: "remove"
            });
            if (!change)
                return;
        }
        try {
            startBatch$$1();
            var notify = hasListeners$$1(this);
            var notifySpy = isSpyEnabled$$1();
            var oldObservable = this.values.get(key);
            var oldValue = oldObservable && oldObservable.get();
            oldObservable && oldObservable.set(undefined);
            // notify key and keyset listeners
            this.keysAtom.reportChanged();
            this.values.delete(key);
            if (this.pendingKeys) {
                var entry = this.pendingKeys.get(key);
                if (entry)
                    entry.set(false);
            }
            // delete the prop
            delete this.target[key];
            var change = notify || notifySpy
                ? {
                    type: "remove",
                    object: this.proxy || target,
                    oldValue: oldValue,
                    name: key
                }
                : null;
            if (notifySpy && "production" !== "production")
                spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
            if (notify)
                notifyListeners$$1(this, change);
            if (notifySpy && "production" !== "production")
                spyReportEnd$$1();
        }
        finally {
            endBatch$$1();
        }
    };
    ObservableObjectAdministration$$1.prototype.illegalAccess = function (owner, propName) {
        /**
         * This happens if a property is accessed through the prototype chain, but the property was
         * declared directly as own property on the prototype.
         *
         * E.g.:
         * class A {
         * }
         * extendObservable(A.prototype, { x: 1 })
         *
         * classB extens A {
         * }
         * console.log(new B().x)
         *
         * It is unclear whether the property should be considered 'static' or inherited.
         * Either use `console.log(A.x)`
         * or: decorate(A, { x: observable })
         *
         * When using decorate, the property will always be redeclared as own property on the actual instance
         */
        console.warn("Property '" + propName + "' of '" + owner + "' was accessed through the prototype chain. Use 'decorate' instead to declare the prop or access it statically through it's owner");
    };
    /**
     * Observes this object. Triggers for the events 'add', 'update' and 'delete'.
     * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/observe
     * for callback details
     */
    ObservableObjectAdministration$$1.prototype.observe = function (callback, fireImmediately) {
        "production" !== "production" &&
            invariant$$1(fireImmediately !== true, "`observe` doesn't support the fire immediately property for observable objects.");
        return registerListener$$1(this, callback);
    };
    ObservableObjectAdministration$$1.prototype.intercept = function (handler) {
        return registerInterceptor$$1(this, handler);
    };
    ObservableObjectAdministration$$1.prototype.notifyPropertyAddition = function (key, newValue) {
        var notify = hasListeners$$1(this);
        var notifySpy = isSpyEnabled$$1();
        var change = notify || notifySpy
            ? {
                type: "add",
                object: this.proxy || this.target,
                name: key,
                newValue: newValue
            }
            : null;
        if (notifySpy && "production" !== "production")
            spyReportStart$$1(__assign({}, change, { name: this.name, key: key }));
        if (notify)
            notifyListeners$$1(this, change);
        if (notifySpy && "production" !== "production")
            spyReportEnd$$1();
        if (this.pendingKeys) {
            var entry = this.pendingKeys.get(key);
            if (entry)
                entry.set(true);
        }
        this.keysAtom.reportChanged();
    };
    ObservableObjectAdministration$$1.prototype.getKeys = function () {
        var e_1, _a;
        this.keysAtom.reportObserved();
        // return Reflect.ownKeys(this.values) as any
        var res = [];
        try {
            for (var _b = __values(this.values), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
                if (value instanceof ObservableValue$$1)
                    res.push(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return res;
    };
    return ObservableObjectAdministration$$1;
}());
function asObservableObject$$1(target, name, defaultEnhancer) {
    if (name === void 0) { name = ""; }
    if (defaultEnhancer === void 0) { defaultEnhancer = deepEnhancer$$1; }
    if (Object.prototype.hasOwnProperty.call(target, $mobx$$1))
        return target[$mobx$$1];
    "production" !== "production" &&
        invariant$$1(Object.isExtensible(target), "Cannot make the designated object observable; it is not extensible");
    if (!isPlainObject$$1(target))
        name = (target.constructor.name || "ObservableObject") + "@" + getNextId$$1();
    if (!name)
        name = "ObservableObject@" + getNextId$$1();
    var adm = new ObservableObjectAdministration$$1(target, new Map(), name, defaultEnhancer);
    addHiddenProp$$1(target, $mobx$$1, adm);
    return adm;
}
var observablePropertyConfigs = Object.create(null);
var computedPropertyConfigs = Object.create(null);
function generateObservablePropConfig$$1(propName) {
    return (observablePropertyConfigs[propName] ||
        (observablePropertyConfigs[propName] = {
            configurable: true,
            enumerable: true,
            get: function () {
                return this[$mobx$$1].read(propName);
            },
            set: function (v) {
                this[$mobx$$1].write(propName, v);
            }
        }));
}
function getAdministrationForComputedPropOwner(owner) {
    var adm = owner[$mobx$$1];
    if (!adm) {
        // because computed props are declared on proty,
        // the current instance might not have been initialized yet
        initializeInstance$$1(owner);
        return owner[$mobx$$1];
    }
    return adm;
}
function generateComputedPropConfig$$1(propName) {
    return (computedPropertyConfigs[propName] ||
        (computedPropertyConfigs[propName] = {
            configurable: true,
            enumerable: false,
            get: function () {
                return getAdministrationForComputedPropOwner(this).read(propName);
            },
            set: function (v) {
                getAdministrationForComputedPropOwner(this).write(propName, v);
            }
        }));
}
var isObservableObjectAdministration = createInstanceofPredicate$$1("ObservableObjectAdministration", ObservableObjectAdministration$$1);
function isObservableObject$$1(thing) {
    if (isObject$$1(thing)) {
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance$$1(thing);
        return isObservableObjectAdministration(thing[$mobx$$1]);
    }
    return false;
}

function getAtom$$1(thing, property) {
    if (typeof thing === "object" && thing !== null) {
        if (isObservableArray$$1(thing)) {
            if (property !== undefined)
                fail$$1("production" !== "production" &&
                    "It is not possible to get index atoms from arrays");
            return thing[$mobx$$1].atom;
        }
        if (isObservableMap$$1(thing)) {
            var anyThing = thing;
            if (property === undefined)
                return anyThing._keysAtom;
            var observable$$1 = anyThing._data.get(property) || anyThing._hasMap.get(property);
            if (!observable$$1)
                fail$$1("production" !== "production" &&
                    "the entry '" + property + "' does not exist in the observable map '" + getDebugName$$1(thing) + "'");
            return observable$$1;
        }
        // Initializers run lazily when transpiling to babel, so make sure they are run...
        initializeInstance$$1(thing);
        if (property && !thing[$mobx$$1])
            thing[property]; // See #1072
        if (isObservableObject$$1(thing)) {
            if (!property)
                return fail$$1("production" !== "production" && "please specify a property");
            var observable$$1 = thing[$mobx$$1].values.get(property);
            if (!observable$$1)
                fail$$1("production" !== "production" &&
                    "no observable property '" + property + "' found on the observable object '" + getDebugName$$1(thing) + "'");
            return observable$$1;
        }
        if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing)) {
            return thing;
        }
    }
    else if (typeof thing === "function") {
        if (isReaction$$1(thing[$mobx$$1])) {
            // disposer function
            return thing[$mobx$$1];
        }
    }
    return fail$$1("production" !== "production" && "Cannot obtain atom from " + thing);
}
function getAdministration$$1(thing, property) {
    if (!thing)
        fail$$1("Expecting some object");
    if (property !== undefined)
        return getAdministration$$1(getAtom$$1(thing, property));
    if (isAtom$$1(thing) || isComputedValue$$1(thing) || isReaction$$1(thing))
        return thing;
    if (isObservableMap$$1(thing))
        return thing;
    // Initializers run lazily when transpiling to babel, so make sure they are run...
    initializeInstance$$1(thing);
    if (thing[$mobx$$1])
        return thing[$mobx$$1];
    fail$$1("production" !== "production" && "Cannot obtain administration from " + thing);
}
function getDebugName$$1(thing, property) {
    var named;
    if (property !== undefined)
        named = getAtom$$1(thing, property);
    else if (isObservableObject$$1(thing) || isObservableMap$$1(thing))
        named = getAdministration$$1(thing);
    else
        named = getAtom$$1(thing); // valid for arrays as well
    return named.name;
}

var toString = Object.prototype.toString;
function deepEqual$$1(a, b) {
    return eq(a, b);
}
// Copied from https://github.com/jashkenas/underscore/blob/5c237a7c682fb68fd5378203f0bf22dce1624854/underscore.js#L1186-L1289
// Internal recursive comparison function for `isEqual`.
function eq(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b)
        return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null)
        return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a)
        return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== "function" && type !== "object" && typeof b != "object")
        return false;
    return deepEq(a, b, aStack, bStack);
}
// Internal recursive comparison function for `isEqual`.
function deepEq(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    a = unwrap(a);
    b = unwrap(b);
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b))
        return false;
    switch (className) {
        // Strings, numbers, regular expressions, dates, and booleans are compared by value.
        case "[object RegExp]":
        // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
        case "[object String]":
            // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
            // equivalent to `new String("5")`.
            return "" + a === "" + b;
        case "[object Number]":
            // `NaN`s are equivalent, but non-reflexive.
            // Object(NaN) is equivalent to NaN.
            if (+a !== +a)
                return +b !== +b;
            // An `egal` comparison is performed for other numeric values.
            return +a === 0 ? 1 / +a === 1 / b : +a === +b;
        case "[object Date]":
        case "[object Boolean]":
            // Coerce dates and booleans to numeric primitive values. Dates are compared by their
            // millisecond representations. Note that invalid dates with millisecond representations
            // of `NaN` are not equivalent.
            return +a === +b;
        case "[object Symbol]":
            return (typeof Symbol !== "undefined" && Symbol.valueOf.call(a) === Symbol.valueOf.call(b));
    }
    var areArrays = className === "[object Array]";
    if (!areArrays) {
        if (typeof a != "object" || typeof b != "object")
            return false;
        // Objects with different constructors are not equivalent, but `Object`s or `Array`s
        // from different frames are.
        var aCtor = a.constructor, bCtor = b.constructor;
        if (aCtor !== bCtor &&
            !(typeof aCtor === "function" &&
                aCtor instanceof aCtor &&
                typeof bCtor === "function" &&
                bCtor instanceof bCtor) &&
            ("constructor" in a && "constructor" in b)) {
            return false;
        }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
        // Linear search. Performance is inversely proportional to the number of
        // unique nested structures.
        if (aStack[length] === a)
            return bStack[length] === b;
    }
    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);
    // Recursively compare objects and arrays.
    if (areArrays) {
        // Compare array lengths to determine if a deep comparison is necessary.
        length = a.length;
        if (length !== b.length)
            return false;
        // Deep compare the contents, ignoring non-numeric properties.
        while (length--) {
            if (!eq(a[length], b[length], aStack, bStack))
                return false;
        }
    }
    else {
        // Deep compare objects.
        var keys$$1 = Object.keys(a), key;
        length = keys$$1.length;
        // Ensure that both objects contain the same number of properties before comparing deep equality.
        if (Object.keys(b).length !== length)
            return false;
        while (length--) {
            // Deep compare each member
            key = keys$$1[length];
            if (!(has$1(b, key) && eq(a[key], b[key], aStack, bStack)))
                return false;
        }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
}
function unwrap(a) {
    if (isObservableArray$$1(a))
        return a.slice();
    if (isES6Map$$1(a) || isObservableMap$$1(a))
        return Array.from(a.entries());
    return a;
}
function has$1(a, key) {
    return Object.prototype.hasOwnProperty.call(a, key);
}

function makeIterable(iterator) {
    iterator[Symbol.iterator] = self;
    return iterator;
}
function self() {
    return this;
}

/*
The only reason for this file to exist is pure horror:
Without it rollup can make the bundling fail at any point in time; when it rolls up the files in the wrong order
it will cause undefined errors (for example because super classes or local variables not being hosted).
With this file that will still happen,
but at least in this file we can magically reorder the imports with trial and error until the build succeeds again.
*/

/**
 * (c) Michel Weststrate 2015 - 2018
 * MIT Licensed
 *
 * Welcome to the mobx sources! To get an global overview of how MobX internally works,
 * this is a good place to start:
 * https://medium.com/@mweststrate/becoming-fully-reactive-an-in-depth-explanation-of-mobservable-55995262a254#.xvbh6qd74
 *
 * Source folders:
 * ===============
 *
 * - api/     Most of the public static methods exposed by the module can be found here.
 * - core/    Implementation of the MobX algorithm; atoms, derivations, reactions, dependency trees, optimizations. Cool stuff can be found here.
 * - types/   All the magic that is need to have observable objects, arrays and values is in this folder. Including the modifiers like `asFlat`.
 * - utils/   Utility stuff.
 *
 */
if (typeof Proxy === "undefined" || typeof Symbol === "undefined") {
    throw new Error("[mobx] MobX 5+ requires Proxy and Symbol objects. If your environment doesn't support Proxy objects, please downgrade to MobX 4. For React Native Android, consider upgrading JSCore.");
}
try {
    // define process.env if needed
    // if this is not a production build in the first place
    // (in which case the expression below would be substituted with 'production')
    "production";
}
catch (e) {
    var g = typeof window !== "undefined" ? window : global;
    if (typeof process === "undefined")
        g.process = {};
    g.process.env = {};
}

(function () {
    function testCodeMinification() { }
    if (testCodeMinification.name !== "testCodeMinification" &&
        "production" !== "production") {
        console.warn(
        // Template literal(backtick) is used for fix issue with rollup-plugin-commonjs https://github.com/rollup/rollup-plugin-commonjs/issues/344
        "[mobx] you are running a minified build, but 'process.env.NODE_ENV' was not set to 'production' in your bundler. This results in an unnecessarily large and slow bundle");
    }
})();
// Devtools support
if (typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ === "object") {
    // See: https://github.com/andykog/mobx-devtools/
    __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: spy$$1,
        extras: {
            getDebugName: getDebugName$$1
        },
        $mobx: $mobx$$1
    });
}



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(47), __webpack_require__(6)))

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var showKey={murongziying:"murongziying",kobe:"kobe",wusheng:"wusheng",xzNot:"xzNot",xzing:"xzing",xzSuccess:"xzSuccess",xzWarning:"xzWarning",xzError:"xzError"};/* harmony default export */ __webpack_exports__["a"] = (showKey);

/***/ }),
/* 6 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(16);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(21);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var executeKey={not:"not",doing:"doing",success:"success",warning:"warning",error:"error"};/* harmony default export */ __webpack_exports__["a"] = (executeKey);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var styleKey={hide:"hide",toastPrimary:"toastPrimary",toastSuccess:"toastSuccess",toastWarning:"toastWarning",toastError:"toastError",inputButtonPrimary:"inputButtonPrimary",inputButtonSuccess:"inputButtonSuccess",inputButtonWarning:"inputButtonWarning",inputButtonError:"inputButtonError"};/* harmony default export */ __webpack_exports__["a"] = (styleKey);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
var _class,_temp,_this=this;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DataTools=(_temp=_class=function DataTools(){_classCallCheck(this,DataTools);this.randomCount=function(count){var myRandom=Math.random()*count;for(var i=1;i<=count;i++){if(myRandom<=i){return i-1;}}};this.convertInputToObject=function(input){var inputArray=input.toLowerCase().trim().split(/\s+/);for(var i=0;i<inputArray.length;i++){inputArray[i]=inputArray[i].replace(/-/g," ");}var standardInput={type:"",arguments:[]};if(inputArray.length===0){return standardInput;}else if(inputArray.length===1){if(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].openArgument.has(inputArray[0])){standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.open;standardInput.arguments.push(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].openArgument.get(inputArray[0]));}else if(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputType.has(inputArray[0])){standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputType.get(inputArray[0]);}else if(inputArray[0]===""){}else{standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.search;standardInput.arguments.push(inputArray[0]);}return standardInput;}else{if(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputType.has(inputArray[0])){standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputType.get(inputArray[0]);standardInput.arguments=inputArray.slice(1);if(standardInput.type===__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.open){standardInput.arguments=[];for(var _i=1;_i<inputArray.length;_i++){if(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].openArgument.has(inputArray[_i])){standardInput.arguments.push(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].openArgument.get(inputArray[_i]));break;}}if(standardInput.arguments.length===0){standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.search;standardInput.arguments=inputArray.slice(1);standardInput.lastType=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.open;}}}else{standardInput.type=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.search;standardInput.arguments=inputArray.slice(0);}return standardInput;}};this.addEffectToStandardInput=function(standardInput,defaultValue){var tempStandardInput={};tempStandardInput.type=standardInput.type;tempStandardInput.arguments=standardInput.arguments;if(typeof standardInput.lastType!=='undefined')tempStandardInput.lastType=standardInput.lastType;switch(standardInput.type){case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.open:tempStandardInput.effect=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.open;break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.search:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.search);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.video:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.video);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.music:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.music);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.mv:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.mv);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.play:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.play);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.wiki:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.wiki);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.question:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.question);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.news:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.news);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playMv:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playMv);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.buy:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.buy);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.code:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.code);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.airticket:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.airticket);break;case __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.trainticket:tempStandardInput.effect=defaultValue.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.trainticket);break;default:tempStandardInput.effect=tempStandardInput.type;break;}return tempStandardInput;};this.convertAsyncDataToEffect=function(data){var effect={url:"",errorInfo:data.errorCount};effect.keys="";if(data.type===__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusic){handleQQMusicEffect(data);}else if(data.type===__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusicMv){handleQQMusicMvEffect(data);}return effect;function handleQQMusicMvEffect(data){var songs=data.songs;console.log(songs);var songData={nameList:[],songList:[]};var singerData={nameList:[],songList:[],hotSongList:[]// 如果有无效字符，剔除
};for(var i=0;i<songs.length;i++){if(songs[i].message!==""){songs.splice(i,1);effect.errorInfo.push(i);i--;}}// 如果无有效输入，不执行操作
if(songs.length===0){return;}// 遍历所有有效数据，把数据按歌手和歌曲分类
for(var _i2=0;_i2<songs.length;_i2++){// 关键字非歌手
if(typeof songs[_i2].data.zhida.list==='undefined'){if(typeof songs[_i2].data.zhida.zhida_singer==='undefined'){var songListValue=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=songs[_i2].data.song.list[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var list=_step.value;songListValue.push({songName:list.name,songMid:list.mid,singer:list.singer,mvMid:list.mv.vid});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}songData.nameList.push(songs[_i2].data.song.list[0].name);songData.songList.push(songListValue);}// 关键字是歌手
else{var _songListValue=[];var hotSongListValue=[];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=songs[_i2].data.song.list[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _list=_step2.value;_songListValue.push({songName:_list.name,songMid:_list.mid,singer:_list.singer,mvMid:_list.mv.vid});}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=songs[_i2].data.zhida.zhida_singer.hotsong[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var hotSong=_step3.value;hotSongListValue.push({songMid:hotSong.songMID,songName:hotSong.songName});}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}singerData.nameList.push(songs[_i2].data.zhida.zhida_singer.singerName);singerData.songList.push(_songListValue);singerData.hotSongList.push(hotSongListValue);}}else{if(songs[_i2].data.zhida.list.length===0||typeof songs[_i2].data.zhida.list[0].zhida_singer==='undefined'){var _songListValue2=[];var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=songs[_i2].data.song.list[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _list2=_step4.value;_songListValue2.push({songName:_list2.name,songMid:_list2.mid,singer:_list2.singer,mvMid:_list2.mv.vid});}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}songData.nameList.push(songs[_i2].data.song.list[0].name);songData.songList.push(_songListValue2);}// 关键字是歌手
else{var _songListValue3=[];var _hotSongListValue=[];var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=songs[_i2].data.song.list[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var _list3=_step5.value;_songListValue3.push({songName:_list3.name,songMid:_list3.mid,singer:_list3.singer,mvMid:_list3.mv.vid});}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}var _iteratorNormalCompletion6=true;var _didIteratorError6=false;var _iteratorError6=undefined;try{for(var _iterator6=songs[_i2].data.zhida.list[0].zhida_singer.hotsong[Symbol.iterator](),_step6;!(_iteratorNormalCompletion6=(_step6=_iterator6.next()).done);_iteratorNormalCompletion6=true){var _hotSong=_step6.value;_hotSongListValue.push({songMid:_hotSong.songMID,songName:_hotSong.songName});}}catch(err){_didIteratorError6=true;_iteratorError6=err;}finally{try{if(!_iteratorNormalCompletion6&&_iterator6.return){_iterator6.return();}}finally{if(_didIteratorError6){throw _iteratorError6;}}}singerData.nameList.push(songs[_i2].data.zhida.list[0].zhida_singer.singerName);singerData.songList.push(_songListValue3);singerData.hotSongList.push(_hotSongListValue);}}}//把关键字按歌手和歌曲分类的for循环结束
// 当关键字全为歌手时
if(songData.nameList.length===0&&songData.songList.length===0){var _iteratorNormalCompletion7=true;var _didIteratorError7=false;var _iteratorError7=undefined;try{for(var _iterator7=singerData.songList[Symbol.iterator](),_step7;!(_iteratorNormalCompletion7=(_step7=_iterator7.next()).done);_iteratorNormalCompletion7=true){var value=_step7.value;var _iteratorNormalCompletion8=true;var _didIteratorError8=false;var _iteratorError8=undefined;try{for(var _iterator8=value[Symbol.iterator](),_step8;!(_iteratorNormalCompletion8=(_step8=_iterator8.next()).done);_iteratorNormalCompletion8=true){var song=_step8.value;if(song.mvMid!==""){effect.keys=song.mvMid;break;}}}catch(err){_didIteratorError8=true;_iteratorError8=err;}finally{try{if(!_iteratorNormalCompletion8&&_iterator8.return){_iterator8.return();}}finally{if(_didIteratorError8){throw _iteratorError8;}}}if(effect.keys!==""){break;}}}catch(err){_didIteratorError7=true;_iteratorError7=err;}finally{try{if(!_iteratorNormalCompletion7&&_iterator7.return){_iterator7.return();}}finally{if(_didIteratorError7){throw _iteratorError7;}}}}// 当关键字全为歌曲时
else if(singerData.nameList.length===0&&singerData.songList.length===0){var _iteratorNormalCompletion9=true;var _didIteratorError9=false;var _iteratorError9=undefined;try{for(var _iterator9=songData.songList[Symbol.iterator](),_step9;!(_iteratorNormalCompletion9=(_step9=_iterator9.next()).done);_iteratorNormalCompletion9=true){var _value=_step9.value;var _iteratorNormalCompletion10=true;var _didIteratorError10=false;var _iteratorError10=undefined;try{for(var _iterator10=_value[Symbol.iterator](),_step10;!(_iteratorNormalCompletion10=(_step10=_iterator10.next()).done);_iteratorNormalCompletion10=true){var _song=_step10.value;if(_song.mvMid!==""){effect.keys=_song.mvMid;break;}}}catch(err){_didIteratorError10=true;_iteratorError10=err;}finally{try{if(!_iteratorNormalCompletion10&&_iterator10.return){_iterator10.return();}}finally{if(_didIteratorError10){throw _iteratorError10;}}}if(effect.keys!==""){break;}}}catch(err){_didIteratorError9=true;_iteratorError9=err;}finally{try{if(!_iteratorNormalCompletion9&&_iterator9.return){_iterator9.return();}}finally{if(_didIteratorError9){throw _iteratorError9;}}}}else{//首先把所有歌手作为整体，匹配所有歌曲
//遍历输入的歌曲关键字
var _iteratorNormalCompletion11=true;var _didIteratorError11=false;var _iteratorError11=undefined;try{for(var _iterator11=songData.songList[Symbol.iterator](),_step11;!(_iteratorNormalCompletion11=(_step11=_iterator11.next()).done);_iteratorNormalCompletion11=true){var _value2=_step11.value;// 遍历每个歌曲关键字中的歌曲列表
var _iteratorNormalCompletion20=true;var _didIteratorError20=false;var _iteratorError20=undefined;try{for(var _iterator20=_value2[Symbol.iterator](),_step20;!(_iteratorNormalCompletion20=(_step20=_iterator20.next()).done);_iteratorNormalCompletion20=true){var _song5=_step20.value;// 如果歌手长度和歌曲列表歌手长度不匹配，不进行后续复杂操作
if(_song5.singer.length!==singerData.nameList.length)continue;var matching=[];// 遍历歌曲中的歌手列表
var _iteratorNormalCompletion21=true;var _didIteratorError21=false;var _iteratorError21=undefined;try{for(var _iterator21=_song5.singer[Symbol.iterator](),_step21;!(_iteratorNormalCompletion21=(_step21=_iterator21.next()).done);_iteratorNormalCompletion21=true){var _singer=_step21.value;// 遍历singerList中的歌手列表
for(var _i4=0;_i4<singerData.nameList.length;_i4++){// 如果匹配，则对位数标记
if(_singer.name===singerData.nameList[_i4]&&!matching[_i4]){matching[_i4]=true;}}}// 如果二者能完全匹配，则验证通过
}catch(err){_didIteratorError21=true;_iteratorError21=err;}finally{try{if(!_iteratorNormalCompletion21&&_iterator21.return){_iterator21.return();}}finally{if(_didIteratorError21){throw _iteratorError21;}}}if(matching.filter(function(data){return data===true;}).length===_song5.singer.length&&_song5.mvMid!==""){effect.keys=_song5.mvMid;break;}}}catch(err){_didIteratorError20=true;_iteratorError20=err;}finally{try{if(!_iteratorNormalCompletion20&&_iterator20.return){_iterator20.return();}}finally{if(_didIteratorError20){throw _iteratorError20;}}}if(effect.keys!==""){break;}}//歌手作为整体匹配结束
// 歌手作为分割元素，分别匹配歌曲列表
// 当songData.songList的length不为0，则说明需要继续匹配
}catch(err){_didIteratorError11=true;_iteratorError11=err;}finally{try{if(!_iteratorNormalCompletion11&&_iterator11.return){_iterator11.return();}}finally{if(_didIteratorError11){throw _iteratorError11;}}}if(effect.keys===""){var _iteratorNormalCompletion12=true;var _didIteratorError12=false;var _iteratorError12=undefined;try{for(var _iterator12=songData.songList[Symbol.iterator](),_step12;!(_iteratorNormalCompletion12=(_step12=_iterator12.next()).done);_iteratorNormalCompletion12=true){var _value3=_step12.value;var _iteratorNormalCompletion13=true;var _didIteratorError13=false;var _iteratorError13=undefined;try{for(var _iterator13=_value3[Symbol.iterator](),_step13;!(_iteratorNormalCompletion13=(_step13=_iterator13.next()).done);_iteratorNormalCompletion13=true){var _song2=_step13.value;if(effect.keys!==""){break;}for(var _i3=0;_i3<singerData.nameList.length;_i3++){if(effect.keys!==""){break;}var _iteratorNormalCompletion14=true;var _didIteratorError14=false;var _iteratorError14=undefined;try{for(var _iterator14=_song2.singer[Symbol.iterator](),_step14;!(_iteratorNormalCompletion14=(_step14=_iterator14.next()).done);_iteratorNormalCompletion14=true){var singer=_step14.value;if(singer.name===singerData.nameList[_i3]){if(_song2.mvMid!==""){effect.keys=_song2.mvMid;break;}}}}catch(err){_didIteratorError14=true;_iteratorError14=err;}finally{try{if(!_iteratorNormalCompletion14&&_iterator14.return){_iterator14.return();}}finally{if(_didIteratorError14){throw _iteratorError14;}}}}}}catch(err){_didIteratorError13=true;_iteratorError13=err;}finally{try{if(!_iteratorNormalCompletion13&&_iterator13.return){_iterator13.return();}}finally{if(_didIteratorError13){throw _iteratorError13;}}}if(effect.keys!=="")break;}}catch(err){_didIteratorError12=true;_iteratorError12=err;}finally{try{if(!_iteratorNormalCompletion12&&_iterator12.return){_iterator12.return();}}finally{if(_didIteratorError12){throw _iteratorError12;}}}}//歌手作为分割元素匹配结束
// 开始歌曲作为分割元素匹配歌手的歌曲列表
if(effect.keys===""){var _iteratorNormalCompletion15=true;var _didIteratorError15=false;var _iteratorError15=undefined;try{for(var _iterator15=songData.nameList[Symbol.iterator](),_step15;!(_iteratorNormalCompletion15=(_step15=_iterator15.next()).done);_iteratorNormalCompletion15=true){var name=_step15.value;if(effect.keys!==""){break;}var _iteratorNormalCompletion16=true;var _didIteratorError16=false;var _iteratorError16=undefined;try{for(var _iterator16=singerData.songList[Symbol.iterator](),_step16;!(_iteratorNormalCompletion16=(_step16=_iterator16.next()).done);_iteratorNormalCompletion16=true){var _list4=_step16.value;if(effect.keys!==""){break;}var _iteratorNormalCompletion17=true;var _didIteratorError17=false;var _iteratorError17=undefined;try{for(var _iterator17=_list4[Symbol.iterator](),_step17;!(_iteratorNormalCompletion17=(_step17=_iterator17.next()).done);_iteratorNormalCompletion17=true){var _song3=_step17.value;if(name===_song3.songName){if(_song3.mvMid!==""){effect.keys=_song3.mvMid;break;}}}}catch(err){_didIteratorError17=true;_iteratorError17=err;}finally{try{if(!_iteratorNormalCompletion17&&_iterator17.return){_iterator17.return();}}finally{if(_didIteratorError17){throw _iteratorError17;}}}}}catch(err){_didIteratorError16=true;_iteratorError16=err;}finally{try{if(!_iteratorNormalCompletion16&&_iterator16.return){_iterator16.return();}}finally{if(_didIteratorError16){throw _iteratorError16;}}}}}catch(err){_didIteratorError15=true;_iteratorError15=err;}finally{try{if(!_iteratorNormalCompletion15&&_iterator15.return){_iterator15.return();}}finally{if(_didIteratorError15){throw _iteratorError15;}}}}//固定歌曲匹配歌手的歌曲列表结束
// 开始剩余歌曲处理
if(effect.keys===""){var _iteratorNormalCompletion18=true;var _didIteratorError18=false;var _iteratorError18=undefined;try{for(var _iterator18=songData.songList[Symbol.iterator](),_step18;!(_iteratorNormalCompletion18=(_step18=_iterator18.next()).done);_iteratorNormalCompletion18=true){var _value4=_step18.value;var _iteratorNormalCompletion19=true;var _didIteratorError19=false;var _iteratorError19=undefined;try{for(var _iterator19=_value4[Symbol.iterator](),_step19;!(_iteratorNormalCompletion19=(_step19=_iterator19.next()).done);_iteratorNormalCompletion19=true){var _song4=_step19.value;if(_song4.mvMid!==""){effect.keys=_song4.mvMid;break;}}}catch(err){_didIteratorError19=true;_iteratorError19=err;}finally{try{if(!_iteratorNormalCompletion19&&_iterator19.return){_iterator19.return();}}finally{if(_didIteratorError19){throw _iteratorError19;}}}}}catch(err){_didIteratorError18=true;_iteratorError18=err;}finally{try{if(!_iteratorNormalCompletion18&&_iterator18.return){_iterator18.return();}}finally{if(_didIteratorError18){throw _iteratorError18;}}}}//剩余歌曲处理结束
//提取keyList的元素
}if(effect.keys!=="")effect.url=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusicMv).playFirstHalf+effect.keys+__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusicMv).playSecondHalf;}//函数内部声明函数，用来处理qq音乐
function handleQQMusicEffect(data){var songs=data.songs;console.log(songs);var songData={nameList:[],songList:[]};var singerData={nameList:[],songList:[],hotSongList:[]// 如果有无效字符，剔除
};for(var i=0;i<songs.length;i++){if(songs[i].message!==""){songs.splice(i,1);effect.errorInfo.push(i);i--;}}// 如果无有效输入，不执行操作
if(songs.length===0){return;}// 遍历所有有效数据，把数据按歌手和歌曲分类
for(var _i5=0;_i5<songs.length;_i5++){// 关键字非歌手
if(typeof songs[_i5].data.zhida.list==='undefined'){if(typeof songs[_i5].data.zhida.zhida_singer==='undefined'){var songListValue=[];var _iteratorNormalCompletion22=true;var _didIteratorError22=false;var _iteratorError22=undefined;try{for(var _iterator22=songs[_i5].data.song.list[Symbol.iterator](),_step22;!(_iteratorNormalCompletion22=(_step22=_iterator22.next()).done);_iteratorNormalCompletion22=true){var list=_step22.value;songListValue.push({songName:list.name,songMid:list.mid,singer:list.singer,mvMid:list.mv.vid});}}catch(err){_didIteratorError22=true;_iteratorError22=err;}finally{try{if(!_iteratorNormalCompletion22&&_iterator22.return){_iterator22.return();}}finally{if(_didIteratorError22){throw _iteratorError22;}}}songData.nameList.push(songs[_i5].data.song.list[0].name);songData.songList.push(songListValue);}// 关键字是歌手
else{var _songListValue4=[];var hotSongListValue=[];var _iteratorNormalCompletion23=true;var _didIteratorError23=false;var _iteratorError23=undefined;try{for(var _iterator23=songs[_i5].data.song.list[Symbol.iterator](),_step23;!(_iteratorNormalCompletion23=(_step23=_iterator23.next()).done);_iteratorNormalCompletion23=true){var _list5=_step23.value;_songListValue4.push({songName:_list5.name,songMid:_list5.mid,singer:_list5.singer,mvMid:_list5.mv.vid});}}catch(err){_didIteratorError23=true;_iteratorError23=err;}finally{try{if(!_iteratorNormalCompletion23&&_iterator23.return){_iterator23.return();}}finally{if(_didIteratorError23){throw _iteratorError23;}}}var _iteratorNormalCompletion24=true;var _didIteratorError24=false;var _iteratorError24=undefined;try{for(var _iterator24=songs[_i5].data.zhida.zhida_singer.hotsong[Symbol.iterator](),_step24;!(_iteratorNormalCompletion24=(_step24=_iterator24.next()).done);_iteratorNormalCompletion24=true){var hotSong=_step24.value;hotSongListValue.push({songMid:hotSong.songMID,songName:hotSong.songName});}}catch(err){_didIteratorError24=true;_iteratorError24=err;}finally{try{if(!_iteratorNormalCompletion24&&_iterator24.return){_iterator24.return();}}finally{if(_didIteratorError24){throw _iteratorError24;}}}singerData.nameList.push(songs[_i5].data.zhida.zhida_singer.singerName);singerData.songList.push(_songListValue4);singerData.hotSongList.push(hotSongListValue);}}else{if(songs[_i5].data.zhida.list.length===0||typeof songs[_i5].data.zhida.list[0].zhida_singer==='undefined'){var _songListValue5=[];var _iteratorNormalCompletion25=true;var _didIteratorError25=false;var _iteratorError25=undefined;try{for(var _iterator25=songs[_i5].data.song.list[Symbol.iterator](),_step25;!(_iteratorNormalCompletion25=(_step25=_iterator25.next()).done);_iteratorNormalCompletion25=true){var _list6=_step25.value;_songListValue5.push({songName:_list6.name,songMid:_list6.mid,singer:_list6.singer,mvMid:_list6.mv.vid});}}catch(err){_didIteratorError25=true;_iteratorError25=err;}finally{try{if(!_iteratorNormalCompletion25&&_iterator25.return){_iterator25.return();}}finally{if(_didIteratorError25){throw _iteratorError25;}}}songData.nameList.push(songs[_i5].data.song.list[0].name);songData.songList.push(_songListValue5);}// 关键字是歌手
else{var _songListValue6=[];var _hotSongListValue2=[];var _iteratorNormalCompletion26=true;var _didIteratorError26=false;var _iteratorError26=undefined;try{for(var _iterator26=songs[_i5].data.song.list[Symbol.iterator](),_step26;!(_iteratorNormalCompletion26=(_step26=_iterator26.next()).done);_iteratorNormalCompletion26=true){var _list7=_step26.value;_songListValue6.push({songName:_list7.name,songMid:_list7.mid,singer:_list7.singer,mvMid:_list7.mv.vid});}}catch(err){_didIteratorError26=true;_iteratorError26=err;}finally{try{if(!_iteratorNormalCompletion26&&_iterator26.return){_iterator26.return();}}finally{if(_didIteratorError26){throw _iteratorError26;}}}var _iteratorNormalCompletion27=true;var _didIteratorError27=false;var _iteratorError27=undefined;try{for(var _iterator27=songs[_i5].data.zhida.list[0].zhida_singer.hotsong[Symbol.iterator](),_step27;!(_iteratorNormalCompletion27=(_step27=_iterator27.next()).done);_iteratorNormalCompletion27=true){var _hotSong2=_step27.value;_hotSongListValue2.push({songMid:_hotSong2.songMID,songName:_hotSong2.songName});}}catch(err){_didIteratorError27=true;_iteratorError27=err;}finally{try{if(!_iteratorNormalCompletion27&&_iterator27.return){_iterator27.return();}}finally{if(_didIteratorError27){throw _iteratorError27;}}}singerData.nameList.push(songs[_i5].data.zhida.list[0].zhida_singer.singerName);singerData.songList.push(_songListValue6);singerData.hotSongList.push(_hotSongListValue2);}}}//把关键字按歌手和歌曲分类的for循环结束
// 当关键字全为歌手时
if(songData.nameList.length===0&&songData.songList.length===0){var _iteratorNormalCompletion28=true;var _didIteratorError28=false;var _iteratorError28=undefined;try{for(var _iterator28=singerData.hotSongList[Symbol.iterator](),_step28;!(_iteratorNormalCompletion28=(_step28=_iterator28.next()).done);_iteratorNormalCompletion28=true){var value=_step28.value;var _iteratorNormalCompletion29=true;var _didIteratorError29=false;var _iteratorError29=undefined;try{for(var _iterator29=value[Symbol.iterator](),_step29;!(_iteratorNormalCompletion29=(_step29=_iterator29.next()).done);_iteratorNormalCompletion29=true){var song=_step29.value;effect.keys+=song.songMid+",";}}catch(err){_didIteratorError29=true;_iteratorError29=err;}finally{try{if(!_iteratorNormalCompletion29&&_iterator29.return){_iterator29.return();}}finally{if(_didIteratorError29){throw _iteratorError29;}}}}}catch(err){_didIteratorError28=true;_iteratorError28=err;}finally{try{if(!_iteratorNormalCompletion28&&_iterator28.return){_iterator28.return();}}finally{if(_didIteratorError28){throw _iteratorError28;}}}}// 当关键字全为歌曲时
else if(singerData.nameList.length===0&&singerData.songList.length===0){var _iteratorNormalCompletion30=true;var _didIteratorError30=false;var _iteratorError30=undefined;try{for(var _iterator30=songData.songList[Symbol.iterator](),_step30;!(_iteratorNormalCompletion30=(_step30=_iterator30.next()).done);_iteratorNormalCompletion30=true){var _value5=_step30.value;effect.keys+=_value5[0].songMid+",";}}catch(err){_didIteratorError30=true;_iteratorError30=err;}finally{try{if(!_iteratorNormalCompletion30&&_iterator30.return){_iterator30.return();}}finally{if(_didIteratorError30){throw _iteratorError30;}}}}else{var keyList=[];var restSongCount=songData.songList.length;//首先把所有歌手作为整体，匹配所有歌曲
//遍历输入的歌曲关键字
var firstSongListCount=0;var _iteratorNormalCompletion31=true;var _didIteratorError31=false;var _iteratorError31=undefined;try{for(var _iterator31=songData.songList[Symbol.iterator](),_step31;!(_iteratorNormalCompletion31=(_step31=_iterator31.next()).done);_iteratorNormalCompletion31=true){var _value6=_step31.value;// 遍历每个歌曲关键字中的歌曲列表
var _iteratorNormalCompletion40=true;var _didIteratorError40=false;var _iteratorError40=undefined;try{for(var _iterator40=_value6[Symbol.iterator](),_step40;!(_iteratorNormalCompletion40=(_step40=_iterator40.next()).done);_iteratorNormalCompletion40=true){var _song8=_step40.value;// 如果歌手长度和歌曲列表歌手长度不匹配，不进行后续复杂操作
if(_song8.singer.length!==singerData.nameList.length)continue;var matching=[];// 遍历歌曲中的歌手列表
var _iteratorNormalCompletion41=true;var _didIteratorError41=false;var _iteratorError41=undefined;try{for(var _iterator41=_song8.singer[Symbol.iterator](),_step41;!(_iteratorNormalCompletion41=(_step41=_iterator41.next()).done);_iteratorNormalCompletion41=true){var _singer2=_step41.value;// 遍历singerList中的歌手列表
for(var _i7=0;_i7<singerData.nameList.length;_i7++){// 如果匹配，则对位数标记
if(_singer2.name===singerData.nameList[_i7]&&!matching[_i7]){matching[_i7]=true;}}}// 如果二者能完全匹配，则验证通过
}catch(err){_didIteratorError41=true;_iteratorError41=err;}finally{try{if(!_iteratorNormalCompletion41&&_iterator41.return){_iterator41.return();}}finally{if(_didIteratorError41){throw _iteratorError41;}}}if(matching.filter(function(data){return data===true;}).length===_song8.singer.length){keyList[firstSongListCount]=_song8.songMid;songData.songList[firstSongListCount]=false;songData.nameList[firstSongListCount]=false;restSongCount--;break;}}}catch(err){_didIteratorError40=true;_iteratorError40=err;}finally{try{if(!_iteratorNormalCompletion40&&_iterator40.return){_iterator40.return();}}finally{if(_didIteratorError40){throw _iteratorError40;}}}firstSongListCount++;}//歌手作为整体匹配结束
// 歌手作为分割元素，分别匹配歌曲列表
// 当songData.songList的length不为0，则说明需要继续匹配
}catch(err){_didIteratorError31=true;_iteratorError31=err;}finally{try{if(!_iteratorNormalCompletion31&&_iterator31.return){_iterator31.return();}}finally{if(_didIteratorError31){throw _iteratorError31;}}}if(restSongCount>0){var secondSongListCount=0;var _iteratorNormalCompletion32=true;var _didIteratorError32=false;var _iteratorError32=undefined;try{for(var _iterator32=songData.songList[Symbol.iterator](),_step32;!(_iteratorNormalCompletion32=(_step32=_iterator32.next()).done);_iteratorNormalCompletion32=true){var _value7=_step32.value;if(_value7===false){secondSongListCount++;continue;}var _iteratorNormalCompletion33=true;var _didIteratorError33=false;var _iteratorError33=undefined;try{for(var _iterator33=_value7[Symbol.iterator](),_step33;!(_iteratorNormalCompletion33=(_step33=_iterator33.next()).done);_iteratorNormalCompletion33=true){var _song6=_step33.value;if(keyList[secondSongListCount]){break;}for(var _i6=0;_i6<singerData.nameList.length;_i6++){if(keyList[secondSongListCount]){break;}var _iteratorNormalCompletion34=true;var _didIteratorError34=false;var _iteratorError34=undefined;try{for(var _iterator34=_song6.singer[Symbol.iterator](),_step34;!(_iteratorNormalCompletion34=(_step34=_iterator34.next()).done);_iteratorNormalCompletion34=true){var singer=_step34.value;if(singer.name===singerData.nameList[_i6]){keyList[secondSongListCount]=_song6.songMid;songData.nameList[secondSongListCount]=false;songData.songList[secondSongListCount]=false;restSongCount--;break;}}}catch(err){_didIteratorError34=true;_iteratorError34=err;}finally{try{if(!_iteratorNormalCompletion34&&_iterator34.return){_iterator34.return();}}finally{if(_didIteratorError34){throw _iteratorError34;}}}}}}catch(err){_didIteratorError33=true;_iteratorError33=err;}finally{try{if(!_iteratorNormalCompletion33&&_iterator33.return){_iterator33.return();}}finally{if(_didIteratorError33){throw _iteratorError33;}}}secondSongListCount++;}}catch(err){_didIteratorError32=true;_iteratorError32=err;}finally{try{if(!_iteratorNormalCompletion32&&_iterator32.return){_iterator32.return();}}finally{if(_didIteratorError32){throw _iteratorError32;}}}}//歌手作为分割元素匹配结束
// 开始歌曲作为分割元素匹配歌手的歌曲列表
if(restSongCount>0){var thirdSongListCount=0;var _iteratorNormalCompletion35=true;var _didIteratorError35=false;var _iteratorError35=undefined;try{for(var _iterator35=songData.nameList[Symbol.iterator](),_step35;!(_iteratorNormalCompletion35=(_step35=_iterator35.next()).done);_iteratorNormalCompletion35=true){var name=_step35.value;if(name===false){thirdSongListCount++;continue;}var _iteratorNormalCompletion36=true;var _didIteratorError36=false;var _iteratorError36=undefined;try{for(var _iterator36=singerData.songList[Symbol.iterator](),_step36;!(_iteratorNormalCompletion36=(_step36=_iterator36.next()).done);_iteratorNormalCompletion36=true){var _list8=_step36.value;if(keyList[thirdSongListCount]){break;}var _iteratorNormalCompletion37=true;var _didIteratorError37=false;var _iteratorError37=undefined;try{for(var _iterator37=_list8[Symbol.iterator](),_step37;!(_iteratorNormalCompletion37=(_step37=_iterator37.next()).done);_iteratorNormalCompletion37=true){var _song7=_step37.value;if(name===_song7.songName){keyList[thirdSongListCount]=_song7.songMid;songData.nameList[thirdSongListCount]=false;songData.songList[thirdSongListCount]=false;restSongCount--;break;}}}catch(err){_didIteratorError37=true;_iteratorError37=err;}finally{try{if(!_iteratorNormalCompletion37&&_iterator37.return){_iterator37.return();}}finally{if(_didIteratorError37){throw _iteratorError37;}}}}}catch(err){_didIteratorError36=true;_iteratorError36=err;}finally{try{if(!_iteratorNormalCompletion36&&_iterator36.return){_iterator36.return();}}finally{if(_didIteratorError36){throw _iteratorError36;}}}thirdSongListCount++;}}catch(err){_didIteratorError35=true;_iteratorError35=err;}finally{try{if(!_iteratorNormalCompletion35&&_iterator35.return){_iterator35.return();}}finally{if(_didIteratorError35){throw _iteratorError35;}}}}//固定歌曲匹配歌手的歌曲列表结束
// 开始剩余歌曲处理
if(restSongCount>0){var fourthSongListCount=0;var _iteratorNormalCompletion38=true;var _didIteratorError38=false;var _iteratorError38=undefined;try{for(var _iterator38=songData.songList[Symbol.iterator](),_step38;!(_iteratorNormalCompletion38=(_step38=_iterator38.next()).done);_iteratorNormalCompletion38=true){var _value8=_step38.value;if(_value8===false){fourthSongListCount++;continue;}keyList[fourthSongListCount]=_value8[0].songMid;songData.nameList[fourthSongListCount]=false;songData.songList[fourthSongListCount]=false;restSongCount--;fourthSongListCount++;}}catch(err){_didIteratorError38=true;_iteratorError38=err;}finally{try{if(!_iteratorNormalCompletion38&&_iterator38.return){_iterator38.return();}}finally{if(_didIteratorError38){throw _iteratorError38;}}}}//剩余歌曲处理结束
//提取keyList的元素
var _iteratorNormalCompletion39=true;var _didIteratorError39=false;var _iteratorError39=undefined;try{for(var _iterator39=keyList[Symbol.iterator](),_step39;!(_iteratorNormalCompletion39=(_step39=_iterator39.next()).done);_iteratorNormalCompletion39=true){var key=_step39.value;effect.keys+=key+",";}}catch(err){_didIteratorError39=true;_iteratorError39=err;}finally{try{if(!_iteratorNormalCompletion39&&_iterator39.return){_iterator39.return();}}finally{if(_didIteratorError39){throw _iteratorError39;}}}}// 组装播放url
if(effect.keys!==""){effect.keys+=sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusic)?sessionStorage.getItem(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusic):"";effect.url=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusic).playFirstHalf+effect.keys+__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].inputKey.playQQMusic).playSecondHalf;}}//处理qq音乐effect的函数尾巴
};this.handleKeyAndStorageWithSession=function(value,keyName){var count=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].count.storageSongCount;var isRepeat=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var lastValue=sessionStorage.getItem(keyName);var newStorage="";var valueArray=lastValue?(lastValue+value).trim().split(","):value.trim().split(",");for(var i=0;i<valueArray.length;i++){if(valueArray[i]===""){valueArray.splice(i,1);}}while(valueArray.length>count){valueArray.shift();}if(!isRepeat){valueArray.sort();newStorage=valueArray[0]+",";for(var _i8=1;_i8<valueArray.length;_i8++){if(valueArray[_i8]!==valueArray[_i8-1]){newStorage+=valueArray[_i8]+",";}}}else{for(var _i9=0;_i9<valueArray.length;_i9++){newStorage+=valueArray[_i9]+",";}}console.log(newStorage);sessionStorage.setItem(keyName,newStorage);};this.handleKeyAndStorageWithLocal=function(value,keyName){var count=arguments.length>2&&arguments[2]!==undefined?arguments[2]:__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].conut.storageSongCount;var isRepeat=arguments.length>3&&arguments[3]!==undefined?arguments[3]:true;var lastValue=localStorage.getItem(keyName);var newStorage="";var valueArray=lastValue?(lastValue+value).trim().split(","):value.trim().split(",");for(var i=0;i<valueArray.length;i++){if(valueArray[i]===""){valueArray.splice(i,1);}}while(valueArray.length>count){valueArray.shift();}if(!isRepeat){valueArray.sort();newStorage=valueArray[0];for(var _i10=1;_i10<valueArray.length;_i10++){if(valueArray[_i10]!==valueArray[_i10-1]){newStorage+=valueArray[_i10]+",";}}}else{for(var _i11=0;_i11<valueArray.length;_i11++){newStorage+=valueArray[_i11]+",";}}localStorage.setItem(keyName,newStorage);};this.csvToArrayNoEmpty=function(csv){var valueArray=csv?csv.trim().split(","):[];for(var i=0;i<valueArray.length;i++){if(valueArray[i]===""){valueArray.splice(i,1);}}return valueArray;};this.instance=null;},_class.createDataToolsClass=function(){if(!_this.instance){_this.instance=new DataTools();}return _this.instance;},_temp);/* harmony default export */ __webpack_exports__["a"] = (DataTools);

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(14);
module.exports = __webpack_require__(19);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(15).enable();
  window.Promise = __webpack_require__(17);
}

// fetch() polyfill for making API calls.
__webpack_require__(18);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(7);


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(8);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(8);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_spectre_min_css__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__css_spectre_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__css_spectre_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_spectre_icons_min_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css_spectre_icons_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__css_spectre_icons_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_spectre_exp_min_css__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__css_spectre_exp_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__css_spectre_exp_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stateClass_UIState__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__stateClass_OtherState__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__stateClass_AppState__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stateClass_InputState__ = __webpack_require__(66);
var states={otherState:__WEBPACK_IMPORTED_MODULE_8__stateClass_OtherState__["a" /* otherState */],uiState:__WEBPACK_IMPORTED_MODULE_7__stateClass_UIState__["a" /* uiState */],appState:__WEBPACK_IMPORTED_MODULE_9__stateClass_AppState__["a" /* appState */],inputState:__WEBPACK_IMPORTED_MODULE_10__stateClass_InputState__["a" /* inputState */]};__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_mobx_react__["a" /* Provider */],states,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__App__["a" /* default */],null)),document.getElementById('root'));

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var k=__webpack_require__(7),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,A=n?Symbol.for("react.memo"):
60115,B=n?Symbol.for("react.lazy"):60116,C="function"===typeof Symbol&&Symbol.iterator;function aa(a,b,e,c,d,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[e,c,d,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function D(a){for(var b=arguments.length-1,e="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)e+="&args[]="+encodeURIComponent(arguments[c+1]);aa(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",e)}var E={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},F={};
function G(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}G.prototype.isReactComponent={};G.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?D("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};G.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function H(){}H.prototype=G.prototype;function I(a,b,e){this.props=a;this.context=b;this.refs=F;this.updater=e||E}var J=I.prototype=new H;
J.constructor=I;k(J,G.prototype);J.isPureReactComponent=!0;var K={current:null,currentDispatcher:null},L=Object.prototype.hasOwnProperty,M={key:!0,ref:!0,__self:!0,__source:!0};
function N(a,b,e){var c=void 0,d={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=b[c]);var f=arguments.length-2;if(1===f)d.children=e;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];d.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===d[c]&&(d[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:d,_owner:K.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,e,c){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=e;d.context=c;d.count=0;return d}return{result:a,keyPrefix:b,func:e,context:c,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,e,c){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return e(c,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){d=a[h];var f=b+U(d,h);g+=T(d,f,e,c)}else if(null===a||"object"!==typeof a?f=null:(f=C&&a[C]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,h++),g+=T(d,f,e,c);else"object"===d&&(e=""+a,D("31","[object Object]"===e?"object with keys {"+Object.keys(a).join(", ")+"}":e,""));return g}function V(a,b,e){return null==a?0:T(a,"",b,e)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,e){var c=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?W(a,c,e,function(a){return a}):null!=a&&(O(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+e)),c.push(a))}function W(a,b,e,c,d){var g="";null!=e&&(g=(""+e).replace(P,"$&/")+"/");b=R(b,g,c,d);V(a,da,b);S(b)}
var X={Children:{map:function(a,b,e){if(null==a)return a;var c=[];W(a,c,null,b,e);return c},forEach:function(a,b,e){if(null==a)return a;b=R(null,null,b,e);V(a,ca,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];W(a,b,null,function(a){return a});return b},only:function(a){O(a)?void 0:D("143");return a}},createRef:function(){return{current:null}},Component:G,PureComponent:I,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:B,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:A,type:a,compare:void 0===b?null:b}},Fragment:r,StrictMode:t,unstable_ConcurrentMode:x,Suspense:z,unstable_Profiler:u,createElement:N,cloneElement:function(a,b,e){null===a||void 0===a?D("267",a):void 0;var c=void 0,d=k({},a.props),
g=a.key,h=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(h=b.ref,f=K.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)L.call(b,c)&&!M.hasOwnProperty(c)&&(d[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)d.children=e;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];d.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:d,_owner:f}},createFactory:function(a){var b=N.bind(null,a);b.type=a;return b},
isValidElement:O,version:"16.6.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:K,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(7),da=__webpack_require__(22);function ea(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var k=[c,d,e,f,g,h],l=0;a=Error(b.replace(/%s/g,function(){return k[l++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
function r(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ea(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:r("227");function fa(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}
var ha=!1,ia=null,ja=!1,ka=null,la={onError:function(a){ha=!0;ia=a}};function ma(a,b,c,d,e,f,g,h,k){ha=!1;ia=null;fa.apply(la,arguments)}function na(a,b,c,d,e,f,g,h,k){ma.apply(this,arguments);if(ha){if(ha){var l=ia;ha=!1;ia=null}else r("198"),l=void 0;ja||(ja=!0,ka=l)}}var oa=null,pa={};
function qa(){if(oa)for(var a in pa){var b=pa[a],c=oa.indexOf(a);-1<c?void 0:r("96",a);if(!ra[c]){b.extractEvents?void 0:r("97",a);ra[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;sa.hasOwnProperty(h)?r("99",h):void 0;sa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ta(k[e],g,h);e=!0}else f.registrationName?(ta(f.registrationName,g,h),e=!0):e=!1;e?void 0:r("98",d,a)}}}}
function ta(a,b,c){ua[a]?r("100",a):void 0;ua[a]=b;va[a]=b.eventTypes[c].dependencies}var ra=[],sa={},ua={},va={},wa=null,xa=null,ya=null;function za(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=ya(d);na(b,c,void 0,a);a.currentTarget=null}function Aa(a,b){null==b?r("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function Ba(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ca=null;function Da(a,b){if(a){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)za(a,b,c[e],d[e]);else c&&za(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ea(a){return Da(a,!0)}function Fa(a){return Da(a,!1)}
var Ga={injectEventPluginOrder:function(a){oa?r("101"):void 0;oa=Array.prototype.slice.call(a);qa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];pa.hasOwnProperty(c)&&pa[c]===d||(pa[c]?r("102",c):void 0,pa[c]=d,b=!0)}b&&qa()}};
function Ha(a,b){var c=a.stateNode;if(!c)return null;var d=wa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?r("231",b,typeof c):void 0;
return c}function Ia(a,b){null!==a&&(Ca=Aa(Ca,a));a=Ca;Ca=null;if(a&&(b?Ba(a,Ea):Ba(a,Fa),Ca?r("95"):void 0,ja))throw b=ka,ja=!1,ka=null,b;}var Ka=Math.random().toString(36).slice(2),La="__reactInternalInstance$"+Ka,Ma="__reactEventHandlers$"+Ka;function Na(a){if(a[La])return a[La];for(;!a[La];)if(a.parentNode)a=a.parentNode;else return null;a=a[La];return 5===a.tag||6===a.tag?a:null}function Oa(a){a=a[La];return!a||5!==a.tag&&6!==a.tag?null:a}
function Pa(a){if(5===a.tag||6===a.tag)return a.stateNode;r("33")}function Qa(a){return a[Ma]||null}function Ra(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Sa(a,b,c){if(b=Ha(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a)}
function Ta(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Ra(b);for(b=c.length;0<b--;)Sa(c[b],"captured",a);for(b=0;b<c.length;b++)Sa(c[b],"bubbled",a)}}function Ua(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ha(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Aa(c._dispatchListeners,b),c._dispatchInstances=Aa(c._dispatchInstances,a))}function Va(a){a&&a.dispatchConfig.registrationName&&Ua(a._targetInst,null,a)}
function Wa(a){Ba(a,Ta)}var Xa=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ya(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Za={animationend:Ya("Animation","AnimationEnd"),animationiteration:Ya("Animation","AnimationIteration"),animationstart:Ya("Animation","AnimationStart"),transitionend:Ya("Transition","TransitionEnd")},$a={},ab={};
Xa&&(ab=document.createElement("div").style,"AnimationEvent"in window||(delete Za.animationend.animation,delete Za.animationiteration.animation,delete Za.animationstart.animation),"TransitionEvent"in window||delete Za.transitionend.transition);function bb(a){if($a[a])return $a[a];if(!Za[a])return a;var b=Za[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in ab)return $a[a]=b[c];return a}
var cb=bb("animationend"),ib=bb("animationiteration"),jb=bb("animationstart"),kb=bb("transitionend"),lb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),mb=null,nb=null,ob=null;
function pb(){if(ob)return ob;var a,b=nb,c=b.length,d,e="value"in mb?mb.value:mb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return ob=e.slice(a,1<d?1-d:void 0)}function qb(){return!0}function rb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?qb:rb;this.isPropagationStopped=rb;return this}
n(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=qb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=qb)},persist:function(){this.isPersistent=qb},isPersistent:rb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=rb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;sb(c);return c};sb(y);function tb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function ub(a){a instanceof this?void 0:r("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
function sb(a){a.eventPool=[];a.getPooled=tb;a.release=ub}var vb=y.extend({data:null}),wb=y.extend({data:null}),xb=[9,13,27,32],yb=Xa&&"CompositionEvent"in window,zb=null;Xa&&"documentMode"in document&&(zb=document.documentMode);
var Ab=Xa&&"TextEvent"in window&&!zb,Bb=Xa&&(!yb||zb&&8<zb&&11>=zb),Cb=String.fromCharCode(32),Db={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Eb=!1;
function Fb(a,b){switch(a){case "keyup":return-1!==xb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Gb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Hb=!1;function Kb(a,b){switch(a){case "compositionend":return Gb(b);case "keypress":if(32!==b.which)return null;Eb=!0;return Cb;case "textInput":return a=b.data,a===Cb&&Eb?null:a;default:return null}}
function Lb(a,b){if(Hb)return"compositionend"===a||!yb&&Fb(a,b)?(a=pb(),ob=nb=mb=null,Hb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Bb&&"ko"!==b.locale?null:b.data;default:return null}}
var Mb={eventTypes:Db,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(yb)b:{switch(a){case "compositionstart":e=Db.compositionStart;break b;case "compositionend":e=Db.compositionEnd;break b;case "compositionupdate":e=Db.compositionUpdate;break b}e=void 0}else Hb?Fb(a,c)&&(e=Db.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=Db.compositionStart);e?(Bb&&"ko"!==c.locale&&(Hb||e!==Db.compositionStart?e===Db.compositionEnd&&Hb&&(f=pb()):(mb=d,nb="value"in mb?mb.value:mb.textContent,Hb=
!0)),e=vb.getPooled(e,b,c,d),f?e.data=f:(f=Gb(c),null!==f&&(e.data=f)),Wa(e),f=e):f=null;(a=Ab?Kb(a,c):Lb(a,c))?(b=wb.getPooled(Db.beforeInput,b,c,d),b.data=a,Wa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Nb=null,Ob=null,Pb=null;function Vb(a){if(a=xa(a)){"function"!==typeof Nb?r("280"):void 0;var b=wa(a.stateNode);Nb(a.stateNode,a.type,b)}}function Wb(a){Ob?Pb?Pb.push(a):Pb=[a]:Ob=a}function Xb(){if(Ob){var a=Ob,b=Pb;Pb=Ob=null;Vb(a);if(b)for(a=0;a<b.length;a++)Vb(b[a])}}
function Yb(a,b){return a(b)}function Zb(a,b,c){return a(b,c)}function $b(){}var ac=!1;function bc(a,b){if(ac)return a(b);ac=!0;try{return Yb(a,b)}finally{if(ac=!1,null!==Ob||null!==Pb)$b(),Xb()}}var cc={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function dc(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!cc[a.type]:"textarea"===b?!0:!1}
function ec(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function fc(a){if(!Xa)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function gc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function hc(a){var b=gc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function ic(a){a._valueTracker||(a._valueTracker=hc(a))}function jc(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=gc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
var kc=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,lc=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,mc=D?Symbol.for("react.element"):60103,nc=D?Symbol.for("react.portal"):60106,oc=D?Symbol.for("react.fragment"):60107,pc=D?Symbol.for("react.strict_mode"):60108,qc=D?Symbol.for("react.profiler"):60114,rc=D?Symbol.for("react.provider"):60109,sc=D?Symbol.for("react.context"):60110,tc=D?Symbol.for("react.concurrent_mode"):60111,uc=D?Symbol.for("react.forward_ref"):60112,vc=D?Symbol.for("react.suspense"):
60113,wc=D?Symbol.for("react.memo"):60115,xc=D?Symbol.for("react.lazy"):60116,yc="function"===typeof Symbol&&Symbol.iterator;function zc(a){if(null===a||"object"!==typeof a)return null;a=yc&&a[yc]||a["@@iterator"];return"function"===typeof a?a:null}
function Ac(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case tc:return"ConcurrentMode";case oc:return"Fragment";case nc:return"Portal";case qc:return"Profiler";case pc:return"StrictMode";case vc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case sc:return"Context.Consumer";case rc:return"Context.Provider";case uc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
")":"ForwardRef");case wc:return Ac(a.type);case xc:if(a=1===a._status?a._result:null)return Ac(a)}return null}function Bc(a){var b="";do{a:switch(a.tag){case 2:case 16:case 0:case 1:case 5:case 8:var c=a._debugOwner,d=a._debugSource,e=Ac(a.type);var f=null;c&&(f=Ac(c.type));c=e;e="";d?e=" (at "+d.fileName.replace(lc,"")+":"+d.lineNumber+")":f&&(e=" (created by "+f+")");f="\n    in "+(c||"Unknown")+e;break a;default:f=""}b+=f;a=a.return}while(a);return b}
var Cc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Dc=Object.prototype.hasOwnProperty,Ec={},Fc={};
function Gc(a){if(Dc.call(Fc,a))return!0;if(Dc.call(Ec,a))return!1;if(Cc.test(a))return Fc[a]=!0;Ec[a]=!0;return!1}function Hc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ic(a,b,c,d){if(null===b||"undefined"===typeof b||Hc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var Mc=/[\-:]([a-z])/g;function Nc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Mc,
Nc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Mc,Nc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Mc,Nc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
function Oc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ic(b,c,e,d)&&(c=null),d||null===e?Gc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Pc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Qc(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Rc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Pc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Sc(a,b){b=b.checked;null!=b&&Oc(a,"checked",b,!1)}
function Tc(a,b){Sc(a,b);var c=Pc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Uc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Uc(a,b.type,Pc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function bd(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Uc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var cd={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function dd(a,b,c){a=y.getPooled(cd.change,a,b,c);a.type="change";Wb(c);Wa(a);return a}var ed=null,fd=null;function gd(a){Ia(a,!1)}
function hd(a){var b=Pa(a);if(jc(b))return a}function id(a,b){if("change"===a)return b}var jd=!1;Xa&&(jd=fc("input")&&(!document.documentMode||9<document.documentMode));function kd(){ed&&(ed.detachEvent("onpropertychange",ld),fd=ed=null)}function ld(a){"value"===a.propertyName&&hd(fd)&&(a=dd(fd,a,ec(a)),bc(gd,a))}function md(a,b,c){"focus"===a?(kd(),ed=b,fd=c,ed.attachEvent("onpropertychange",ld)):"blur"===a&&kd()}function nd(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return hd(fd)}
function od(a,b){if("click"===a)return hd(b)}function pd(a,b){if("input"===a||"change"===a)return hd(b)}
var qd={eventTypes:cd,_isInputEventSupported:jd,extractEvents:function(a,b,c,d){var e=b?Pa(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=id:dc(e)?jd?f=pd:(f=nd,g=md):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=od);if(f&&(f=f(a,b)))return dd(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Uc(e,"number",e.value)}},rd=y.extend({view:null,detail:null}),sd={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function td(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=sd[a])?!!b[a]:!1}function ud(){return td}
var vd=0,wd=0,xd=!1,yd=!1,zd=rd.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:ud,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=vd;vd=a.screenX;return xd?"mousemove"===a.type?a.screenX-b:0:(xd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=wd;wd=a.screenY;return yd?"mousemove"===a.type?a.screenY-b:0:(yd=!0,0)}}),Ad=zd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Bd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Cd={eventTypes:Bd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Na(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)g=zd,h=Bd.mouseLeave,k=Bd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)g=Ad,h=Bd.pointerLeave,k=Bd.pointerEnter,l="pointer";var m=null==f?e:Pa(f);e=null==b?e:Pa(b);a=g.getPooled(h,f,c,d);a.type=l+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;l=0;for(g=b;g;g=Ra(g))l++;g=0;for(k=e;k;k=Ra(k))g++;for(;0<l-g;)b=Ra(b),l--;for(;0<g-l;)e=Ra(e),g--;for(;l--;){if(b===e||b===e.alternate)break a;b=Ra(b);e=Ra(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=Ra(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=Ra(d)}for(d=0;d<b.length;d++)Ua(b[d],"bubbled",a);for(d=f.length;0<d--;)Ua(f[d],"captured",c);return[a,c]}},Dd=Object.prototype.hasOwnProperty;function Ed(a,b){return a===b?0!==a||0!==b||1/a===1/b:a!==a&&b!==b}
function Fd(a,b){if(Ed(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Dd.call(b,c[d])||!Ed(a[c[d]],b[c[d]]))return!1;return!0}function Gd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function Hd(a){2!==Gd(a)?r("188"):void 0}
function Id(a){var b=a.alternate;if(!b)return b=Gd(a),3===b?r("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return Hd(e),a;if(g===d)return Hd(e),b;g=g.sibling}r("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
void 0:r("189")}}c.alternate!==d?r("190"):void 0}3!==c.tag?r("188"):void 0;return c.stateNode.current===c?a:b}function Jd(a){a=Id(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var Kd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Ld=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Md=rd.extend({relatedTarget:null});function Nd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var Od={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Pd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Qd=rd.extend({key:function(a){if(a.key){var b=Od[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=Nd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Pd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:ud,charCode:function(a){return"keypress"===
a.type?Nd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?Nd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=zd.extend({dataTransfer:null}),Sd=rd.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:ud}),Td=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Ud=zd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Vd=[["abort","abort"],[cb,"animationEnd"],[ib,"animationIteration"],[jb,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[kb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Wd={},Xd={};function Yd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Wd[a]=b;Xd[c]=b}
[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Yd(a,!0)});Vd.forEach(function(a){Yd(a,!1)});
var Zd={eventTypes:Wd,isInteractiveTopLevelEventType:function(a){a=Xd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Xd[a];if(!e)return null;switch(a){case "keypress":if(0===Nd(c))return null;case "keydown":case "keyup":a=Qd;break;case "blur":case "focus":a=Md;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=zd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
Rd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=Sd;break;case cb:case ib:case jb:a=Kd;break;case kb:a=Td;break;case "scroll":a=rd;break;case "wheel":a=Ud;break;case "copy":case "cut":case "paste":a=Ld;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=Ad;break;default:a=y}b=a.getPooled(e,b,c,d);Wa(b);return b}},$d=Zd.isInteractiveTopLevelEventType,
ae=[];function be(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Na(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=ec(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<ra.length;h++){var k=ra[h];k&&(k=k.extractEvents(d,b,f,e))&&(g=Aa(g,k))}Ia(g,!1)}}var ce=!0;
function H(a,b){if(!b)return null;var c=($d(a)?de:ee).bind(null,a);b.addEventListener(a,c,!1)}function ge(a,b){if(!b)return null;var c=($d(a)?de:ee).bind(null,a);b.addEventListener(a,c,!0)}function de(a,b){Zb(ee,a,b)}
function ee(a,b){if(ce){var c=ec(b);c=Na(c);null===c||"number"!==typeof c.tag||2===Gd(c)||(c=null);if(ae.length){var d=ae.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{bc(be,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>ae.length&&ae.push(a)}}}var he={},ie=0,je="_reactListenersID"+(""+Math.random()).slice(2);
function ke(a){Object.prototype.hasOwnProperty.call(a,je)||(a[je]=ie++,he[a[je]]={});return he[a[je]]}function le(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function me(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function ne(a,b){var c=me(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=me(c)}}function oe(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?oe(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function pe(){for(var a=window,b=le();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=le(a.document)}return b}function qe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var re=Xa&&"documentMode"in document&&11>=document.documentMode,se={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},te=null,ue=null,He=null,Ie=!1;
function Je(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(Ie||null==te||te!==le(c))return null;c=te;"selectionStart"in c&&qe(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return He&&Fd(He,c)?null:(He=c,a=y.getPooled(se.select,ue,a,b),a.type="select",a.target=te,Wa(a),a)}
var Ke={eventTypes:se,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=ke(e);f=va.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?Pa(b):window;switch(a){case "focus":if(dc(e)||"true"===e.contentEditable)te=e,ue=b,He=null;break;case "blur":He=ue=te=null;break;case "mousedown":Ie=!0;break;case "contextmenu":case "mouseup":case "dragend":return Ie=!1,Je(c,d);case "selectionchange":if(re)break;
case "keydown":case "keyup":return Je(c,d)}return null}};Ga.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));wa=Qa;xa=Oa;ya=Pa;Ga.injectEventPluginsByName({SimpleEventPlugin:Zd,EnterLeaveEventPlugin:Cd,ChangeEventPlugin:qd,SelectEventPlugin:Ke,BeforeInputEventPlugin:Mb});function Le(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function Me(a,b){a=n({children:void 0},b);if(b=Le(b.children))a.children=b;return a}function Ne(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Pc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Oe(a,b){null!=b.dangerouslySetInnerHTML?r("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Pe(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?r("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:r("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:Pc(c)}}
function Qe(a,b){var c=Pc(b.value),d=Pc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Re(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var Se={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Te(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ue(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Te(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Ve=void 0,We=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Se.svg||"innerHTML"in a)a.innerHTML=b;else{Ve=Ve||document.createElement("div");Ve.innerHTML="<svg>"+b+"</svg>";for(b=Ve.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Xe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var Ye={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ze=["Webkit","ms","Moz","O"];Object.keys(Ye).forEach(function(a){Ze.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Ye[b]=Ye[a]})});
function $e(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Ye.hasOwnProperty(e)&&Ye[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var af=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function bf(a,b){b&&(af[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?r("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?r("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:r("61")),null!=b.style&&"object"!==typeof b.style?r("62",""):void 0)}
function cf(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function df(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=ke(a);b=va[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":ge("scroll",a);break;case "focus":case "blur":ge("focus",a);ge("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":fc(e)&&ge(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===lb.indexOf(e)&&H(e,a)}c[e]=!0}}}function ef(){}var ff=null,gf=null;
function hf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function jf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var kf=setTimeout,lf=clearTimeout;function mf(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}
function nf(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var of=[],pf=-1;function I(a){0>pf||(a.current=of[pf],of[pf]=null,pf--)}function J(a,b){pf++;of[pf]=a.current;a.current=b}var qf={},K={current:qf},L={current:!1},rf=qf;
function sf(a,b){var c=a.type.contextTypes;if(!c)return qf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function tf(a){I(L,a);I(K,a)}function uf(a){I(L,a);I(K,a)}
function vf(a,b,c){K.current!==qf?r("168"):void 0;J(K,b,a);J(L,c,a)}function wf(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:r("108",Ac(b)||"Unknown",e);return n({},c,d)}function xf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||qf;rf=K.current;J(K,b,a);J(L,L.current,a);return!0}
function yf(a,b,c){var d=a.stateNode;d?void 0:r("169");c?(b=wf(a,b,rf),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var zf=null,Af=null;function Bf(a){return function(b){try{return a(b)}catch(c){}}}
function Cf(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);zf=Bf(function(a){return b.onCommitFiberRoot(c,a)});Af=Bf(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
function Df(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.firstContextDependency=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Df(a,b,c,d)}
function Ef(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Ff(a){if("function"===typeof a)return Ef(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===uc)return 11;if(a===wc)return 14}return 2}
function Gf(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.firstContextDependency=a.firstContextDependency;c.sibling=a.sibling;
c.index=a.index;c.ref=a.ref;return c}
function Hf(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)Ef(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case oc:return If(c.children,e,f,b);case tc:return Jf(c,e|3,f,b);case pc:return Jf(c,e|2,f,b);case qc:return a=N(12,c,b,e|4),a.elementType=qc,a.type=qc,a.expirationTime=f,a;case vc:return a=N(13,c,b,e),a.elementType=vc,a.type=vc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case rc:g=10;break a;case sc:g=9;break a;case uc:g=11;break a;case wc:g=
14;break a;case xc:g=16;d=null;break a}r("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function If(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function Jf(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?pc:tc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function Kf(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
function Lf(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function Mf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c>b?a.earliestPendingTime=b:a.latestPendingTime<b&&(a.latestPendingTime=b);Nf(b,a)}
function Of(a,b){a.didError=!1;var c=a.latestPingedTime;0!==c&&c<=b&&(a.latestPingedTime=0);c=a.earliestPendingTime;var d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c>b?a.earliestSuspendedTime=b:d<b&&(a.latestSuspendedTime=b);Nf(b,a)}
function Pf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;if(0===b||0!==c&&c<b)b=c;if(0===b||0!==a&&a<b)b=a;return b}function Nf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d>a)&&(e=d);a=e;0!==a&&0!==c&&c<a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}var Qf=!1;
function Rf(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Sf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Tf(a){return{expirationTime:a,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Uf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Vf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Rf(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Rf(a.memoizedState),e=c.updateQueue=Rf(c.memoizedState)):d=a.updateQueue=Sf(e):null===e&&(e=c.updateQueue=Sf(d));null===e||d===e?Uf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Uf(d,b),Uf(e,b)):(Uf(d,b),e.lastUpdate=b)}
function Wf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Rf(a.memoizedState):Xf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Xf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Sf(b));return b}
function Yf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-1025|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:Qf=!0}return d}
function Zf(a,b,c,d,e){Qf=!1;b=Xf(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;if(m>e){if(null===g&&(g=k,f=l),0===h||h>m)h=m}else l=Yf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var p=k.expirationTime;if(p>e){if(null===m&&(m=k,null===g&&(f=l)),0===h||h>p)h=p}else l=Yf(a,b,k,l,c,d),
null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=l}
function $f(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);ag(b.firstEffect,c);b.firstEffect=b.lastEffect=null;ag(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function ag(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?r("191",c):void 0;c.call(d)}a=a.nextEffect}}
function bg(a,b){return{value:a,source:b,stack:Bc(b)}}var cg={current:null},dg=null,eg=null,fg=null;function gg(a,b){var c=a.type._context;J(cg,c._currentValue,a);c._currentValue=b}function hg(a){var b=cg.current;I(cg,a);a.type._context._currentValue=b}function ig(a){dg=a;fg=eg=null;a.firstContextDependency=null}
function jg(a,b){if(fg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)fg=a,b=1073741823;b={context:a,observedBits:b,next:null};null===eg?(null===dg?r("293"):void 0,dg.firstContextDependency=eg=b):eg=eg.next=b}return a._currentValue}var kg={},O={current:kg},lg={current:kg},mg={current:kg};function ng(a){a===kg?r("174"):void 0;return a}
function og(a,b){J(mg,b,a);J(lg,a,a);J(O,kg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ue(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Ue(b,c)}I(O,a);J(O,b,a)}function pg(a){I(O,a);I(lg,a);I(mg,a)}function qg(a){ng(mg.current);var b=ng(O.current);var c=Ue(b,a.type);b!==c&&(J(lg,a,a),J(O,c,a))}function rg(a){lg.current===a&&(I(O,a),I(lg,a))}var sg=kc.ReactCurrentOwner,tg=(new aa.Component).refs;
function ug(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var yg={isMounted:function(a){return(a=a._reactInternalFiber)?2===Gd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=vg();d=wg(d,a);var e=Tf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Vf(a,e);xg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=vg();d=wg(d,a);var e=Tf(d);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Vf(a,e);xg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=vg();c=wg(c,a);var d=Tf(c);d.tag=2;void 0!==
b&&null!==b&&(d.callback=b);Vf(a,d);xg(a,c)}};function zg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Fd(c,d)||!Fd(e,f):!0}
function Ag(a,b,c){var d=!1,e=qf;var f=b.contextType;"object"===typeof f&&null!==f?f=sg.currentDispatcher.readContext(f):(e=M(b)?rf:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?sf(a,e):qf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=yg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Bg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&yg.enqueueReplaceState(b,b.state,null)}
function Cg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=tg;var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg.currentDispatcher.readContext(f):(f=M(b)?rf:K.current,e.context=sf(a,f));f=a.updateQueue;null!==f&&(Zf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(ug(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&
"function"!==typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&yg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Zf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Dg=Array.isArray;
function Eg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?r("289"):void 0,d=c.stateNode);d?void 0:r("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===tg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?r("284"):void 0;c._owner?void 0:r("290",a)}return a}
function Fg(a,b){"textarea"!==a.type&&r("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
function Gg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=Gf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Kf(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Eg(a,b,c),d.return=a,d;d=Hf(c.type,c.key,c.props,null,a.mode,d);d.ref=Eg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Lf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=If(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Kf(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case mc:return c=Hf(b.type,b.key,b.props,null,a.mode,c),c.ref=Eg(a,null,b),c.return=a,c;case nc:return b=Lf(b,a.mode,c),b.return=a,b}if(Dg(b)||
zc(b))return b=If(b,a.mode,c,null),b.return=a,b;Fg(a,b)}return null}function v(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case mc:return c.key===e?c.type===oc?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case nc:return c.key===e?l(a,b,c,d):null}if(Dg(c)||zc(c))return null!==e?null:m(a,b,c,d,null);Fg(a,c)}return null}function B(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case mc:return a=a.get(null===d.key?c:d.key)||null,d.type===oc?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case nc:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Dg(d)||zc(d))return a=a.get(c)||null,m(b,a,d,e,null);Fg(b,d)}return null}function w(e,g,h,k){for(var l=null,m=null,q=g,u=g=0,A=null;null!==q&&u<h.length;u++){q.index>u?(A=q,q=null):A=q.sibling;var t=v(e,q,h[u],k);if(null===t){null===q&&(q=A);break}a&&
q&&null===t.alternate&&b(e,q);g=f(t,g,u);null===m?l=t:m.sibling=t;m=t;q=A}if(u===h.length)return c(e,q),l;if(null===q){for(;u<h.length;u++)if(q=p(e,h[u],k))g=f(q,g,u),null===m?l=q:m.sibling=q,m=q;return l}for(q=d(e,q);u<h.length;u++)if(A=B(q,e,u,h[u],k))a&&null!==A.alternate&&q.delete(null===A.key?u:A.key),g=f(A,g,u),null===m?l=A:m.sibling=A,m=A;a&&q.forEach(function(a){return b(e,a)});return l}function C(e,g,h,k){var l=zc(h);"function"!==typeof l?r("150"):void 0;h=l.call(h);null==h?r("151"):void 0;
for(var m=l=null,q=g,u=g=0,A=null,t=h.next();null!==q&&!t.done;u++,t=h.next()){q.index>u?(A=q,q=null):A=q.sibling;var w=v(e,q,t.value,k);if(null===w){q||(q=A);break}a&&q&&null===w.alternate&&b(e,q);g=f(w,g,u);null===m?l=w:m.sibling=w;m=w;q=A}if(t.done)return c(e,q),l;if(null===q){for(;!t.done;u++,t=h.next())t=p(e,t.value,k),null!==t&&(g=f(t,g,u),null===m?l=t:m.sibling=t,m=t);return l}for(q=d(e,q);!t.done;u++,t=h.next())t=B(q,e,u,t.value,k),null!==t&&(a&&null!==t.alternate&&q.delete(null===t.key?u:
t.key),g=f(t,g,u),null===m?l=t:m.sibling=t,m=t);a&&q.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===oc&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case mc:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===oc:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===oc?f.props.children:f.props,h);d.ref=Eg(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
k.sibling}f.type===oc?(d=If(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Hf(f.type,f.key,f.props,null,a.mode,h),h.ref=Eg(a,d,f),h.return=a,a=h)}return g(a);case nc:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=Lf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=Kf(f,a.mode,h),d.return=a,a=d),g(a);if(Dg(f))return w(a,d,f,h);if(zc(f))return C(a,d,f,h);l&&Fg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,r("152",h.displayName||h.name||"Component")}return c(a,d)}}var Hg=Gg(!0),Ig=Gg(!1),Jg=null,Kg=null,Lg=!1;
function Mg(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Ng(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
function Og(a){if(Lg){var b=Kg;if(b){var c=b;if(!Ng(a,b)){b=mf(c);if(!b||!Ng(a,b)){a.effectTag|=2;Lg=!1;Jg=a;return}Mg(Jg,c)}Jg=a;Kg=nf(b)}else a.effectTag|=2,Lg=!1,Jg=a}}function Pg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Jg=a}function Qg(a){if(a!==Jg)return!1;if(!Lg)return Pg(a),Lg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!jf(b,a.memoizedProps))for(b=Kg;b;)Mg(a,b),b=mf(b);Pg(a);Kg=Jg?mf(a.stateNode):null;return!0}function Rg(){Kg=Jg=null;Lg=!1}
function Sg(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:throw a._status=0,b=a._ctor,b=b(),b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)}),a._result=b,b;}}var Tg=kc.ReactCurrentOwner;function P(a,b,c,d){b.child=null===a?Ig(b,null,c,d):Hg(b,a.child,c,d)}
function Ug(a,b,c,d,e){c=c.render;var f=b.ref;if(!L.current&&b.memoizedProps===d&&f===(null!==a?a.ref:null))return Vg(a,b,e);d=c(d,f);P(a,b,d,e);return b.child}
function Wg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!Ef(g)&&void 0===g.defaultProps&&null===c.compare)return b.tag=15,b.type=g,Xg(a,b,g,d,e,f);a=Hf(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===e||e>f)if(e=g.memoizedProps,c=c.compare,c=null!==c?c:Fd,c(e,d)&&a.ref===b.ref)return Vg(a,b,f);a=Gf(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Xg(a,b,c,d,e,f){return null!==a&&(0===e||e>f)&&Fd(a.memoizedProps,d)&&a.ref===b.ref?Vg(a,b,f):Yg(a,b,c,d,f)}function Zg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Yg(a,b,c,d,e){var f=M(c)?rf:K.current;f=sf(b,f);ig(b,e);c=c(d,f);b.effectTag|=1;P(a,b,c,e);return b.child}
function $g(a,b,c,d,e){if(M(c)){var f=!0;xf(b)}else f=!1;ig(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ag(b,c,d,e),Cg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg.currentDispatcher.readContext(l):(l=M(c)?rf:K.current,l=sf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Bg(b,g,d,l);Qf=!1;var v=b.memoizedState;k=g.state=v;var B=b.updateQueue;null!==B&&(Zf(b,B,d,g,e),k=b.memoizedState);h!==d||v!==k||L.current||Qf?("function"===typeof m&&(ug(b,c,m,d),k=b.memoizedState),(h=Qf||zg(b,c,h,d,v,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=h,k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg.currentDispatcher.readContext(l):(l=M(c)?rf:K.current,l=sf(b,l)),m=c.getDerivedStateFromProps,(p="function"===
typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Bg(b,g,d,l),Qf=!1,k=b.memoizedState,v=g.state=k,B=b.updateQueue,null!==B&&(Zf(b,B,d,g,e),v=b.memoizedState),h!==d||k!==v||L.current||Qf?("function"===typeof m&&(ug(b,c,m,d),v=b.memoizedState),(m=Qf||zg(b,c,h,d,k,v,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
typeof g.componentWillUpdate&&g.componentWillUpdate(d,v,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,v,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
v),g.props=d,g.state=v,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return ah(a,b,c,d,f,e)}
function ah(a,b,c,d,e,f){Zg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&yf(b,c,!1),Vg(a,b,f);d=b.stateNode;Tg.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Hg(b,a.child,null,f),b.child=Hg(b,null,h,f)):P(a,b,h,f);b.memoizedState=d.state;e&&yf(b,c,!0);return b.child}function bh(a){var b=a.stateNode;b.pendingContext?vf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&vf(a,b.context,!1);og(a,b.containerInfo)}
function ch(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function dh(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;null!==f&&(f.alreadyCaptured?null!==a&&f===a.memoizedState?f={alreadyCaptured:!0,didTimeout:!0,timedOutAt:f.timedOutAt}:(f.alreadyCaptured=!0,f.didTimeout=!0):f=null);var g=null!==f&&f.didTimeout;if(null===a)g?(g=e.fallback,e=If(null,d,0,null),d=If(g,d,c,null),e.sibling=d,c=e,c.return=d.return=b):c=d=Ig(b,null,e.children,c);else{var h=a.memoizedState;null!==h&&h.didTimeout?(d=a.child,a=d.sibling,g?(c=e.fallback,d=Gf(d,d.pendingProps,
0),d.effectTag|=2,e=d.sibling=Gf(a,c,a.expirationTime),e.effectTag|=2,c=d,d.childExpirationTime=0,d=e,c.return=d.return=b):(g=a.child,d=Hg(b,d.child,e.children,c),Hg(b,g,null,c),c=d)):(a=a.child,g?(g=e.fallback,e=If(null,d,0,null),e.effectTag|=2,e.child=a,a.return=e,d=e.sibling=If(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=Hg(b,a,e.children,c))}b.memoizedState=f;b.child=c;return d}
function Vg(a,b,c){null!==a&&(b.firstContextDependency=a.firstContextDependency);var d=b.childExpirationTime;if(0===d||d>c)return null;null!==a&&b.child!==a.child?r("153"):void 0;if(null!==b.child){a=b.child;c=Gf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Gf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
function eh(a,b,c){var d=b.expirationTime;if(null!==a&&a.memoizedProps===b.pendingProps&&!L.current&&(0===d||d>c)){switch(b.tag){case 3:bh(b);Rg();break;case 5:qg(b);break;case 1:M(b.type)&&xf(b);break;case 4:og(b,b.stateNode.containerInfo);break;case 10:gg(b,b.memoizedProps.value);break;case 13:if(d=b.memoizedState,null!==d&&d.didTimeout){d=b.child.childExpirationTime;if(0!==d&&d<=c)return dh(a,b,c);b=Vg(a,b,c);return null!==b?b.sibling:null}}return Vg(a,b,c)}b.expirationTime=0;switch(b.tag){case 2:d=
b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=sf(b,K.current);ig(b,c);e=d(a,e);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;if(M(d)){var f=!0;xf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&ug(b,d,g,a);e.updater=yg;b.stateNode=e;e._reactInternalFiber=b;Cg(b,d,a,c);b=ah(null,b,d,!0,f,c)}else b.tag=0,
P(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=Sg(e);b.type=a;e=b.tag=Ff(a);f=ch(a,f);g=void 0;switch(e){case 0:g=Yg(null,b,a,f,c);break;case 1:g=$g(null,b,a,f,c);break;case 11:g=Ug(null,b,a,f,c);break;case 14:g=Wg(null,b,a,ch(a.type,f),d,c);break;default:r("283",a)}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),Yg(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===
d?e:ch(d,e),$g(a,b,d,e,c);case 3:bh(b);d=b.updateQueue;null===d?r("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;Zf(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Rg(),b=Vg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Kg=nf(b.stateNode.containerInfo),Jg=b,e=Lg=!0;e?(b.effectTag|=2,b.child=Ig(b,null,d,c)):(P(a,b,d,c),Rg());b=b.child}return b;case 5:return qg(b),null===a&&Og(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,jf(d,
e)?g=null:null!==f&&jf(d,f)&&(b.effectTag|=16),Zg(a,b),1073741823!==c&&b.mode&1&&e.hidden?(b.expirationTime=1073741823,b=null):(P(a,b,g,c),b=b.child),b;case 6:return null===a&&Og(b),null;case 13:return dh(a,b,c);case 4:return og(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Hg(b,null,d,c):P(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),Ug(a,b,d,e,c);case 7:return P(a,b,b.pendingProps,c),b.child;case 8:return P(a,b,b.pendingProps.children,
c),b.child;case 12:return P(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;gg(b,f);if(null!==g){var h=g.value;f=h===f&&(0!==h||1/h===1/f)||h!==h&&f!==f?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=Vg(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){h=g.firstContextDependency;if(null!==h){do{if(h.context===d&&0!==(h.observedBits&
f)){if(1===g.tag){var k=Tf(c);k.tag=2;Vf(g,k)}if(0===g.expirationTime||g.expirationTime>c)g.expirationTime=c;k=g.alternate;null!==k&&(0===k.expirationTime||k.expirationTime>c)&&(k.expirationTime=c);for(var l=g.return;null!==l;){k=l.alternate;if(0===l.childExpirationTime||l.childExpirationTime>c)l.childExpirationTime=c,null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c)&&(k.childExpirationTime=c);else if(null!==k&&(0===k.childExpirationTime||k.childExpirationTime>c))k.childExpirationTime=
c;else break;l=l.return}}k=g.child;h=h.next}while(null!==h)}else k=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==k)k.return=g;else for(k=g;null!==k;){if(k===b){k=null;break}g=k.sibling;if(null!==g){g.return=k.return;k=g;break}k=k.return}g=k}}P(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,ig(b,c),e=jg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,P(a,b,d,c),b.child;case 14:return e=b.type,f=ch(e.type,b.pendingProps),Wg(a,b,e,f,d,c);case 15:return Xg(a,
b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ch(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=!0,xf(b)):a=!1,ig(b,c),Ag(b,d,e,c),Cg(b,d,e,c),ah(null,b,d,!0,a,c);default:r("156")}}function zh(a){a.effectTag|=4}var Ah=void 0,Bh=void 0,Ch=void 0,Dh=void 0;
Ah=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Bh=function(){};
Ch=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ng(O.current);a=null;switch(c){case "input":f=Qc(g,f);d=Qc(g,d);a=[];break;case "option":f=Me(g,f);d=Me(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Oe(g,f);d=Oe(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ef)}bf(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(g in k)k.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ua.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(g in k)!k.hasOwnProperty(g)||l&&l.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in l)l.hasOwnProperty(g)&&k[g]!==l[g]&&(h||
(h={}),h[g]=l[g])}else h||(a||(a=[]),a.push(c,h)),h=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ua.hasOwnProperty(c)?(null!=l&&df(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&zh(b)}};Dh=function(a,b,c,d){c!==d&&zh(b)};
function Eh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Bc(c));null!==c&&Ac(c.type);b=b.value;null!==a&&1===a.tag&&Ac(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Fh(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Gh(a,c)}else b.current=null}
function Hh(a){"function"===typeof Af&&Af(a);switch(a.tag){case 1:Fh(a);var b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Gh(a,c)}break;case 5:Fh(a);break;case 4:Ih(a)}}function Jh(a){return 5===a.tag||3===a.tag||4===a.tag}
function Kh(a){a:{for(var b=a.return;null!==b;){if(Jh(b)){var c=b;break a}b=b.return}r("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:r("161")}c.effectTag&16&&(Xe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Jh(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=ef)):b.appendChild(e.stateNode);
else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Ih(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?r("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Hh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Hh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
function Lh(a,b){switch(b.tag){case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ma]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Sc(c,d);cf(a,e);b=cf(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?$e(c,h):"dangerouslySetInnerHTML"===g?We(c,h):"children"===g?Xe(c,h):Oc(c,g,h,b)}switch(a){case "input":Tc(c,d);break;case "textarea":Qe(c,d);break;case "select":a=c._wrapperState.wasMultiple,
c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?Ne(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?Ne(c,!!d.multiple,d.defaultValue,!0):Ne(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:null===b.stateNode?r("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:break;case 17:break;default:r("163")}}function Mh(a,b,c){c=Tf(c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Nh(d);Eh(a,b)};return c}
function Oh(a,b,c){c=Tf(c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ph?Ph=new Set([this]):Ph.add(this));var c=b.value,e=b.stack;Eh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
function Qh(a){switch(a.tag){case 1:M(a.type)&&tf(a);var b=a.effectTag;return b&1024?(a.effectTag=b&-1025|64,a):null;case 3:return pg(a),uf(a),b=a.effectTag,0!==(b&64)?r("285"):void 0,a.effectTag=b&-1025|64,a;case 5:return rg(a),null;case 13:b=a.effectTag;if(b&1024){a.effectTag=b&-1025|64;b=a.alternate;b=null!==b?b.memoizedState:null;var c=a.memoizedState;null===c?c={alreadyCaptured:!0,didTimeout:!1,timedOutAt:0}:b===c?c={alreadyCaptured:!0,didTimeout:c.didTimeout,timedOutAt:c.timedOutAt}:c.alreadyCaptured=
!0;a.memoizedState=c;return a}return null;case 4:return pg(a),null;case 10:return hg(a),null;default:return null}}var Rh={readContext:jg},Sh=kc.ReactCurrentOwner,Th=0,Uh=0,Vh=!1,Q=null,R=null,S=0,Wh=-1,Xh=!1,T=null,Yh=!1,Ph=null;function Zh(){if(null!==Q)for(var a=Q.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&tf(b);break;case 3:pg(b);uf(b);break;case 5:rg(b);break;case 4:pg(b);break;case 10:hg(b)}a=a.return}R=null;S=0;Wh=-1;Xh=!1;Q=null}
function $h(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&512)){var e=b;b=a;var f=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&tf(b);break;case 3:pg(b);uf(b);f=b.stateNode;f.pendingContext&&(f.context=f.pendingContext,f.pendingContext=null);if(null===e||null===e.child)Qg(b),b.effectTag&=-3;Bh(b);break;case 5:rg(b);var g=ng(mg.current),h=b.type;if(null!==e&&null!=b.stateNode)Ch(e,b,h,f,g),e.ref!==b.ref&&(b.effectTag|=128);
else if(f){var k=ng(O.current);if(Qg(b)){f=b;e=f.stateNode;var l=f.type,m=f.memoizedProps,p=g;e[La]=f;e[Ma]=m;h=void 0;g=l;switch(g){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(l=0;l<lb.length;l++)H(lb[l],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Rc(e,m);H("invalid",e);df(p,"onChange");break;case "select":e._wrapperState=
{wasMultiple:!!m.multiple};H("invalid",e);df(p,"onChange");break;case "textarea":Pe(e,m),H("invalid",e),df(p,"onChange")}bf(g,m);l=null;for(h in m)m.hasOwnProperty(h)&&(k=m[h],"children"===h?"string"===typeof k?e.textContent!==k&&(l=["children",k]):"number"===typeof k&&e.textContent!==""+k&&(l=["children",""+k]):ua.hasOwnProperty(h)&&null!=k&&df(p,h));switch(g){case "input":ic(e);bd(e,m,!0);break;case "textarea":ic(e);Re(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
(e.onclick=ef)}h=l;f.updateQueue=h;f=null!==h?!0:!1;f&&zh(b)}else{m=b;e=h;p=f;l=9===g.nodeType?g:g.ownerDocument;k===Se.html&&(k=Te(e));k===Se.html?"script"===e?(e=l.createElement("div"),e.innerHTML="<script>\x3c/script>",l=e.removeChild(e.firstChild)):"string"===typeof p.is?l=l.createElement(e,{is:p.is}):(l=l.createElement(e),"select"===e&&p.multiple&&(l.multiple=!0)):l=l.createElementNS(k,e);e=l;e[La]=m;e[Ma]=f;Ah(e,b,!1,!1);p=e;l=h;m=f;var v=g,B=cf(l,m);switch(l){case "iframe":case "object":H("load",
p);g=m;break;case "video":case "audio":for(g=0;g<lb.length;g++)H(lb[g],p);g=m;break;case "source":H("error",p);g=m;break;case "img":case "image":case "link":H("error",p);H("load",p);g=m;break;case "form":H("reset",p);H("submit",p);g=m;break;case "details":H("toggle",p);g=m;break;case "input":Rc(p,m);g=Qc(p,m);H("invalid",p);df(v,"onChange");break;case "option":g=Me(p,m);break;case "select":p._wrapperState={wasMultiple:!!m.multiple};g=n({},m,{value:void 0});H("invalid",p);df(v,"onChange");break;case "textarea":Pe(p,
m);g=Oe(p,m);H("invalid",p);df(v,"onChange");break;default:g=m}bf(l,g);k=void 0;var w=l,C=p,u=g;for(k in u)if(u.hasOwnProperty(k)){var q=u[k];"style"===k?$e(C,q):"dangerouslySetInnerHTML"===k?(q=q?q.__html:void 0,null!=q&&We(C,q)):"children"===k?"string"===typeof q?("textarea"!==w||""!==q)&&Xe(C,q):"number"===typeof q&&Xe(C,""+q):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ua.hasOwnProperty(k)?null!=q&&df(v,k):null!=q&&Oc(C,k,q,B))}switch(l){case "input":ic(p);
bd(p,m,!1);break;case "textarea":ic(p);Re(p,m);break;case "option":null!=m.value&&p.setAttribute("value",""+Pc(m.value));break;case "select":g=p;g.multiple=!!m.multiple;p=m.value;null!=p?Ne(g,!!m.multiple,p,!1):null!=m.defaultValue&&Ne(g,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof g.onClick&&(p.onclick=ef)}(f=hf(h,f))&&zh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?r("166"):void 0;break;case 6:e&&null!=b.stateNode?Dh(e,b,e.memoizedProps,f):("string"!==
typeof f&&(null===b.stateNode?r("166"):void 0),e=ng(mg.current),ng(O.current),Qg(b)?(f=b,h=f.stateNode,e=f.memoizedProps,h[La]=f,(f=h.nodeValue!==e)&&zh(b)):(h=b,f=(9===e.nodeType?e:e.ownerDocument).createTextNode(f),f[La]=b,h.stateNode=f));break;case 11:break;case 13:f=b.memoizedState;h=null!==e?e.memoizedState:null;(null!==f&&f.didTimeout)!==(null!==h&&h.didTimeout)&&(b.effectTag|=4);break;case 7:break;case 8:break;case 12:break;case 4:pg(b);Bh(b);break;case 10:hg(b);break;case 9:break;case 14:break;
case 17:M(b.type)&&tf(b);break;default:r("156")}Q=null;b=a;if(1073741823===S||1073741823!==b.childExpirationTime){f=0;for(h=b.child;null!==h;){e=h.expirationTime;g=h.childExpirationTime;if(0===f||0!==e&&e<f)f=e;if(0===f||0!==g&&g<f)f=g;h=h.sibling}b.childExpirationTime=f}null!==c&&0===(c.effectTag&512)&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?
c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Qh(a,S);if(null!==a)return a.effectTag&=511,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=512)}if(null!==d)return d;if(null!==c)a=c;else break}return null}function ai(a){var b=eh(a.alternate,a,S);a.memoizedProps=a.pendingProps;null===b&&(b=$h(a));Sh.current=null;return b}
function bi(a,b,c){Vh?r("243"):void 0;Vh=!0;Sh.currentDispatcher=Rh;var d=a.nextExpirationTimeToWorkOn;if(d!==S||a!==R||null===Q)Zh(),R=a,S=d,Q=Gf(R.current,null,S),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==Q&&!ci();)Q=ai(Q);else for(;null!==Q;)Q=ai(Q)}catch(C){if(null===Q)e=!0,Nh(C);else{null===Q?r("271"):void 0;var f=Q,g=f.return;if(null===g)e=!0,Nh(C);else{a:{var h=a,k=g,l=f,m=C;g=S;l.effectTag|=512;l.firstEffect=l.lastEffect=null;if(null!==m&&"object"===typeof m&&"function"===
typeof m.then){var p=m;m=k;var v=-1,B=-1;do{if(13===m.tag){var w=m.alternate;if(null!==w&&(w=w.memoizedState,null!==w&&w.didTimeout)){B=10*(w.timedOutAt-2);break}w=m.pendingProps.maxDuration;if("number"===typeof w)if(0>=w)v=0;else if(-1===v||w<v)v=w}m=m.return}while(null!==m);m=k;do{if(w=13===m.tag)void 0===m.memoizedProps.fallback?w=!1:(w=m.memoizedState,w=null===w||!w.didTimeout);if(w){k=di.bind(null,h,m,l,0===(m.mode&1)?1:g);p.then(k,k);if(0===(m.mode&1)){m.effectTag|=32;P(l.alternate,l,null,g);
l.effectTag&=-513;1===l.tag&&(l.effectTag&=-421,null===l.alternate&&(l.tag=17));break a}-1===v?h=1073741823:(-1===B&&(B=10*(Pf(h,g)-2)-5E3),h=B+v);0<=h&&Wh<h&&(Wh=h);m.effectTag|=1024;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error("An update was suspended, but no placeholder UI was provided.")}Xh=!0;m=bg(m,l);h=k;do{switch(h.tag){case 3:l=m;h.effectTag|=1024;h.expirationTime=g;g=Mh(h,l,g);Wf(h,g);break a;case 1:if(l=m,k=h.type,p=h.stateNode,0===(h.effectTag&64)&&("function"===typeof k.getDerivedStateFromError||
null!==p&&"function"===typeof p.componentDidCatch&&(null===Ph||!Ph.has(p)))){h.effectTag|=1024;h.expirationTime=g;g=Oh(h,l,g);Wf(h,g);break a}}h=h.return}while(null!==h)}Q=$h(f);continue}}}break}while(1);Vh=!1;fg=eg=dg=Sh.currentDispatcher=null;if(e)R=null,a.finishedWork=null;else if(null!==Q)a.finishedWork=null;else{b=a.current.alternate;null===b?r("281"):void 0;R=null;if(Xh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e>d||0!==f&&f>d||0!==g&&g>d){Of(a,d);ei(a,b,
d,a.expirationTime,-1);return}if(!a.didError&&!c){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;c=a.expirationTime=1;ei(a,b,d,c,-1);return}}c||-1===Wh?(a.pendingCommitExpirationTime=d,a.finishedWork=b):(Of(a,d),c=10*(Pf(a,d)-2),c<Wh&&(Wh=c),c=10*(vg()-2),c=Wh-c,ei(a,b,d,a.expirationTime,0>c?0:c))}}
function Gh(a,b){var c;a:{Vh&&!Yh?r("263"):void 0;for(c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ph||!Ph.has(d))){a=bg(b,a);a=Oh(c,a,1);Vf(c,a);xg(c,1);c=void 0;break a}break;case 3:a=bg(b,a);a=Mh(c,a,1);Vf(c,a);xg(c,1);c=void 0;break a}c=c.return}3===a.tag&&(c=bg(b,a),c=Mh(a,c,1),Vf(a,c),xg(a,1));c=void 0}return c}
function wg(a,b){0!==Uh?a=Uh:Vh?a=Yh?1:S:b.mode&1?(a=fi?2+10*(((a-2+15)/10|0)+1):2+25*(((a-2+500)/25|0)+1),null!==R&&a===S&&(a+=1)):a=1;fi&&a>gi&&(gi=a);return a}
function di(a,b,c,d){var e=a.earliestSuspendedTime;var f=a.latestSuspendedTime;if(0!==e&&d>=e&&d<=f){f=e=d;a.didError=!1;var g=a.latestPingedTime;if(0===g||g<f)a.latestPingedTime=f;Nf(f,a)}else e=vg(),e=wg(e,b),Mf(a,e);0!==(b.mode&1)&&a===R&&S===d&&(R=null);hi(b,e);0===(b.mode&1)&&(hi(c,e),1===c.tag&&null!==c.stateNode&&(b=Tf(e),b.tag=2,Vf(c,b)));c=a.expirationTime;0!==c&&ii(a,c)}
function hi(a,b){if(0===a.expirationTime||a.expirationTime>b)a.expirationTime=b;var c=a.alternate;null!==c&&(0===c.expirationTime||c.expirationTime>b)&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;if(0===d.childExpirationTime||d.childExpirationTime>b)d.childExpirationTime=b;null!==c&&(0===c.childExpirationTime||c.childExpirationTime>b)&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return null===
e?null:e}function xg(a,b){a=hi(a,b);null!==a&&(!Vh&&0!==S&&b<S&&Zh(),Mf(a,b),Vh&&!Yh&&R===a||ii(a,a.expirationTime),ji>ki&&(ji=0,r("185")))}function li(a,b,c,d,e){var f=Uh;Uh=1;try{return a(b,c,d,e)}finally{Uh=f}}var U=null,V=null,mi=0,ni=void 0,W=!1,X=null,Y=0,gi=0,oi=!1,pi=!1,qi=null,ri=null,Z=!1,si=!1,fi=!1,ti=null,ui=da.unstable_now(),vi=(ui/10|0)+2,wi=vi,ki=50,ji=0,xi=null,yi=1;function zi(){vi=((da.unstable_now()-ui)/10|0)+2}
function Ai(a,b){if(0!==mi){if(b>mi)return;null!==ni&&da.unstable_cancelCallback(ni)}mi=b;a=da.unstable_now()-ui;ni=da.unstable_scheduleCallback(Bi,{timeout:10*(b-2)-a})}function ei(a,b,c,d,e){a.expirationTime=d;0!==e||ci()?0<e&&(a.timeoutHandle=kf(Ci.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Ci(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;zi();wi=vi;Di(a,c)}function vg(){if(W)return wi;Ei();if(0===Y||1073741823===Y)zi(),wi=vi;return wi}
function ii(a,b){if(null===a.nextScheduledRoot)a.expirationTime=b,null===V?(U=V=a,a.nextScheduledRoot=a):(V=V.nextScheduledRoot=a,V.nextScheduledRoot=U);else{var c=a.expirationTime;if(0===c||b<c)a.expirationTime=b}W||(Z?si&&(X=a,Y=1,Fi(a,1,!0)):1===b?Gi(1,null):Ai(a,b))}
function Ei(){var a=0,b=null;if(null!==V)for(var c=V,d=U;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===V?r("244"):void 0;if(d===d.nextScheduledRoot){U=V=d.nextScheduledRoot=null;break}else if(d===U)U=e=d.nextScheduledRoot,V.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===V){V=c;V.nextScheduledRoot=U;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{if(0===a||e<a)a=e,b=d;if(d===V)break;if(1===a)break;
c=d;d=d.nextScheduledRoot}}X=b;Y=a}function Bi(a){if(a.didTimeout&&null!==U){zi();var b=U;do{var c=b.expirationTime;0!==c&&vi>=c&&(b.nextExpirationTimeToWorkOn=vi);b=b.nextScheduledRoot}while(b!==U)}Gi(0,a)}
function Gi(a,b){ri=b;Ei();if(null!==ri)for(zi(),wi=vi;null!==X&&0!==Y&&(0===a||a>=Y)&&(!oi||vi>=Y);)Fi(X,Y,vi>=Y),Ei(),zi(),wi=vi;else for(;null!==X&&0!==Y&&(0===a||a>=Y);)Fi(X,Y,!0),Ei();null!==ri&&(mi=0,ni=null);0!==Y&&Ai(X,Y);ri=null;oi=!1;ji=0;xi=null;if(null!==ti)for(a=ti,ti=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){pi||(pi=!0,qi=d)}}if(pi)throw a=qi,qi=null,pi=!1,a;}function Di(a,b){W?r("253"):void 0;X=a;Y=b;Fi(a,b,!0);Gi(1,null)}
function Fi(a,b,c){W?r("245"):void 0;W=!0;if(null===ri||c){var d=a.finishedWork;null!==d?Hi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,lf(d)),bi(a,!1,c),d=a.finishedWork,null!==d&&Hi(a,d,b))}else d=a.finishedWork,null!==d?Hi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,lf(d)),bi(a,!0,c),d=a.finishedWork,null!==d&&(ci()?a.finishedWork=d:Hi(a,d,b)));W=!1}
function Hi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime<=c&&(null===ti?ti=[d]:ti.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===xi?ji++:(xi=a,ji=0);Yh=Vh=!0;a.current===b?r("177"):void 0;var e=a.pendingCommitExpirationTime;0===e?r("261"):void 0;a.pendingCommitExpirationTime=0;var f=b.expirationTime,g=b.childExpirationTime,h=0===f||0!==g&&g<f?g:f;a.didError=!1;if(0===h)a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=
0,a.latestPingedTime=0;else{var k=a.latestPendingTime;0!==k&&(k<h?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime<h&&(a.earliestPendingTime=a.latestPendingTime));var l=a.earliestSuspendedTime;0===l?Mf(a,h):h>a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,Mf(a,h)):h<l&&Mf(a,h)}Nf(0,a);Sh.current=null;if(1<b.effectTag)if(null!==b.lastEffect){b.lastEffect.nextEffect=b;var m=b.firstEffect}else m=b;else m=b.firstEffect;ff=ce;var p=pe();if(qe(p)){if("selectionStart"in
p)var v={start:p.selectionStart,end:p.selectionEnd};else a:{var B=p.ownerDocument,w=B&&B.defaultView||window,C=w.getSelection&&w.getSelection();if(C&&0!==C.rangeCount){var u=C.anchorNode,q=C.anchorOffset,A=C.focusNode,fe=C.focusOffset;try{u.nodeType,A.nodeType}catch(db){v=null;break a}var Ib=0,Jc=-1,Kc=-1,Ni=0,Oi=0,t=p,Jb=null;b:for(;;){for(var Lc;;){t!==u||0!==q&&3!==t.nodeType||(Jc=Ib+q);t!==A||0!==fe&&3!==t.nodeType||(Kc=Ib+fe);3===t.nodeType&&(Ib+=t.nodeValue.length);if(null===(Lc=t.firstChild))break;
Jb=t;t=Lc}for(;;){if(t===p)break b;Jb===u&&++Ni===q&&(Jc=Ib);Jb===A&&++Oi===fe&&(Kc=Ib);if(null!==(Lc=t.nextSibling))break;t=Jb;Jb=t.parentNode}t=Lc}v=-1===Jc||-1===Kc?null:{start:Jc,end:Kc}}else v=null}var fh=v||{start:0,end:0}}else fh=null;gf={focusedElem:p,selectionRange:fh};ce=!1;for(T=m;null!==T;){var gh=!1,hh=void 0;try{for(;null!==T;){if(T.effectTag&256){var ve=T.alternate;a:{var Qb=T;switch(Qb.tag){case 1:if(Qb.effectTag&256&&null!==ve){var Zi=ve.memoizedProps,$i=ve.memoizedState,Vc=Qb.stateNode;
Vc.props=Qb.memoizedProps;Vc.state=Qb.memoizedState;var aj=Vc.getSnapshotBeforeUpdate(Zi,$i);Vc.__reactInternalSnapshotBeforeUpdate=aj}break a;case 3:case 5:case 6:case 4:case 17:break a;default:r("163")}}}T=T.nextEffect}}catch(db){gh=!0,hh=db}gh&&(null===T?r("178"):void 0,Gh(T,hh),null!==T&&(T=T.nextEffect))}for(T=m;null!==T;){var ih=!1,jh=void 0;try{for(;null!==T;){var we=T.effectTag;we&16&&Xe(T.stateNode,"");if(we&128){var kh=T.alternate;if(null!==kh){var Wc=kh.ref;null!==Wc&&("function"===typeof Wc?
Wc(null):Wc.current=null)}}switch(we&14){case 2:Kh(T);T.effectTag&=-3;break;case 6:Kh(T);T.effectTag&=-3;Lh(T.alternate,T);break;case 4:Lh(T.alternate,T);break;case 8:var lh=T;Ih(lh);var Rb=lh;Rb.return=null;Rb.child=null;Rb.alternate&&(Rb.alternate.child=null,Rb.alternate.return=null)}T=T.nextEffect}}catch(db){ih=!0,jh=db}ih&&(null===T?r("178"):void 0,Gh(T,jh),null!==T&&(T=T.nextEffect))}var mh=gf,bj=pe(),E=mh.focusedElem,eb=mh.selectionRange;if(bj!==E&&E&&E.ownerDocument&&oe(E.ownerDocument.documentElement,
E)){if(null!==eb&&qe(E)){var nh=eb.start,xe=eb.end;void 0===xe&&(xe=nh);if("selectionStart"in E)E.selectionStart=nh,E.selectionEnd=Math.min(xe,E.value.length);else{var ye=E.ownerDocument||document,ba=(ye&&ye.defaultView||window).getSelection(),oh=E.textContent.length,fb=Math.min(eb.start,oh),Sb=void 0===eb.end?fb:Math.min(eb.end,oh);if(!ba.extend&&fb>Sb){var cj=Sb;Sb=fb;fb=cj}var Tb=ne(E,fb),Ja=ne(E,Sb);if(Tb&&Ja&&(1!==ba.rangeCount||ba.anchorNode!==Tb.node||ba.anchorOffset!==Tb.offset||ba.focusNode!==
Ja.node||ba.focusOffset!==Ja.offset)){var Xc=ye.createRange();Xc.setStart(Tb.node,Tb.offset);ba.removeAllRanges();fb>Sb?(ba.addRange(Xc),ba.extend(Ja.node,Ja.offset)):(Xc.setEnd(Ja.node,Ja.offset),ba.addRange(Xc))}}}for(var ze=[],gb=E;gb=gb.parentNode;)1===gb.nodeType&&ze.push({element:gb,left:gb.scrollLeft,top:gb.scrollTop});"function"===typeof E.focus&&E.focus();for(var Ae=0;Ae<ze.length;Ae++){var Yc=ze[Ae];Yc.element.scrollLeft=Yc.left;Yc.element.scrollTop=Yc.top}}gf=null;ce=!!ff;ff=null;a.current=
b;for(T=m;null!==T;){var ph=!1,qh=void 0;try{for(var dj=e;null!==T;){var rh=T.effectTag;if(rh&36){var Zc=void 0,hb=T.alternate,x=T,sh=dj;switch(x.tag){case 1:var ca=x.stateNode;if(x.effectTag&4)if(null===hb)ca.props=x.memoizedProps,ca.state=x.memoizedState,ca.componentDidMount();else{var ej=hb.memoizedProps,fj=hb.memoizedState;ca.props=x.memoizedProps;ca.state=x.memoizedState;ca.componentDidUpdate(ej,fj,ca.__reactInternalSnapshotBeforeUpdate)}var th=x.updateQueue;null!==th&&(ca.props=x.memoizedProps,
ca.state=x.memoizedState,$f(x,th,ca,sh));break;case 3:var uh=x.updateQueue;if(null!==uh){var Be=null;if(null!==x.child)switch(x.child.tag){case 5:Be=x.child.stateNode;break;case 1:Be=x.child.stateNode}$f(x,uh,Be,sh)}break;case 5:var gj=x.stateNode;null===hb&&x.effectTag&4&&hf(x.type,x.memoizedProps)&&gj.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(x.effectTag&32){x.memoizedState={alreadyCaptured:!0,didTimeout:!1,timedOutAt:0};xg(x,1);break}var vh=null!==hb?hb.memoizedState:null,
Ub=x.memoizedState,hj=null!==vh?vh.didTimeout:!1,Ce=x;if(null===Ub)Zc=!1;else if(Zc=Ub.didTimeout)Ce=x.child,Ub.alreadyCaptured=!1,0===Ub.timedOutAt&&(Ub.timedOutAt=vg());if(Zc!==hj&&null!==Ce)a:for(var De=Ce,wh=Zc,z=De;;){if(5===z.tag){var ij=z.stateNode;if(wh)ij.style.display="none";else{var jj=z.stateNode,$c=z.memoizedProps.style,kj=void 0!==$c&&null!==$c&&$c.hasOwnProperty("display")?$c.display:null;jj.style.display=kj}}else if(6===z.tag)z.stateNode.nodeValue=wh?"":z.memoizedProps;else if(null!==
z.child){z.child.return=z;z=z.child;continue}if(z===De)break a;for(;null===z.sibling;){if(null===z.return||z.return===De)break a;z=z.return}z.sibling.return=z.return;z=z.sibling}break;case 17:break;default:r("163")}}if(rh&128){var ad=T.ref;if(null!==ad){var xh=T.stateNode;switch(T.tag){case 5:var Ee=xh;break;default:Ee=xh}"function"===typeof ad?ad(Ee):ad.current=Ee}}var lj=T.nextEffect;T.nextEffect=null;T=lj}}catch(db){ph=!0,qh=db}ph&&(null===T?r("178"):void 0,Gh(T,qh),null!==T&&(T=T.nextEffect))}Vh=
Yh=!1;"function"===typeof zf&&zf(b.stateNode);var Fe=b.expirationTime,Ge=b.childExpirationTime,yh=0===Fe||0!==Ge&&Ge<Fe?Ge:Fe;0===yh&&(Ph=null);a.expirationTime=yh;a.finishedWork=null}function ci(){return oi?!0:null===ri||ri.timeRemaining()>yi?!1:oi=!0}function Nh(a){null===X?r("246"):void 0;X.expirationTime=0;pi||(pi=!0,qi=a)}function Ii(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Gi(1,null)}}function Ji(a,b){if(Z&&!si){si=!0;try{return a(b)}finally{si=!1}}return a(b)}
function Ki(a,b,c){if(fi)return a(b,c);Z||W||0===gi||(Gi(gi,null),gi=0);var d=fi,e=Z;Z=fi=!0;try{return a(b,c)}finally{fi=d,(Z=e)||W||Gi(1,null)}}
function Li(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===Gd(c)&&1===c.tag?void 0:r("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);r("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=wf(c,h,g);break a}}c=g}else c=qf;null===b.context?b.context=c:b.pendingContext=c;b=e;e=Tf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
Vf(f,e);xg(f,d);return d}function Mi(a,b,c,d){var e=b.current,f=vg();e=wg(f,e);return Li(a,b,c,e,d)}function Pi(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Qi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:nc,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Nb=function(a,b,c){switch(b){case "input":Tc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qa(d);e?void 0:r("90");jc(d);Tc(d,e)}}}break;case "textarea":Qe(a,c);break;case "select":b=c.value,null!=b&&Ne(a,!!c.multiple,b,!1)}};
function Ri(a){var b=2+25*(((vg()-2+500)/25|0)+1);b<=Th&&(b=Th+1);this._expirationTime=Th=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Ri.prototype.render=function(a){this._defer?void 0:r("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Si;Li(a,b,null,c,d._onCommit);return d};
Ri.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Ri.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:r("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?r("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Di(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
null,this._defer=!1};Ri.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Si(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Si.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Si.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?r("191",c):void 0;c()}}};
function Ti(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
Ti.prototype.render=function(a,b){var c=this._internalRoot,d=new Si;b=void 0===b?null:b;null!==b&&d.then(b);Mi(a,c,null,d._onCommit);return d};Ti.prototype.unmount=function(a){var b=this._internalRoot,c=new Si;a=void 0===a?null:a;null!==a&&c.then(a);Mi(null,b,null,c._onCommit);return c};Ti.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Si;c=void 0===c?null:c;null!==c&&e.then(c);Mi(b,d,a,e._onCommit);return e};
Ti.prototype.createBatch=function(){var a=new Ri(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime<=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Ui(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Yb=Ii;Zb=Ki;$b=function(){W||0===gi||(Gi(gi,null),gi=0)};
function Vi(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Ti(a,!1,b)}
function Wi(a,b,c,d,e){Ui(c)?void 0:r("200");var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Pi(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=Vi(c,d);if("function"===typeof e){var h=e;e=function(){var a=Pi(f._internalRoot);h.call(a)}}Ji(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Pi(f._internalRoot)}
function Xi(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Ui(b)?void 0:r("200");return Qi(a,b,null,c)}
var Yi={createPortal:Xi,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?r("188"):r("268",Object.keys(a)));a=Jd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){return Wi(null,a,b,!0,c)},render:function(a,b,c){return Wi(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null==a||void 0===a._reactInternalFiber?r("38"):void 0;return Wi(a,b,c,!1,d)},unmountComponentAtNode:function(a){Ui(a)?
void 0:r("40");return a._reactRootContainer?(Ji(function(){Wi(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Xi.apply(void 0,arguments)},unstable_batchedUpdates:Ii,unstable_interactiveUpdates:Ki,flushSync:function(a,b){W?r("187"):void 0;var c=Z;Z=!0;try{return li(a,b)}finally{Z=c,Gi(1,null)}},unstable_flushControlled:function(a){var b=Z;Z=!0;try{li(a)}finally{(Z=b)||W||Gi(1,null)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Oa,
Pa,Qa,Ga.injectEventPluginsByName,sa,Wa,function(a){Ba(a,Va)},Wb,Xb,ee,Ia]},unstable_createRoot:function(a,b){Ui(a)?void 0:r("278");return new Ti(a,!0,null!=b&&!0===b.hydrate)}};(function(a){var b=a.findFiberByHostInstance;return Cf(n({},a,{findHostInstanceByFiber:function(a){a=Jd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Na,bundleType:0,version:"16.6.0",rendererPackageName:"react-dom"});
var mj={default:Yi},nj=mj&&Yi||mj;module.exports=nj.default||nj;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(23);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.6.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var c=null,f=3,h=-1,k=-1,l=!1,m=!1,n="object"===typeof performance&&"function"===typeof performance.now,q={timeRemaining:n?function(){if(null!==c&&c.expirationTime<k)return 0;var a=p()-performance.now();return 0<a?a:0}:function(){if(null!==c&&c.expirationTime<k)return 0;var a=p()-Date.now();return 0<a?a:0},didTimeout:!1};function r(){if(!l){var a=c.expirationTime;m?t():m=!0;u(v,a)}}
function w(){var a=c,b=c.next;if(c===b)c=null;else{var d=c.previous;c=d.next=b;b.previous=d}a.next=a.previous=null;d=a.callback;b=a.expirationTime;a=a.priorityLevel;var e=f,R=k;f=a;k=b;try{var g=d(q)}finally{f=e,k=R}if("function"===typeof g)if(g={callback:g,priorityLevel:a,expirationTime:b,next:null,previous:null},null===c)c=g.next=g.previous=g;else{d=null;a=c;do{if(a.expirationTime>=b){d=a;break}a=a.next}while(a!==c);null===d?d=c:d===c&&(c=g,r());b=d.previous;b.next=d.previous=g;g.next=d;g.previous=
b}}function x(){if(-1===h&&null!==c&&1===c.priorityLevel){l=!0;q.didTimeout=!0;try{do w();while(null!==c&&1===c.priorityLevel)}finally{l=!1,null!==c?r():m=!1}}}function v(a){l=!0;q.didTimeout=a;try{if(a)for(;null!==c;){var b=exports.unstable_now();if(c.expirationTime<=b){do w();while(null!==c&&c.expirationTime<=b)}else break}else if(null!==c){do w();while(null!==c&&0<p()-exports.unstable_now())}}finally{l=!1,null!==c?r():m=!1,x()}}
var y=Date,z="function"===typeof setTimeout?setTimeout:void 0,A="function"===typeof clearTimeout?clearTimeout:void 0,B="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,C="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,D,E;function F(a){D=B(function(b){A(E);a(b)});E=z(function(){C(D);a(exports.unstable_now())},100)}if(n){var G=performance;exports.unstable_now=function(){return G.now()}}else exports.unstable_now=function(){return y.now()};var u,t,p;
if("undefined"!==typeof window&&window._schedMock){var H=window._schedMock;u=H[0];t=H[1];p=H[2]}else if("undefined"===typeof window||"function"!==typeof window.addEventListener){var I=null,J=-1,K=function(a,b){if(null!==I){var d=I;I=null;try{J=b,d(a)}finally{J=-1}}};u=function(a,b){-1!==J?setTimeout(u,0,a,b):(I=a,setTimeout(K,b,!0,b),setTimeout(K,1073741823,!1,1073741823))};t=function(){I=null};p=function(){return Infinity};exports.unstable_now=function(){return-1===J?0:J}}else{"undefined"!==typeof console&&
("function"!==typeof B&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof C&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var L=null,M=!1,N=-1,O=!1,P=!1,Q=0,S=33,T=33;p=function(){return Q};var U="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",
function(a){if(a.source===window&&a.data===U){M=!1;a=L;var b=N;L=null;N=-1;var d=exports.unstable_now(),e=!1;if(0>=Q-d)if(-1!==b&&b<=d)e=!0;else{O||(O=!0,F(V));L=a;N=b;return}if(null!==a){P=!0;try{a(e)}finally{P=!1}}}},!1);var V=function(a){if(null!==L){F(V);var b=a-Q+T;b<T&&S<T?(8>b&&(b=8),T=b<S?S:b):S=b;Q=a+T;M||(M=!0,window.postMessage(U,"*"))}else O=!1};u=function(a,b){L=a;N=b;P||0>b?window.postMessage(U,"*"):O||(O=!0,F(V))};t=function(){L=null;M=!1;N=-1}}exports.unstable_ImmediatePriority=1;
exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:break;default:a=3}var d=f,e=h;f=a;h=exports.unstable_now();try{return b()}finally{f=d,h=e,x()}};
exports.unstable_scheduleCallback=function(a,b){var d=-1!==h?h:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=d+b.timeout;else switch(f){case 1:b=d+-1;break;case 2:b=d+250;break;case 4:b=d+1073741823;break;default:b=d+5E3}a={callback:a,priorityLevel:f,expirationTime:b,next:null,previous:null};if(null===c)c=a.next=a.previous=a,r();else{d=null;var e=c;do{if(e.expirationTime>b){d=e;break}e=e.next}while(e!==c);null===d?d=c:d===c&&(c=a,r());b=d.previous;b.next=d.previous=
a;a.next=d;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)c=null;else{a===c&&(c=b);var d=a.previous;d.next=b;b.previous=d}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=f;return function(){var d=f,e=h;f=b;h=exports.unstable_now();try{return a.apply(this,arguments)}finally{f=d,h=e,x()}}};exports.unstable_getCurrentPriorityLevel=function(){return f};


/***/ }),
/* 24 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 26 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__topModule_Top__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__textModule_Text__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_mobx__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["b" /* inject */])("uiState","appState"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_5_mobx_react__["c" /* observer */])(_class=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.handleUIState=function(){var state=_this.props.appState.executeState;if(state===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.not){_this.props.uiState.beNotUI();}else if(state===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.doing){_this.props.uiState.beDoingUI();}else if(state===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success){_this.props.uiState.beSuccessUI();}else if(state===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.warning){_this.props.uiState.beWarningUI();}else if(state===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.error){_this.props.uiState.beErrorUI();}else{}};return _this;}_createClass(App,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.modifyUIReaction=Object(__WEBPACK_IMPORTED_MODULE_6_mobx__["m" /* reaction */])(function(){return _this2.props.appState.executeState;},this.handleUIState);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__topModule_Top__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__textModule_Text__["a" /* default */],null));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cnConst_text__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnConst_showText__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cnConst_showKey__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cnConst_showAuthor__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cnConst_openArgument__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cnConst_inputType__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cnConst_inputKey__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__cnConst_defaultValue__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cnConst_randomShowKey__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__httpApi__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__openSites__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__executeKey__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultStyle__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__asyncInputKey__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__outFunctions__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__styleKey__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__storageKey__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__count__ = __webpack_require__(43);
var cnConst={text:__WEBPACK_IMPORTED_MODULE_0__cnConst_text__["a" /* default */],showText:__WEBPACK_IMPORTED_MODULE_1__cnConst_showText__["a" /* default */],showKey:__WEBPACK_IMPORTED_MODULE_2__cnConst_showKey__["a" /* default */],showAuthor:__WEBPACK_IMPORTED_MODULE_3__cnConst_showAuthor__["a" /* default */],openArgument:__WEBPACK_IMPORTED_MODULE_4__cnConst_openArgument__["a" /* default */],inputType:__WEBPACK_IMPORTED_MODULE_5__cnConst_inputType__["a" /* default */],inputKey:__WEBPACK_IMPORTED_MODULE_6__cnConst_inputKey__["a" /* default */],defaultValue:__WEBPACK_IMPORTED_MODULE_7__cnConst_defaultValue__["a" /* default */],randomShowKey:__WEBPACK_IMPORTED_MODULE_8__cnConst_randomShowKey__["a" /* default */],httpApi:__WEBPACK_IMPORTED_MODULE_9__httpApi__["a" /* default */],openSites:__WEBPACK_IMPORTED_MODULE_10__openSites__["a" /* default */],executeKey:__WEBPACK_IMPORTED_MODULE_11__executeKey__["a" /* default */],defaultStyle:__WEBPACK_IMPORTED_MODULE_12__defaultStyle__["a" /* default */],asyncInputKey:__WEBPACK_IMPORTED_MODULE_13__asyncInputKey__["a" /* default */],outFunctions:__WEBPACK_IMPORTED_MODULE_14__outFunctions__["a" /* default */],styleKey:__WEBPACK_IMPORTED_MODULE_15__styleKey__["a" /* default */],storageKey:__WEBPACK_IMPORTED_MODULE_16__storageKey__["a" /* default */],count:__WEBPACK_IMPORTED_MODULE_17__count__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (cnConst);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var text=new Map([["title","小障"],["login","登录"],["input","一个输入框"],["input2","上一次操作"],["submit","开始你的表演"]]);/* harmony default export */ __webpack_exports__["a"] = (text);

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__showKey__ = __webpack_require__(5);
var showText=new Map([[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].murongziying,"人生一场虚空大梦，韶华白首，不过转瞬，唯有天道恒在，循环往复，不曾更改。"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].wusheng,"我突然顿悟，一个人，想要的东西不能太多。但我的一生，是抗争的一生。"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].kobe,"你知道洛杉矶凌晨四点钟是什么样子吗？"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzNot,"你好~我是你的朋友~~小障"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzSuccess,"你输入的指令已~成功执行！！ ~~嘿嘿嘿~"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzing,"小障正在~拼尽全力~~执行你的指令。。。"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzWarning,"可能有~部分指令~~未能成功执行。。。"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzError,"指令未能成功执行~请尝试对~~指令或参数~进行调整。。。"]]);/* harmony default export */ __webpack_exports__["a"] = (showText);

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__showKey__ = __webpack_require__(5);
var showAuthor=new Map([[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].murongziying,"-- 慕容紫英"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].kobe,"-- Kobe Bryant"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].wusheng,"-- 伍声2009"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzSuccess,"-- 小障如是说"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzing,"-- 小障如是说"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzWarning,"-- 小障如是说"],[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].xzError,"-- 小障如是说"]]);/* harmony default export */ __webpack_exports__["a"] = (showAuthor);

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
var openArgument=new Map([["baidu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["百度",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["ecosia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ecosia],["google",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["谷歌",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["guge",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["雅虎",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["yahoo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["yahu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["bing",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["必应",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["biying",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["360搜索",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu],["360sousuo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu],["搜狗",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou],["sougou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou],["soso",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["搜搜",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["sousou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["优酷",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku],["youku",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku],["土豆",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou],["tudou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou],["腾讯视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qq视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qqshipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["tengxunshipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qqvideo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["Tencentvideo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["爱奇艺",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["aiqiyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["iqiyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["哔哩哔哩",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["bilibili",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["b站",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["bzhan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["芒果tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["mangguotv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["mgtv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["搜狐视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["souhushipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["sohutv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["乐视",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["leshi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["le",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["acfun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["a站",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["azhan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["nico",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].nico],["youtube",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtube],["qq音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic],["qqmusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic],["qqyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmuaic],["虾米音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["xiamimusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["虾米",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["xiami",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["网易云音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["netmusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["wangyiyunyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["酷狗",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["酷狗音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugouyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugoumusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["youtubemusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtubemusic],["百度音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["千千音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["baiduyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["qianqianyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["baidumusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["音悦台",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai],["yinyuetai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai],["qq音乐mv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["qqmusicmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["qqyinyuemv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["知乎",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu],["zhihu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu],["百度知道",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao],["baiduzhidao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao],["百度百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike],["baidubaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike],["搜狗百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike],["sougoubaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike],["360百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike],["360baike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike],["互动百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike],["hudongbaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike],["维基百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["weijibaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["维基",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["weiji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["baiduxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen],["百度新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen],["腾讯新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qq新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["tengxunxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qqxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["tencentnews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qqnews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["网易新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netxinwen],["wangyixinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netxinwen],["netnews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netxinwen],["搜狐新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["souhuxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["sohunews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["新浪新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["xinlangxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["sinanews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["淘宝",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],["taobao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],["京东",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd],["jingdong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd],["天猫",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["tianmao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["tmall",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["亚马逊",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["亚马逊中国",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["yamaxun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["yamaxunzhongguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["amazoncn",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["亚马逊国际",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["yamaxunguoji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["amazon",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["github",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github],["oschina",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["开源中国",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["kaiyuanzhongguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["segmentfault",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["思否",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["sifou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["stackoverflow",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow],["腾讯网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq],["腾讯",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq],["tencent",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq],["tengxunwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq],["tengxun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq],["hao123",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hao123],["好123",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hao123],["搜狐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu],["sohu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu],["搜狐网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu],["souhu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu],["souhuwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu],["新浪",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina],["新浪网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina],["xinlang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina],["xinlangwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina],["sina",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina],["google翻译",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate],["谷歌翻译",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate],["gugefanyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate],["googlefanyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate],["googletranslate",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate],["百度文库",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwenku],["baiduwenku",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwenku],["百度网盘",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwangpan],["baiduwangpan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwangpan],["115",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoyaowu],["115wangpan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoyaowu],["115网盘",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoyaowu],["新华网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xinhuawang],["xinhuawang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xinhuawang],["xinlangboke",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinablog],["sinablog",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinablog],["新浪博客",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinablog],["人民日报",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renminribao],["renminribao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renminribao],["光明网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmw],["guangmingwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmw],["天涯",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianya],["tianya",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianya],["天涯社区",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianya],["tianyashequ",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianya],["中国青年网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youth],["zhongguoqingnianwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youth],["中华网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].china],["zhonghuawang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].china],["cctv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv],["yangshiwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv],["央视网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv],["中央电视台",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv],["zhongyangdianshitai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv],["alipay",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alipay],["支付宝",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alipay],["zhifubao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alipay],["宝宝树",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].babytree],["baobaoshu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].babytree],["环球网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huanqiu],["huanqiuwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huanqiu],["csdn",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].csdn],["妈妈网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mamawang],["mamawang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mamawang],["中关村在线",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zol],["zhongguancunzaixian",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zol],["zol",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zol],["网易",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].net163],["wangyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].net163],["163",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].net163],["斗鱼",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["douyu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["斗鱼tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["douyutv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["斗鱼直播",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["douyuzhibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu],["易车网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bitauto],["yichewang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bitauto],["bitauto",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bitauto],["豆瓣",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douban],["douban",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douban],["财经网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].caijing],["caijingwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].caijing],["天极网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yesky],["tianjiwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yesky],["yesky",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yesky],["电影网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianying1905],["dianyingwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianying1905],["1905",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianying1905],["中国互联网络信息中心",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnnic],["zhongguohulianwangluoxinxizhongxin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnnic],["cnnic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnnic],["博客园",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnblogs],["bokeyuan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnblogs],["中国日报",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhongguoribao],["zhongguoribao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhongguoribao],["阿里巴巴",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alibaba],["alibaba",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alibaba],["苹果官网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["pingguoguanwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["苹果",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["pingguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["苹果手机",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["pingguoshouji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["apple",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple],["脸书",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook],["lianshu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook],["lianpuwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook],["脸谱网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook],["facebook",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook],["微软",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["weiruan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["微软官网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["weiruanguanwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["巨硬",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["juying",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["microsoft",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft],["东方网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dongfangwang],["dongfangwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dongfangwang],["天猫超市",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chaoshitmall],["tianmaochaoshi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chaoshitmall],["有道云笔记",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaonote],["youdaoyunbiji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaonote],["网易云笔记",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaonote],["wangyiyunbiji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaonote],["红网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hongwang],["hongwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hongwang],["instagram",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].instagram],["阿里云",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aliyun],["aliyun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aliyun],["站长之家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chinaz],["zhanzhangzhijia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chinaz],["chinaz",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chinaz],["花瓣网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huaban],["huabanwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huaban],["花瓣",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huaban],["huaban",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huaban],["凤凰网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ifeng],["fenghuangwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ifeng],["ifeng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ifeng],["领英",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].linkedin],["lingying",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].linkedin],["linkedin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].linkedin],["苏宁",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].suning],["苏宁易购",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].suning],["suning",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].suning],["suningyigou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].suning],["手机中国",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnmo],["shoujizhongguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnmo],["cnmo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnmo],["战旗",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["zhanqi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["战旗tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["zhanqitv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["战旗直播",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["zhanqizhibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi],["未来网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].k618],["weilaiwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].k618],["58",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wuba],["58同城",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wuba],["58tongcheng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wuba],["证券之星",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stockstar],["zhengquanzhixing",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stockstar],["stockstar",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stockstar],["脚本之家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jb51],["jiaobenzhijia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jb51],["jb51",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jb51],["52pk",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pk52],["52pk游戏网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pk52],["52pkyouxiwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pk52],["今日头条",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].toutiao],["jinritoutiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].toutiao],["迅雷",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xunlei],["xunlei",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xunlei],["英国广播公司",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bbc],["bbc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bbc],["yingguoguangbogongsi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bbc],["推特",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].twitter],["twitter",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].twitter],["tuite",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].twitter],["ebay",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ebay],["易趣",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ebay],["yiqu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ebay],["tumblr",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tumblr],["小米",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["小米官网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["小米手机",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["xiaomi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["xiaomiguanwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["xiaomishouji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi],["智联招聘",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhaopin],["zhilianzhaopin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhaopin],["同程旅游",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ly],["tongchenglvyou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ly],["齐家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jia],["qijia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jia],["齐家网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jia],["qijiawang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jia],["adobe",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].adobe],["虎扑",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hupu],["hupu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hupu],["简书",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jianshu],["jianshu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jianshu],["126",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail126],["126邮箱",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail126],["126youxiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail126],["163邮箱",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail163],["163youxiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail163],["4399",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sisanjiujiu],["大众点评",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianping],["dazhongdianping",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianping],["3dm",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sandm],["3大妈",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sandm],["三大妈",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sandm],["游民星空",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gamersky],["youminxingkong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gamersky],["gamersky",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gamersky],["金山毒霸",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].duba],["jinshanduba",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].duba],["duba",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].duba],["毒霸",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].duba],["熊猫",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["xiongmao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["熊猫tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["xiongmaotv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["熊猫直播",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["xiongmaozhibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda],["steam",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].steampowered],["steampowered",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].steampowered],["土巴兔",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].to8to],["tubatu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].to8to],["威锋网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feng],["weifengwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feng],["weifeng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feng],["威锋",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feng],["nga",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ngacn],["nga玩家社区",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ngacn],["ngawanjiashequ",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ngacn],["17173",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoqiyaoqisan],["wordpress",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wordpress],["51cto",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cto51],["什么值得买",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].smzdm],["shenmezhidemai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].smzdm],["smzdm",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].smzdm],["w3school",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].w3school],["w3schools",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].w3schools],["人人网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renren],["renrenwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renren],["renren",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renren],["v2ex",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].v2ex],["菜鸟教程",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].runoob],["cainiaojiaocheng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].runoob],["runoob",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].runoob],["贝宝",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].paypal],["paypal",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].paypal],["beibao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].paypal],["tieba",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tieba],["百度贴吧",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tieba],["baidutieba",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tieba],["贴吧",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tieba],["国美",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gome],["guomei",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gome],["gome",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gome],["汽车之家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].autohome],["qichezhijia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].autohome],["autohome",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].autohome],["fangtianxia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fang],["房天下",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fang],["携程",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip],["xiecheng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip],["携程旅行网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip],["xiechenglvxingwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip],["ctrip",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip],["12306",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoersanlingliu],["瓜子",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guazi],["瓜子二手车",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guazi],["guazi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guazi],["guaziershouche",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guazi],["去哪网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qunar],["qunawang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qunar],["booking",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].booking],["途牛",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tuniu],["途牛旅游网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tuniu],["tuniu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tuniu],["tuniulvyouwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tuniu],["mafengwo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mafengwo],["马蜂窝",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mafengwo],["飞猪",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhu],["feizhu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhu],["alitrip",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhu],["起点",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qidian],["qidian",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qidian],["起点中文网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qidian],["qidianzhongwenwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qidian],["晋江",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jinjiang],["jinjiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jinjiang],["晋江文学城",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jinjiang],["jinjiangwenxuecheng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jinjiang],["太平洋电脑网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pconline],["taipingyangdiannaowang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pconline],["pconline",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pconline],["ithome",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ithome],["it之家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ithome],["itzhijia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ithome],["zealer",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zealer],["虎牙",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["huya",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["huyatv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["虎牙tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["虎牙直播",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["huyazhibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya],["longzhu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["龙珠",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["龙珠tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["longzhutv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["龙珠直播",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["longzhuzhibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu],["赶集",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ganji],["ganji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ganji],["赶集网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ganji],["ganjiwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ganji],["百姓网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baixing],["baixingwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baixing],["贝壳找房",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].beike],["beikezhaofang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].beike],["链家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lianjia],["lianjia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lianjia],["我爱我家",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].woaiwojia],["woaiwojia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].woaiwojia],["美团",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituan],["meituan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituan],["华军",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huajun],["huajun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huajun],["华军软件园",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huajun],["huajunruanjianyuan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huajun],["前程无忧",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qianchengwuyou],["qianchengwuyou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qianchengwuyou],["51job",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qianchengwuyou],["拉勾",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lagou],["lagou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lagou],["拉勾网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lagou],["lagouwang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lagou],["qq邮箱",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailqq],["qqyouxiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailqq],["新浪邮箱",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailsina],["xinlangyouxiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailsina],["下厨房",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiachufang],["xiachufang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiachufang],["糗事百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qiushibaike],["qiushibaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qiushibaike],["天眼查",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianyancha],["tianyancha",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianyancha],["网易云课堂",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netstudy],["wangyiyunketang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netstudy],["慕课网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].imooc],["mukewang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].imooc],["imooc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].imooc],["qq网页版",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["网页版qq",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["qqwangyeban",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["wangyebanqq",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["qqweb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["webqq",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb],["微信网页版",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["网页版微信",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["weixinwangyeban",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["wangyebanweixin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["微信web",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["web微信",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["weixinweb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["webweixin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb],["腾讯云",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentcloud],["tengxunyun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentcloud],["tencentcloud",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentcloud],["aws",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aws],["亚马逊云",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aws],["yamaxunyun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aws],["azure",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].azure],["微软云",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].azure],["weiruanyun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].azure],["googlecloud",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlecloud],["谷歌云",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlecloud],["gugeyun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlecloud],["安居客",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].anjuke],["anjuke",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].anjuke],["半次元",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bcy],["banciyuan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bcy],["bcy",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bcy],["菜鸟裹裹",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoguo],["cainiaoguoguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoguo],["电信",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianxin],["中国电信",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianxin],["dianxin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianxin],["zhongguodianxin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianxin],["移动",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yidong],["中国移动",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yidong],["yidong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yidong],["zhongguoyidong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yidong],["联通",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].liantong],["中国联通",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].liantong],["liantong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].liantong],["zhongguoliantong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].liantong],["高德",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["高德地图",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["gaode",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["gaodeditu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["gaodemap",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["amap",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode],["百度地图",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumap],["baiduditu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumap],["baidumap",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumap],["腾讯地图",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentmap],["tengxunditu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentmap],["tencentmap",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentmap],["googlemap",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlemap],["谷歌地图",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlemap],["gugeditu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlemap],["滴滴",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].didi],["滴滴打车",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].didi],["didi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].didi],["dididache",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].didi],["饿了么",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].eleme],["eleme",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].eleme],["美团外卖",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituanwaimai],["meituanwaimai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituanwaimai],["koubei",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].koubei],["口碑",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].koubei],["gmail",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmail],["谷歌邮箱",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmail],["gugeyouxiang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmail],["百度翻译",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidutranslate],["baidufanyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidutranslate],["baidutranslate",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidutranslate],["有道翻译",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaotranslate],["youdaotranslate",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaotranslate],["youdaofanyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaotranslate],["喜马拉雅",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ximalaya],["ximalaya",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ximalaya],["微博",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weibo],["weibo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weibo],["果壳网",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoke],["guokewang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoke],["果壳",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoke],["guoke",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoke],["腾讯课堂",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentstudy],["tengxunketang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentstudy]]);/* harmony default export */ __webpack_exports__["a"] = (openArgument);

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
var inputType=new Map([["清除缓存",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qingchuhuancun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["clear",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qchc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["清理缓存",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["clearcache",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qinglihuancun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qlhc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["清空缓存",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qingkonghuancun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["qkhc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clear],["清除播放列表",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qingchubofangliebiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["clearlist",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qcbflb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["清理播放列表",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["clearlistcache",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qinglibofangliebiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qlbflb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["清空播放列表",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qingkongbofangliebiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["qkbflb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearList],["清除输入数据",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qingchushurushuju",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["cleardata",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qcsrsj",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["清理输入数据",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["cleardatacache",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qinglishurushuju",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qlsrsj",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["清空输入数据",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["clearinput",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qingkongshurushuju",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["qksrsj",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].clearInput],["dakai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["open",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["打开",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["kaiqi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["开启",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["dk",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["kq",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].open],["sousuo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].search],["search",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].search],["搜索",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].search],["ss",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].search],["百度",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["baidu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["度娘",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["duniang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],["ecosia",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ecosia],["谷歌",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["google",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["guge",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google],["雅虎",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["yahoo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["yahu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo],["bing",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["必应",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["biying",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing],["360",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu],["360搜索",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu],["360sousuo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu],["搜狗",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou],["sougou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou],["soso",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["搜搜",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["sousou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso],["shipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].video],["video",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].video],["视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].video],["sp",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].video],["优酷",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku],["youku",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku],["土豆",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou],["tudou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou],["腾讯视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qq视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qqshipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["tengxunshipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["qqvideo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["Tencentvideo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo],["爱奇艺",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["aiqiyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["iqiyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi],["哔哩哔哩",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["bilibili",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["b站",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["bzhan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili],["芒果tv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["mangguotv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["mgtv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv],["搜狐视频",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["souhushipin",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["sohutv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv],["乐视",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["leshi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["le",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le],["acfun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["a站",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["azhan",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun],["nico",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].nico],["youtube",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtube],["yinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].music],["music",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].music],["音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].music],["yy",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].music],["qq音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic],["qqmusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic],["qqyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmuaic],["虾米音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["xiamimusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["虾米",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["xiami",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic],["网易云音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["netmusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["wangyiyunyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic],["酷狗",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["酷狗音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugouyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["kugoumusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic],["youtubemusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtubemusic],["百度音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["千千音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["baiduyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["qianqianyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["baidumusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic],["mv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mv],["musicvideo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mv],["音悦台",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai],["yinyuetai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai],["qq音乐mv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["qqmusicmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["qqyinyuemv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],["bofang",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play],["play",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play],["播放",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play],["bf",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play],["播放qq音乐",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic],["bofangqqyinyue",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic],["playqqmusic",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic],["播放mv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv],["bofangmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv],["playmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv],["bfmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv],["播放qq音乐mv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv],["bofangqqyinyuemv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv],["playqqmusicmv",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv],["wenti",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].question],["question",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].question],["问题",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].question],["wt",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].question],["知乎",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu],["zhihu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu],["百度知道",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao],["baiduzhidao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao],["baike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wiki],["wiki",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wiki],["百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wiki],["bk",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wiki],["百度百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike],["baidubaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike],["搜狗百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike],["sougoubaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike],["360百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike],["360baike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike],["互动百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike],["hudongbaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike],["维基百科",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["weijibaike",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["维基",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["weiji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike],["百度百科搜索",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaikeSearch],["baidubaikesousuo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaikeSearch],["baidubaikeSearch",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaikeSearch],["xinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].news],["news",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].news],["新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].news],["xw",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].news],["baiduxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen],["百度新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen],["腾讯新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qq新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["tengxunxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qqxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["tencentnews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["qqnews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen],["搜狐新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["souhuxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["sohunews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen],["新浪新闻",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["xinlangxinwen",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["sinanews",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen],["购物",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["买",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["gouwu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["mai",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["buy",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["shopping",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["gw",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["m",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy],["淘宝",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],["taobao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],["tb",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],["京东",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd],["jingdong",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd],["jd",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd],["天猫",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["tianmao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["tmall",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["tm",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall],["亚马逊",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["亚马逊中国",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["yamaxun",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["yamaxunzhongguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["amazoncn",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn],["亚马逊国际",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["yamaxunguoji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["amazon",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon],["编程",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["代码",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["code",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["Programming",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["biancheng",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["daima",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["bc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["dm",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code],["github",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github],["gh",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github],["oschina",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["开源中国",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["kaiyuanzhongguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina],["segmentfault",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["思否",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["sifou",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault],["stackoverflow",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow],["sf",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow],["堆栈溢出",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow],["duizhanyichu",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow],["dzyc",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow]// ,["下载",inputKey.download]
// ,["xiazai",inputKey.download]
// ,["download",inputKey.download]
// ,["xz",inputKey.download]
,["机票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["jipiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["airticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["jp",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["飞机",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["feiji",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket],["携程机票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctripairticket],["xiechengjipiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctripairticket],["ctripairticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctripairticket],["飞猪机票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhuairticket],["feizhujipiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhuairticket],["alitripairticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhuairticket],["火车票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["huochepiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["trainticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["hcp",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["huoche",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["火车",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket],["携程火车票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctriptrainticket],["xiechenghuochepiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctriptrainticket],["ctriptrainticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctriptrainticket],["飞猪火车票",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhutrainticket],["feizhuhuochepiao",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhutrainticket],["alitriptrainticket",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhutrainticket],["链接",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["网址",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["link",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["site",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["lianjie",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["wangzhi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["lj",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["wz",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].link],["kuaidi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["快递",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["邮件",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["youjian",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["包裹",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["baoguo",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["express",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["kd",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["yj",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["bg",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].express],["翻译",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fanyi],["fanyi",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fanyi],["fy",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fanyi],["translate",__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fanyi]]);/* harmony default export */ __webpack_exports__["a"] = (inputType);

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__executeKey__ = __webpack_require__(10);
var defaultValue=new Map([[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].search,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].video,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].music,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mv,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].question,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wiki,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].news,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].buy,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].code,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].airticket,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhuairticket],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].trainticket,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhutrainticket],[__WEBPACK_IMPORTED_MODULE_2__executeKey__["a" /* default */].notExecute,__WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__["a" /* default */].xzNot],[__WEBPACK_IMPORTED_MODULE_2__executeKey__["a" /* default */].executing,__WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__["a" /* default */].xzing],[__WEBPACK_IMPORTED_MODULE_2__executeKey__["a" /* default */].executeSuccess,__WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__["a" /* default */].xzSuccess],[__WEBPACK_IMPORTED_MODULE_2__executeKey__["a" /* default */].executeWarning,__WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__["a" /* default */].xzWarning],[__WEBPACK_IMPORTED_MODULE_2__executeKey__["a" /* default */].executeError,__WEBPACK_IMPORTED_MODULE_1__cnConst_showKey__["a" /* default */].xzError]]);/* harmony default export */ __webpack_exports__["a"] = (defaultValue);

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__showKey__ = __webpack_require__(5);
var randomShowKey=[__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].murongziying,__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].wusheng,__WEBPACK_IMPORTED_MODULE_0__showKey__["a" /* default */].kobe];/* harmony default export */ __webpack_exports__["a"] = (randomShowKey);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
var httpApi=new Map([[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic,{firstHalf:"https://c.y.qq.com/soso/fcgi-bin/client_search_cp?ct=24&qqmusic_ver=1298&new_json=1&remoteplace=txt.yqq.top&searchid=9527&t=0&aggr=1&cr=1&catZhida=1&lossless=0&flag_qc=0&p=1&n=20&w=",secondHalf:"&g_tk=5381&jsonpCallback=MusicJsonCallback9527&loginUin=0&hostUin=0&format=jsonp&inCharset=utf8&outCharset=utf-8&notice=0&platform=yqq&needNewCode=0",playFirstHalf:"http://y.qq.com/#type=index&mids=",playSecondHalf:"&play=1&ADTAG=baiduald"}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu,{firstHalf:"https://www.baidu.com/s?word=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ecosia,{firstHalf:"https://www.ecosia.org/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google,{firstHalf:"https://www.google.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo,{firstHalf:"https://search.yahoo.com/search?p=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing,{firstHalf:"https://cn.bing.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu,{firstHalf:"https://www.so.com/s?ie=utf-8&fr=none&src=360sou_newhome&q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou,{firstHalf:"https://www.sogou.com/web?query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso,{firstHalf:"http://www.soso.com/tx?ie=utf8&pid=&query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku,{firstHalf:"http://so.youku.com/search_video/q_",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou,{firstHalf:"http://www.soku.com/nt/search/q_",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo,{firstHalf:"https://v.qq.com/x/search/?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi,{firstHalf:"https://so.iqiyi.com/so/q_",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili,{firstHalf:"https://search.bilibili.com/all?keyword=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv,{firstHalf:"https://so.mgtv.com/so/k-",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv,{firstHalf:"https://so.tv.sohu.com/mts?wd=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le,{firstHalf:"http://so.le.com/s?wd=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun,{firstHalf:"http://www.acfun.cn/search/?#query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].nico,{firstHalf:"http://www.nicovideo.jp/?CrossSearch-input=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtube,{firstHalf:"https://www.youtube.com/results?search_query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic,{firstHalf:"https://y.qq.com/portal/search.html#page=1&searchid=1&remoteplace=txt.yqq.top&t=song&w=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic,{firstHalf:"https://www.xiami.com/search?key=",secondHalf:"&pos=1"}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic,{firstHalf:"https://music.163.com/#/search/m/?s=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic,{firstHalf:"http://www.kugou.com/yy/html/search.html#searchType=song&searchKeyWord=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtubemusic,{firstHalf:"https://music.youtube.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic,{firstHalf:"http://music.taihe.com/search?key=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai,{firstHalf:"http://so.yinyuetai.com/?keyword=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv,{firstHalf:"https://y.qq.com/portal/search.html#page=1&searchid=1&remoteplace=txt.yqq.top&t=mv&w=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu,{firstHalf:"https://www.zhihu.com/search?type=content&q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao,{firstHalf:"https://zhidao.baidu.com/search?lm=0&rn=10&pn=0&fr=search&ie=gbk&word=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaikeSearch,{firstHalf:"https://baike.baidu.com/search/none?word=",secondHalf:"&pn=0&rn=10&enc=utf8"}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike,{firstHalf:"https://baike.baidu.com/item/",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike,{firstHalf:"https://baike.sogou.com/Search.e?sp=S",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike,{firstHalf:"https://baike.so.com/search/?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike,{firstHalf:"http://www.baike.com/wiki/",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike,{firstHalf:"https://zh.wikipedia.org/wiki/",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen,{firstHalf:"http://news.baidu.com/ns?tn=news&cl=2&rn=20&ct=1&fr=bks0000&ie=utf-8&word=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen,{firstHalf:"https://www.sogou.com/sogou?site=news.qq.com&query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen,{firstHalf:"http://news.sogou.com/news?ie=utf8&p=40230447&interV=kKIOkrELjboLmLkElbYTkKIKmbELjboJmLkEkL8TkKIRmLkEk78TkKILkY==_-1091100819&query=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen,{firstHalf:"http://search.sina.com.cn/?q=",secondHalf:"&range=all&c=news&sort=time"}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao,{firstHalf:"https://s.taobao.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall,{firstHalf:"https://list.tmall.com/search_product.htm?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd,{firstHalf:"https://search.jd.com/Search?keyword=",secondHalf:"&enc=utf-8"}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon,{firstHalf:"https://www.amazon.com/s/ref=nb_sb_noss_2?url=search-alias%3Daps&field-keywords=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn,{firstHalf:"https://www.amazon.cn/s/ref=nb_sb_noss_2?__mk_zh_CN=%E4%BA%9A%E9%A9%AC%E9%80%8A%E7%BD%91%E7%AB%99&url=search-alias%3Daps&field-keywords=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github,{firstHalf:"https://github.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina,{firstHalf:"https://www.oschina.net/search?scope=project&q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault,{firstHalf:"https://segmentfault.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow,{firstHalf:"https://stackoverflow.com/search?q=",secondHalf:""}],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv,{firstHalf:"https://c.y.qq.com/soso/fcgi-bin/client_search_cp?ct=24&qqmusic_ver=1298&new_json=1&remoteplace=txt.yqq.top&searchid=9527&t=0&aggr=1&cr=1&catZhida=1&lossless=0&flag_qc=0&p=1&n=20&w=",secondHalf:"&g_tk=5381&jsonpCallback=MusicJsonCallback9527&loginUin=0&hostUin=0&format=jsonp&inCharset=utf8&outCharset=utf-8&notice=0&platform=yqq&needNewCode=0",playFirstHalf:"https://y.qq.com/n/yqq/mv/v/",playSecondHalf:".html"}]]);/* harmony default export */ __webpack_exports__["a"] = (httpApi);

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
var openSites=new Map([[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidu,"https://www.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ecosia,"https://www.ecosia.org/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].google,"https://www.google.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yahoo,"https://www.yahoo.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bing,"https://www.bing.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihu,"https://www.so.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougou,"https://www.sogou.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].soso,"http://www.soso.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youku,"https://www.youku.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tudou,"http://www.tudou.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqVideo,"https://v.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].iqiyi,"https://www.iqiyi.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bilibili,"https://www.bilibili.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mgtv,"https://www.mgtv.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohutv,"https://tv.sohu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].le,"http://www.le.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].acfun,"http://www.acfun.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].nico,"http://www.nicovideo.jp/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtube,"https://www.youtube.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusic,"https://y.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiamimusic,"https://www.xiami.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netmusic,"https://music.163.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].kugoumusic,"http://www.kugou.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youtubemusic,"https://music.youtube.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumusic,"http://music.taihe.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yinyuetai,"http://www.yinyuetai.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqmusicmv,"https://y.qq.com/portal/mv_lib.html"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhihu,"https://www.zhihu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduzhidao,"https://zhidao.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidubaike,"https://baike.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sougoubaike,"https://baike.sogou.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qihubaike,"https://baike.so.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hudongbaike,"http://www.baike.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wikibaike,"https://zh.wikipedia.org/zh-hans/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduxinwen,"http://news.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqxinwen,"http://news.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netxinwen,"https://news.163.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohuxinwen,"http://news.sohu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinaxinwen,"http://news.sina.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].taobao,"https://www.taobao.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jd,"https://www.jd.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tmall,"https://www.tmall.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazoncn,"https://www.amazon.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].amazon,"https://www.amazon.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].github,"https://github.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].oschina,"https://www.oschina.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].segmentfault,"https://segmentfault.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stackoverflow,"https://stackoverflow.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qq,"http://www.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hao123,"https://www.hao123.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sohu,"http://www.sohu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sina,"https://www.sina.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googletranslate,"https://translate.google.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwenku,"https://wenku.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baiduwangpan,"https://pan.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xinhuawang,"http://www.xinhuanet.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoyaowu,"https://115.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sinablog,"http://blog.sina.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renminribao,"http://people.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmw,"http://www.gmw.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianya,"http://www.tianya.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youth,"https://www.youth.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].china,"https://www.china.com/index.html"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cctv,"http://www.cctv.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alipay,"https://www.alipay.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].babytree,"http://www.babytree.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huanqiu,"http://www.huanqiu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].csdn,"https://www.csdn.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mamawang,"http://www.mama.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zol,"http://www.zol.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].net163,"https://www.163.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douyu,"https://www.douyu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bitauto,"http://www.bitauto.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].douban,"https://www.douban.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].caijing,"http://www.caijing.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yesky,"http://www.yesky.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianying1905,"http://www.1905.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnnic,"https://www.cnnic.net.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnblogs,"https://www.cnblogs.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhongguoribao,"http://cn.chinadaily.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].alibaba,"https://www.alibaba.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].apple,"https://www.apple.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].facebook,"https://www.facebook.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].microsoft,"https://www.microsoft.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dongfangwang,"http://www.eastday.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chaoshitmall,"https://chaoshi.tmall.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaonote,"https://note.youdao.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hongwang,"http://www.rednet.cn/index.html"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].instagram,"https://www.instagram.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aliyun,"https://www.aliyun.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].chinaz,"http://www.chinaz.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huaban,"http://huaban.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ifeng,"http://www.ifeng.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].linkedin,"https://www.linkedin.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].suning,"https://www.suning.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cnmo,"http://www.cnmo.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhanqi,"https://www.zhanqi.tv/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].k618,"http://www.k618.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wuba,"http://www.58.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].stockstar,"http://www.stockstar.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jb51,"https://www.jb51.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pk52,"http://www.52pk.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].toutiao,"https://www.toutiao.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xunlei,"https://www.xunlei.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bbc,"http://www.bbc.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].twitter,"https://twitter.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ebay,"https://www.guokr.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tumblr,"https://www.tumblr.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mi,"https://www.mi.com/index.html"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zhaopin,"https://www.zhaopin.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ly,"https://www.ly.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jia,"http://www.jia.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].adobe,"https://www.adobe.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].hupu,"https://www.hupu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jianshu,"https://www.jianshu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail126,"https://www.126.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mail163,"https://mail.163.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sisanjiujiu,"http://www.4399.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianping,"https://www.dianping.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].sandm,"https://www.3dmgame.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gamersky,"http://www.gamersky.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].duba,"http://www.ijinshan.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].panda,"https://www.panda.tv/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].steampowered,"https://www.steampowered.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].to8to,"http://www.to8to.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feng,"https://www.feng.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ngacn,"http://ngacn.cc/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoqiyaoqisan,"https://www.17173.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].wordpress,"https://wordpress.org/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].cto51,"http://www.51cto.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].smzdm,"https://www.smzdm.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].w3school,"http://www.w3school.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].w3schools,"https://www.w3schools.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].renren,"http://www.renren.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].v2ex,"https://www.v2ex.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].runoob,"http://www.runoob.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].paypal,"https://www.paypal.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tieba,"https://tieba.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gome,"https://www.gome.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].autohome,"https://www.autohome.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].fang,"http://www1.fang.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ctrip,"http://www.ctrip.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yaoersanlingliu,"http://www.12306.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guazi,"https://www.guazi.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qunar,"https://www.qunar.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].booking,"https://www.booking.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tuniu,"http://www.tuniu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mafengwo,"http://www.mafengwo.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].feizhu,"https://www.alitrip.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qidian,"https://www.qidian.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].jinjiang,"http://www.jjwxc.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].pconline,"http://www.pconline.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ithome,"https://www.ithome.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].zealer,"http://www.zealer.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huya,"https://www.huya.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].longzhu,"http://longzhu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ganji,"http://www.ganji.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baixing,"http://www.baixing.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].beike,"https://www.ke.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lianjia,"https://www.lianjia.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].woaiwojia,"https://www.5i5j.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituan,"http://www.meituan.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].huajun,"http://www.onlinedown.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qianchengwuyou,"https://www.51job.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].lagou,"https://www.lagou.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailqq,"https://mail.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].mailsina,"https://mail.sina.com.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].xiachufang,"https://www.xiachufang.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qiushibaike,"https://www.qiushibaike.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tianyancha,"https://www.tianyancha.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].netstudy,"https://study.163.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].imooc,"https://www.imooc.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].qqweb,"https://web2.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weixinweb,"https://wx.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentcloud,"https://cloud.tencent.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].aws,"https://aws.amazon.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].azure,"https://azure.microsoft.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlecloud,"https://cloud.google.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].anjuke,"https://www.anjuke.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].bcy,"https://bcy.net/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoguo,"https://www.guoguo-app.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].dianxin,"https://www.189.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].yidong,"http://www.10086.cn/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].liantong,"http://www.10010.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gaode,"https://ditu.amap.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidumap,"https://map.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentmap,"https://map.qq.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].googlemap,"https://www.google.com/maps"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].didi,"https://www.didiglobal.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].eleme,"https://www.ele.me/home/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].meituanwaimai,"http://waimai.meituan.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].koubei,"https://www.koubei.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].gmail,"https://mail.google.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].baidutranslate,"https://fanyi.baidu.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].youdaotranslate,"http://fanyi.youdao.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].ximalaya,"https://www.ximalaya.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].weibo,"https://www.weibo.com/login.php"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].guoke,"https://www.guokr.com/"],[__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].tencentstudy,"https://ke.qq.com/"]]);/* harmony default export */ __webpack_exports__["a"] = (openSites);

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styleKey__ = __webpack_require__(11);
var defaultStyle=new Map([[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].hide,{display:"none"}],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].toastPrimary,"toast toast-primary"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].toastSuccess,"toast toast-success"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].toastWarning,"toast toast-warning"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].toastError,"toast toast-error"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].inputButtonPrimary,"btn btn-primary"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].inputButtonSuccess,"btn btn-success"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].inputButtonWarning,"btn btn-warning"],[__WEBPACK_IMPORTED_MODULE_0__styleKey__["a" /* default */].inputButtonError,"btn btn-error"]]);/* harmony default export */ __webpack_exports__["a"] = (defaultStyle);

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inputKey__ = __webpack_require__(3);
var asyncInputKey=new Set([__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].play,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusic,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playMv,__WEBPACK_IMPORTED_MODULE_0__inputKey__["a" /* default */].playQQMusicMv]);/* harmony default export */ __webpack_exports__["a"] = (asyncInputKey);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fetch_jsonp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fetch_jsonp__);
var outFunctions={fetchJsonp:__WEBPACK_IMPORTED_MODULE_0_fetch_jsonp___default.a};/* harmony default export */ __webpack_exports__["a"] = (outFunctions);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports, module], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else if (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    factory(exports, module);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, mod);
    global.fetchJsonp = mod.exports;
  }
})(this, function (exports, module) {
  'use strict';

  var defaultOptions = {
    timeout: 5000,
    jsonpCallback: 'callback',
    jsonpCallbackFunction: null
  };

  function generateCallbackFunction() {
    return 'jsonp_' + Date.now() + '_' + Math.ceil(Math.random() * 100000);
  }

  function clearFunction(functionName) {
    // IE8 throws an exception when you try to delete a property on window
    // http://stackoverflow.com/a/1824228/751089
    try {
      delete window[functionName];
    } catch (e) {
      window[functionName] = undefined;
    }
  }

  function removeScript(scriptId) {
    var script = document.getElementById(scriptId);
    if (script) {
      document.getElementsByTagName('head')[0].removeChild(script);
    }
  }

  function fetchJsonp(_url) {
    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

    // to avoid param reassign
    var url = _url;
    var timeout = options.timeout || defaultOptions.timeout;
    var jsonpCallback = options.jsonpCallback || defaultOptions.jsonpCallback;

    var timeoutId = undefined;

    return new Promise(function (resolve, reject) {
      var callbackFunction = options.jsonpCallbackFunction || generateCallbackFunction();
      var scriptId = jsonpCallback + '_' + callbackFunction;

      window[callbackFunction] = function (response) {
        resolve({
          ok: true,
          // keep consistent with fetch API
          json: function json() {
            return Promise.resolve(response);
          }
        });

        if (timeoutId) clearTimeout(timeoutId);

        removeScript(scriptId);

        clearFunction(callbackFunction);
      };

      // Check if the user set their own params, and if not add a ? to start a list of params
      url += url.indexOf('?') === -1 ? '?' : '&';

      var jsonpScript = document.createElement('script');
      jsonpScript.setAttribute('src', '' + url + jsonpCallback + '=' + callbackFunction);
      if (options.charset) {
        jsonpScript.setAttribute('charset', options.charset);
      }
      jsonpScript.id = scriptId;
      document.getElementsByTagName('head')[0].appendChild(jsonpScript);

      timeoutId = setTimeout(function () {
        reject(new Error('JSONP request to ' + _url + ' timed out'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        window[callbackFunction] = function () {
          clearFunction(callbackFunction);
        };
      }, timeout);

      // Caught if got 404/500
      jsonpScript.onerror = function () {
        reject(new Error('JSONP request to ' + _url + ' failed'));

        clearFunction(callbackFunction);
        removeScript(scriptId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    });
  }

  // export as global function
  /*
  let local;
  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }
  local.fetchJsonp = fetchJsonp;
  */

  module.exports = fetchJsonp;
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var storageKey={playQQMusic:"playQQMusic",inputValue:"inputValue"};/* harmony default export */ __webpack_exports__["a"] = (storageKey);

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//此对象暂时未启用
var count={enterTime:160,newWindowTime:500,otherWindowDisplayTime:12000,storageInputValueCount:100,storageSongCount:20,handleInputTime:1200,playQQMusicWindowWidth:1080,playQQMusicWindowHeight:720};/* harmony default export */ __webpack_exports__["a"] = (count);

/***/ }),
/* 44 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TitleBinder__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MeterBinder__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ButtonBinder__ = __webpack_require__(51);
function Top(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'navbar pt-2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TitleBinder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MeterBinder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ButtonBinder__["a" /* default */],null)));}/* harmony default export */ __webpack_exports__["a"] = (Top);

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Title__ = __webpack_require__(48);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TitleBinder=function(_Component){_inherits(TitleBinder,_Component);function TitleBinder(){_classCallCheck(this,TitleBinder);return _possibleConstructorReturn(this,(TitleBinder.__proto__||Object.getPrototypeOf(TitleBinder)).apply(this,arguments));}_createClass(TitleBinder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Title__["a" /* default */],null);}}]);return TitleBinder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TitleBinder);

/***/ }),
/* 47 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Title(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"navbar-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\xA0\xA0\xA0\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon icon-menu icon-2x hvr-pulse c-hand"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\xA0\xA0\xA0\xA0\xA0\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"h4 c-hand",lang:"zh-Hans"},"\u5C0F\u969C"));}/* harmony default export */ __webpack_exports__["a"] = (Title);

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Meter__ = __webpack_require__(50);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MeterBinder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("uiState"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(_class=function(_Component){_inherits(MeterBinder,_Component);function MeterBinder(){_classCallCheck(this,MeterBinder);return _possibleConstructorReturn(this,(MeterBinder.__proto__||Object.getPrototypeOf(MeterBinder)).apply(this,arguments));}_createClass(MeterBinder,[{key:'render',value:function render(){var meterValue=this.props.uiState.meterValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Meter__["a" /* default */],{value:meterValue});}}]);return MeterBinder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (MeterBinder);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Meter(props){var value=props.value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"navbar-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meter",{className:"meter",value:value,optimum:"90",min:"0",max:"100",low:"40",high:"70",style:{width:"42rem"}}));}/* harmony default export */ __webpack_exports__["a"] = (Meter);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(52);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonBinder=function(_Component){_inherits(ButtonBinder,_Component);function ButtonBinder(){_classCallCheck(this,ButtonBinder);return _possibleConstructorReturn(this,(ButtonBinder.__proto__||Object.getPrototypeOf(ButtonBinder)).apply(this,arguments));}_createClass(ButtonBinder,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Button__["a" /* default */],null);}}]);return ButtonBinder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ButtonBinder);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Button(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"navbar-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"badge",tabIndex:"-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"icon icon-mail icon-2x c-hand hvr-pulse"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\xA0\xA0\xA0\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn hvr-pulse",lang:"zh-Hans",tabIndex:"-1"},"\u767B\u5F55"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\xA0\xA0\xA0\xA0"));}/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InputBinder__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowTextBinder__ = __webpack_require__(61);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Text=function(_Component){_inherits(Text,_Component);function Text(){_classCallCheck(this,Text);return _possibleConstructorReturn(this,(Text.__proto__||Object.getPrototypeOf(Text)).apply(this,arguments));}_createClass(Text,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShowTextBinder__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__InputBinder__["a" /* default */],null));}}]);return Text;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Text);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toolsClass_DataTools__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toolsClass_EffectTools__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toolsClass_HigherTools__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__(60);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InputBinder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["b" /* inject */])("uiState","appState","inputState"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_1_mobx_react__["c" /* observer */])(_class=function(_Component){_inherits(InputBinder,_Component);function InputBinder(props){_classCallCheck(this,InputBinder);var _this=_possibleConstructorReturn(this,(InputBinder.__proto__||Object.getPrototypeOf(InputBinder)).call(this,props));_this.playQQMusicWindowId=0;_this.replyEffect=function(){if(_this.props.inputState.clickedUrl===""){return;}if(!__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].asyncInputKey.has(_this.props.appState.asyncEffect)){if(_this.replyEffectTimer){clearTimeout(_this.replyEffectTimer);}_this.replyEffectTimer=setTimeout(function(){_this.lastUrlRef.href=_this.props.inputState.clickedUrl;_this.lastUrlRef.click();_this.inputRef.focus();_this.inputRef.blur();_this.props.inputState.clickedUrl="";_this.replyEffectTimer=null;},__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.newWindowTime);}else if(_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.playQQMusic){if(_this.replyEffectTimer){clearTimeout(_this.replyEffectTimer);}_this.replyEffectTimer=setTimeout(function(){_this.lastUrlRef.href=_this.props.inputState.clickedUrl;if(_this.playQQMusicWindowId===1){_this.props.appState.playQQMusicWindow.resizeTo(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.playQQMusicWindowWidth,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.playQQMusicWindowHeight);_this.props.appState.playQQMusicWindow.moveTo((window.screen.width-__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.playQQMusicWindowWidth)/2,(window.screen.height-__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.playQQMusicWindowHeight)/2);_this.props.appState.playQQMusicWindow.location.href=_this.props.inputState.clickedUrl;}else if(_this.playQQMusicWindowId===2){var tempWindow=_this.props.appState.playQQMusicOtherWindow;setTimeout(function(){tempWindow.close();},__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.otherWindowDisplayTime);_this.props.appState.playQQMusicOtherWindow.location.href=_this.props.inputState.clickedUrl;}_this.props.inputState.clickedUrl="";_this.replyEffectTimer=null;},__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.newWindowTime);}else if(_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.playQQMusicMv){if(_this.replyEffectTimer){clearTimeout(_this.replyEffectTimer);}_this.replyEffectTimer=setTimeout(function(){_this.lastUrlRef.href=_this.props.inputState.clickedUrl;_this.props.appState.playQQMusicMvWindow.resizeTo(window.screen.width-60,window.screen.height-60);_this.props.appState.playQQMusicMvWindow.moveTo(30,30);_this.props.appState.playQQMusicMvWindow.location.href=_this.props.inputState.clickedUrl;_this.props.inputState.clickedUrl="";_this.replyEffectTimer=null;},__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.newWindowTime);}};_this.handleKeyboardEvent=function(event){var keyCode=event.keyCode;if(keyCode===13){_this.throttleHandleEnter();}else if(keyCode===38){_this.handleStorageInputValue(true);event.preventDefault();}else if(keyCode===40){_this.handleStorageInputValue(false);event.preventDefault();}};_this.handleEnter=function(){if(_this.props.inputState.inputIsFocus&&!_this.props.inputState.inputIsComposition){_this.handleInput();}else{_this.inputRef.focus();}};_this.handleStorageInputValue=function(isUp){if(_this.props.inputState.inputIsFocus&&!_this.props.inputState.inputIsComposition){_this.props.appState.setIuputValueCount(isUp);if(_this.props.appState.inputValueListValue){_this.props.inputState.changeInputValue(_this.props.appState.inputValueListValue);}else{_this.props.inputState.changeInputValue("");}}};_this.changeInputValue=function(event){//if(!this.props.inputState.inputIsComposition)
_this.props.inputState.changeInputValue(event.target.value);};_this.handleInput=function(event){_this.testTime=Date.now();if(_this.props.inputState.inputValue===""){_this.inputRef.blur();return;}_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.doing);var dataTools=__WEBPACK_IMPORTED_MODULE_4__toolsClass_DataTools__["a" /* default */].createDataToolsClass();var effectTools=__WEBPACK_IMPORTED_MODULE_5__toolsClass_EffectTools__["a" /* default */].createEffectToolsClass();dataTools.handleKeyAndStorageWithLocal(_this.props.inputState.inputValue,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].storageKey.inputValue,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.storageInputValueCount);_this.props.appState.pushInputValueList(_this.props.inputState.inputValue);_this.props.appState.setInputValueCountZero();var standardInput=dataTools.convertInputToObject(_this.props.inputState.inputValue);var standardInputWithEffect=dataTools.addEffectToStandardInput(standardInput,_this.props.appState.defaultValue);_this.props.appState.setAsyncEffect(standardInputWithEffect.effect);var effect=effectTools.switchInputToEffect(standardInputWithEffect);if(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].asyncInputKey.has(_this.props.appState.asyncEffect)){if(standardInput.arguments.length!==0)_this.handleAsyncWindow();_this.handleAsyncEffect(effect);}else _this.handleEffect(effect);_this.props.inputState.changeInputValue("");_this.inputRef.blur();_this.props.uiState.setInputA(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].text.get("input2"));};_this.handleEffect=function(effect){if(effect.state===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error||effect.url===null||effect.url===""){if(effect.state===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.success){_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.success);}else{_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error);}}else if(effect.state===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.warning){_this.props.inputState.changeClickedUrl(effect.url);_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.warning);}else if(effect.state===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.success){_this.props.inputState.changeClickedUrl(effect.url);_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.success);}else{_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error);}if(_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.clear||_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.clearInput){_this.props.appState.setInputValueList([]);}};_this.handleAsyncEffect=function(effect){if(effect.state===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error){_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error);return;}var dataTools=__WEBPACK_IMPORTED_MODULE_4__toolsClass_DataTools__["a" /* default */].createDataToolsClass();effect.then(function(data){var state=dataTools.convertAsyncDataToEffect(data);if(state.url===""){_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.error);}else if(state.errorInfo.length!==0){console.log(Date.now()-_this.testTime);_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.warning);_this.props.inputState.changeClickedUrl(state.url);}else{console.log(Date.now()-_this.testTime);_this.props.appState.changeExecuteState(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].executeKey.success);_this.props.inputState.changeClickedUrl(state.url);}_this.props.appState.changeExecuteErrorInfo(state.errorInfo);dataTools.handleKeyAndStorageWithSession(state.keys,_this.props.appState.asyncEffect,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.storageSongCount,false);});};_this.handleAsyncWindow=function(){var playQQMusicWindow=_this.props.appState.playQQMusicWindow;var effectTools=__WEBPACK_IMPORTED_MODULE_5__toolsClass_EffectTools__["a" /* default */].createEffectToolsClass();if(_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.playQQMusic){if(playQQMusicWindow===null||playQQMusicWindow.closed){var tempWindow=window.open("",effectTools.randomStringkBuilder(30),'channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top='+window.screen.height/2+',width=160');_this.props.appState.setPlayQQMusicWindow(tempWindow);_this.playQQMusicWindowId=1;}else{var _tempWindow=window.open("",effectTools.randomStringkBuilder(30),'channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top='+window.screen.height/2+',width=160');_this.props.appState.setPlayQQMusicOtherWindow(_tempWindow);_this.playQQMusicWindowId=2;}}else if(_this.props.appState.asyncEffect===__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].inputKey.playQQMusicMv){var _tempWindow2=window.open("",effectTools.randomStringkBuilder(30),'channelmode=0,directories=0,fullscreen=0,height=120,left=75,location=0,menubar=0,resizable=1,scrollbars=0,status=0,titlebar=0,toolbar=0,top='+window.screen.height/2+',width=160');_this.props.appState.setPlayQQMusicMvWindow(_tempWindow2);}};_this.getLastUrlRef=function(a){_this.lastUrlRef=a;};_this.getInputRef=function(input){_this.inputRef=input;};_this.inputOnFocus=function(event){_this.props.inputState.switchInputFocus(true);};_this.inputOnBlur=function(event){_this.props.inputState.switchInputFocus(false);};_this.inputOnCompositionStart=function(event){_this.props.inputState.switchInputComposition(true);};_this.inputOnCompositionEnd=function(event){_this.props.inputState.switchInputComposition(false);};_this.turnIntoBlur=function(event){event.target.blur();};var higherTools=__WEBPACK_IMPORTED_MODULE_6__toolsClass_HigherTools__["a" /* default */].createHigherToolsClass();_this.throttleHandleEnter=higherTools.throttle(_this.handleEnter,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.enterTime);_this.modifyUrlReaction=Object(__WEBPACK_IMPORTED_MODULE_2_mobx__["m" /* reaction */])(function(){return _this.props.inputState.clickedUrl;},_this.replyEffect);return _this;}//测试用
_createClass(InputBinder,[{key:'componentDidMount',value:function componentDidMount(){var higherTools=__WEBPACK_IMPORTED_MODULE_6__toolsClass_HigherTools__["a" /* default */].createHigherToolsClass();var dataTools=__WEBPACK_IMPORTED_MODULE_4__toolsClass_DataTools__["a" /* default */].createDataToolsClass();window.onkeydown=this.handleKeyboardEvent;var value=localStorage.getItem(__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].storageKey.inputValue);var valueArray=dataTools.csvToArrayNoEmpty(value);this.props.appState.setInputValueList(valueArray);}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.modifyUrlReaction();window.onkeydown=null;}},{key:'render',value:function render(){var _props$uiState=this.props.uiState,loadingStyle=_props$uiState.loadingStyle,inputButtonStyle=_props$uiState.inputButtonStyle,inputA=_props$uiState.inputA;var inputValue=this.props.inputState.inputValue;var higherTools=__WEBPACK_IMPORTED_MODULE_6__toolsClass_HigherTools__["a" /* default */].createHigherToolsClass();var props={getLastUrlRef:this.getLastUrlRef,getInputRef:this.getInputRef,input:inputA,submit:__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].text.get("submit"),handleInput:higherTools.throttle(this.handleInput,__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].count.handleInputTime),changeInputValue:this.changeInputValue,inputValue:inputValue,loadingStyle:__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].defaultStyle.get(loadingStyle),inputButtonStyle:__WEBPACK_IMPORTED_MODULE_3__Const__["a" /* default */].defaultStyle.get(inputButtonStyle),inputOnFocus:this.inputOnFocus,inputOnBlur:this.inputOnBlur,turnIntoBlur:this.turnIntoBlur,inputOnCompositionStart:this.inputOnCompositionStart,inputOnCompositionEnd:this.inputOnCompositionEnd};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["a" /* default */],props);}}]);return InputBinder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (InputBinder);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Const__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp,_initialiseProps;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var EffectTools=(_temp=_class=function(){function EffectTools(Const){_classCallCheck(this,EffectTools);_initialiseProps.call(this);this.instance=null;}_createClass(EffectTools,null,[{key:"createEffectToolsClass",value:function createEffectToolsClass(){if(!this.instance){this.instance=new EffectTools();}return this.instance;}}]);return EffectTools;}(),_initialiseProps=function _initialiseProps(){var _this=this;this.switchInputToEffect=function(standardInput){var data=void 0;switch(standardInput.effect){case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.open:data=_this.effectOpen(standardInput.arguments);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.clear:data=_this.effectClear(standardInput.arguments);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.clearList:data=_this.effectClearList(standardInput.arguments);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.clearInput:data=_this.effectClearInput(standardInput.arguments);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidu:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidu,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.ecosia:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.ecosia,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.google:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.google,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.yahoo:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.yahoo,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.bing:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.bing,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qihu:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qihu,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sougou:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sougou,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.soso:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.soso,standardInput.lastType);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.tudou:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.tudou);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youku:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youku);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqVideo:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqVideo);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.iqiyi:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.iqiyi);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.bilibili:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.bilibili);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.mgtv:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.mgtv);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sohutv:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sohutv);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.le:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.le);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.acfun:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.acfun);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.nico:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.nico);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youtube:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youtube);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqmusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqmusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.xiamimusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.xiamimusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.netmusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.netmusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.kugoumusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.kugoumusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youtubemusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.youtubemusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidumusic:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidumusic);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.yinyuetai:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.yinyuetai);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqmusicmv:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqmusicmv);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusic:return standardInput.arguments.length!==0?_this.effectPlayQQMusic(standardInput.arguments):{state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.error,url:""};case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusicMv:return standardInput.arguments.length!==0?_this.effectPlayQQMusicMv(standardInput.arguments):{state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.error,url:""};case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.zhihu:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.zhihu);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baiduzhidao:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baiduzhidao);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidubaike:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidubaike);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sougoubaike:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sougoubaike);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qihubaike:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qihubaike);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidubaikeSearch:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baidubaikeSearch);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.hudongbaike:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.hudongbaike);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.wikibaike:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.wikibaike);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baiduxinwen:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.baiduxinwen);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqxinwen:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.qqxinwen);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sohuxinwen:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sohuxinwen);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sinaxinwen:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.sinaxinwen);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.taobao:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.taobao);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.tmall:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.tmall);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.jd:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.jd);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.amazon:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.amazon);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.amazoncn:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.amazoncn);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.github:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.github);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.oschina:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.oschina);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.segmentfault:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.segmentfault);break;case __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.stackoverflow:data=_this.effectLikeSearch(standardInput.arguments,__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.stackoverflow);break;default:}return data;};this.effectOpen=function(args){var data={state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success,url:""};if(args.length===0){data.state=__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.error;return data;}data.url=__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].openSites.get(args[0]);return data;};this.effectClear=function(args){var data={state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success,url:""};localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].storageKey.inputValue);sessionStorage.clear();return data;};this.effectClearList=function(args){sessionStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].storageKey.playQQMusic);return{state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success,url:""};};this.effectClearInput=function(args){localStorage.removeItem(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].storageKey.inputValue);return{state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success,url:""};};this.effectLikeSearch=function(args,value){var lastType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;var data={state:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.success,url:""};if(args.length===0)args=[""];data.url=__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(value).firstHalf+args.reduce(function(x,y){return x+" "+y;})+__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(value).secondHalf;if(lastType===__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.open){data.state=__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].executeKey.warning;}return data;};this.effectPlayQQMusic=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(args){var songs,errorCount,_loop,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:songs=[];errorCount=[];_loop=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(i){var firstRandom,secondRandom;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:firstRandom=_this.randomStringkBuilder(17);secondRandom=_this.randomStringkBuilder(16);_context.next=4;return __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].outFunctions.fetchJsonp(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusic).firstHalf.replace("9527",firstRandom)+args[i]+__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusic).secondHalf.replace("9527",secondRandom),{jsonpCallbackFunction:"MusicJsonCallback"+secondRandom}).then(function(response){return response.json();}).catch(function(e){errorCount.push(i);});case 4:songs[i]=_context.sent;case 5:case"end":return _context.stop();}}},_callee,_this);});i=0;case 4:if(!(i<args.length)){_context2.next=9;break;}return _context2.delegateYield(_loop(i),"t0",6);case 6:i++;_context2.next=4;break;case 9:return _context2.abrupt("return",{type:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusic,songs:songs,errorCount:errorCount});case 10:case"end":return _context2.stop();}}},_callee2,_this);}));return function(_x2){return _ref.apply(this,arguments);};}();this.effectPlayQQMusicMv=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(args){var songs,errorCount,_loop2,i;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:songs=[];errorCount=[];_loop2=/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(i){var firstRandom,secondRandom;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:firstRandom=_this.randomStringkBuilder(17);secondRandom=_this.randomStringkBuilder(16);_context3.next=4;return __WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].outFunctions.fetchJsonp(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusicMv).firstHalf.replace("9527",firstRandom)+args[i]+__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].httpApi.get(__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusicMv).secondHalf.replace("9527",secondRandom),{jsonpCallbackFunction:"MusicJsonCallback"+secondRandom}).then(function(response){return response.json();}).catch(function(e){errorCount.push(i);});case 4:songs[i]=_context3.sent;case 5:case"end":return _context3.stop();}}},_callee3,_this);});i=0;case 4:if(!(i<args.length)){_context4.next=9;break;}return _context4.delegateYield(_loop2(i),"t0",6);case 6:i++;_context4.next=4;break;case 9:return _context4.abrupt("return",{type:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].inputKey.playQQMusicMv,songs:songs,errorCount:errorCount});case 10:case"end":return _context4.stop();}}},_callee4,_this);}));return function(_x3){return _ref2.apply(this,arguments);};}();this.randomStringkBuilder=function(count){var randomString="";for(var i=0;i<count;i++){randomString+=Math.abs(Math.floor(Math.random()*10-0.0001)).toString();}return randomString;};},_temp);/* harmony default export */ __webpack_exports__["a"] = (EffectTools);

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(57);


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(58);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var HigherTools=function(){function HigherTools(){_classCallCheck(this,HigherTools);this.debounce=function(func,times){var timer=void 0;return function(){for(var _len=arguments.length,rest=Array(_len),_key=0;_key<_len;_key++){rest[_key]=arguments[_key];}if(!timer){timer=setTimeout(function(){func.apply(undefined,rest);timer=null;},times);}else{clearTimeout(timer);timer=setTimeout(function(){func.apply(undefined,rest);timer=null;},times);}};};this.throttle=function(func,times){var timer=void 0;var ok=true;return function(){if(ok){ok=false;timer=setTimeout(function(){ok=true;},times);func.apply(undefined,arguments);}};};this.instance=null;}_createClass(HigherTools,null,[{key:'createHigherToolsClass',value:function createHigherToolsClass(){if(!this.instance){this.instance=new HigherTools();}return this.instance;}}]);return HigherTools;}();/* harmony default export */ __webpack_exports__["a"] = (HigherTools);

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Input(props){var input=props.input,submit=props.submit,getLastUrlRef=props.getLastUrlRef,getInputRef=props.getInputRef,changeInputValue=props.changeInputValue,handleInput=props.handleInput,inputValue=props.inputValue,inputOnFocus=props.inputOnFocus,inputOnBlur=props.inputOnBlur,turnIntoBlur=props.turnIntoBlur,inputOnCompositionEnd=props.inputOnCompositionEnd,inputOnCompositionStart=props.inputOnCompositionStart,loadingStyle=props.loadingStyle,inputButtonStyle=props.inputButtonStyle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container grid-md pt-2",key:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns col-gapless"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column col-10 has-icon-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"input-group"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"input-group-addon"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",ref:getLastUrlRef,className:"text-dark",tabIndex:"-1",onFocus:turnIntoBlur},input)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"text",className:"form-input",placeholder:"",ref:getInputRef,tabIndex:"-1",onChange:changeInputValue,value:inputValue,onFocus:inputOnFocus,onBlur:inputOnBlur,onCompositionStart:inputOnCompositionStart,onCompositionEnd:inputOnCompositionEnd})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i",{className:"form-icon loading",style:loadingStyle})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column col-2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"btn-block"+" "+inputButtonStyle,tabIndex:"-1",onClick:handleInput,onFocus:turnIntoBlur},submit))));}/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mobx_react__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ShowText__ = __webpack_require__(62);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ShowTextBinder=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["b" /* inject */])("uiState"),_dec(_class=Object(__WEBPACK_IMPORTED_MODULE_2_mobx_react__["c" /* observer */])(_class=function(_Component){_inherits(ShowTextBinder,_Component);function ShowTextBinder(){_classCallCheck(this,ShowTextBinder);return _possibleConstructorReturn(this,(ShowTextBinder.__proto__||Object.getPrototypeOf(ShowTextBinder)).apply(this,arguments));}_createClass(ShowTextBinder,[{key:'render',value:function render(){var _props$uiState=this.props.uiState,showKey=_props$uiState.showKey,toastStyle=_props$uiState.toastStyle;var props={showText:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].showText.get(showKey),showAuthor:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].showAuthor.get(showKey),toastStyle:__WEBPACK_IMPORTED_MODULE_1__Const__["a" /* default */].defaultStyle.get(toastStyle)};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ShowText__["a" /* default */],props);}}]);return ShowTextBinder;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (ShowTextBinder);

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function ShowText(props){var showText=props.showText,showAuthor=props.showAuthor,toastStyle=props.toastStyle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container grid-md pt-2",style:{margin:"40px auto auto auto"},key:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"column col-12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:toastStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h5",{lang:"zh-Hans",style:{margin:"7px auto"}},"\xA0\xA0\xA0\xA0",showText),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("cite",{lang:"zh-Hans"},"\xA0\xA0\xA0\xA0",showAuthor)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"divider"}));}/* harmony default export */ __webpack_exports__["a"] = (ShowText);

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return uiState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toolsClass_DataTools__ = __webpack_require__(12);
var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var UIState=(_class=function UIState(){_classCallCheck(this,UIState);_initDefineProp(this,'inputA',_descriptor,this);_initDefineProp(this,'showKey',_descriptor2,this);_initDefineProp(this,'meterValue',_descriptor3,this);_initDefineProp(this,'loadingStyle',_descriptor4,this);_initDefineProp(this,'toastStyle',_descriptor5,this);_initDefineProp(this,'inputButtonStyle',_descriptor6,this);_initDefineProp(this,'setInputA',_descriptor7,this);_initDefineProp(this,'setloadingStyle',_descriptor8,this);_initDefineProp(this,'meterValuePlusCount',_descriptor9,this);_initDefineProp(this,'ChangeMeterValue',_descriptor10,this);_initDefineProp(this,'beDoingUI',_descriptor11,this);_initDefineProp(this,'beNotUI',_descriptor12,this);_initDefineProp(this,'beSuccessUI',_descriptor13,this);_initDefineProp(this,'beWarningUI',_descriptor14,this);_initDefineProp(this,'beErrorUI',_descriptor15,this);var dataTools=__WEBPACK_IMPORTED_MODULE_2__toolsClass_DataTools__["a" /* default */].createDataToolsClass();var index=dataTools.randomCount(__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].randomShowKey.length);this.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].randomShowKey[index];},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'inputA',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].text.get("input");}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'showKey',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:null}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'meterValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return 0;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'loadingStyle',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.hide;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'toastStyle',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastPrimary;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'inputButtonStyle',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonPrimary;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'setInputA',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this=this;return function(value){_this.inputA=value;};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'setloadingStyle',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(style){if(style!==_this2.loadingStyle)_this2.loadingStyle=style;};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'meterValuePlusCount',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(count){_this3.meterValue+=count;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'ChangeMeterValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(count){_this4.meterValue=count;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'beDoingUI',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(){_this5.ChangeMeterValue(0);if(_this5.meterTimer)clearInterval(_this5.meterTimer);_this5.loadingStyle=null;_this5.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].showKey.xzing;_this5.meterTimer=setInterval(function(){_this5.meterValuePlusCount(3);if(_this5.meterValue>=81){clearInterval(_this5.meterTimer);_this5.meterTimer=null;}},10);_this5.toastStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastPrimary;_this5.inputButtonStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonPrimary;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'beNotUI',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(){if(_this6.meterTimer)clearInterval(_this6.meterTimer);_this6.loadingStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.hide;_this6.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].showKey.xzNot;_this6.ChangeMeterValue(0);_this6.toastStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastPrimary;_this6.inputButtonStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonPrimary;};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'beSuccessUI',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(){if(_this7.meterTimer)clearInterval(_this7.meterTimer);_this7.loadingStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.hide;_this7.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].showKey.xzSuccess;_this7.meterTimer=setInterval(function(){_this7.meterValuePlusCount(3);if(_this7.meterValue>=100){clearInterval(_this7.meterTimer);_this7.meterTimer=null;}},Math.round(200*3/(100-_this7.meterValue)));_this7.toastStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastSuccess;_this7.inputButtonStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonSuccess;};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'beWarningUI',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){if(_this8.meterTimer)clearInterval(_this8.meterTimer);_this8.loadingStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.hide;_this8.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].showKey.xzWarning;_this8.meterTimer=setInterval(function(){_this8.meterValuePlusCount(_this8.meterValue<=60?3:-3);if(_this8.meterValue<=60?_this8.meterValue>=60:_this8.meterValue<=60){clearInterval(_this8.meterTimer);_this8.meterTimer=null;}},Math.round(200*3/Math.abs(60-_this8.meterValue)));_this8.toastStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastWarning;_this8.inputButtonStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonWarning;};}}),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'beErrorUI',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(){if(_this9.meterTimer)clearInterval(_this9.meterTimer);_this9.loadingStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.hide;_this9.showKey=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].showKey.xzError;_this9.meterTimer=setInterval(function(){_this9.meterValuePlusCount(_this9.meterValue<=30?3:-3);if(_this9.meterValue<=30?_this9.meterValue>=30:_this9.meterValue<=30){clearInterval(_this9.meterTimer);_this9.meterTimer=null;}},Math.round(200*3/Math.abs(30-_this9.meterValue)));_this9.toastStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.toastError;_this9.inputButtonStyle=__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].styleKey.inputButtonError;};}})),_class);var uiState=new UIState();

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return otherState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var OtherState=function OtherState(){_classCallCheck(this,OtherState);};var otherState=new OtherState();

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8,_descriptor9,_descriptor10,_descriptor11,_descriptor12,_descriptor13,_descriptor14,_descriptor15,_descriptor16,_descriptor17,_descriptor18;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var AppState=(_class=function(){function AppState(){_classCallCheck(this,AppState);_initDefineProp(this,'defaultValue',_descriptor,this);_initDefineProp(this,'executeState',_descriptor2,this);_initDefineProp(this,'executeErrorInfo',_descriptor3,this);_initDefineProp(this,'playQQMusicWindow',_descriptor4,this);_initDefineProp(this,'playQQMusicOtherWindow',_descriptor5,this);_initDefineProp(this,'playQQMusicMvWindow',_descriptor6,this);_initDefineProp(this,'asyncEffect',_descriptor7,this);_initDefineProp(this,'inputValueList',_descriptor8,this);_initDefineProp(this,'changeExecuteState',_descriptor9,this);_initDefineProp(this,'changeExecuteErrorInfo',_descriptor10,this);_initDefineProp(this,'setPlayQQMusicWindow',_descriptor11,this);_initDefineProp(this,'setPlayQQMusicOtherWindow',_descriptor12,this);_initDefineProp(this,'setPlayQQMusicMvWindow',_descriptor13,this);_initDefineProp(this,'setAsyncEffect',_descriptor14,this);_initDefineProp(this,'setIuputValueCount',_descriptor15,this);_initDefineProp(this,'setInputValueCountZero',_descriptor16,this);_initDefineProp(this,'setInputValueList',_descriptor17,this);_initDefineProp(this,'pushInputValueList',_descriptor18,this);}_createClass(AppState,[{key:'inputValueListValue',get:function get(){return this.inputValueList.list.length-this.inputValueList.count<=0&&this.inputValueList.list.length-this.inputValueList.count>=this.inputValueList.list.length?"":this.inputValueList.list[this.inputValueList.list.length-this.inputValueList.count];}}]);return AppState;}(),(_descriptor=_applyDecoratedDescriptor(_class.prototype,'defaultValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].defaultValue;}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'executeState',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return __WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].executeKey.not;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'executeErrorInfo',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:null}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'playQQMusicWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'playQQMusicOtherWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'playQQMusicMvWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'asyncEffect',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return null;}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'inputValueList',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return{list:[],count:0};}}),_descriptor9=_applyDecoratedDescriptor(_class.prototype,'changeExecuteState',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this=this;return function(state){if(_this.executeState===state){return;}_this.executeState=state;};}}),_descriptor10=_applyDecoratedDescriptor(_class.prototype,'changeExecuteErrorInfo',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(info){if(info)_this2.executeErrorInfo=info;};}}),_descriptor11=_applyDecoratedDescriptor(_class.prototype,'setPlayQQMusicWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(value){_this3.playQQMusicWindow=value;};}}),_descriptor12=_applyDecoratedDescriptor(_class.prototype,'setPlayQQMusicOtherWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(value){_this4.playQQMusicOtherWindow=value;};}}),_descriptor13=_applyDecoratedDescriptor(_class.prototype,'setPlayQQMusicMvWindow',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this5=this;return function(value){_this5.playQQMusicMvWindow=value;};}}),_descriptor14=_applyDecoratedDescriptor(_class.prototype,'setAsyncEffect',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this6=this;return function(value){_this6.asyncEffect=value;};}}),_applyDecoratedDescriptor(_class.prototype,'inputValueListValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["e" /* computed */]],Object.getOwnPropertyDescriptor(_class.prototype,'inputValueListValue'),_class.prototype),_descriptor15=_applyDecoratedDescriptor(_class.prototype,'setIuputValueCount',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this7=this;return function(isUp){if(isUp)_this7.inputValueList.count++;else _this7.inputValueList.count--;if(_this7.inputValueList.count>=_this7.inputValueList.list.length){_this7.inputValueList.count=_this7.inputValueList.list.length-1;if(_this7.inputValueList.count===0)_this7.inputValueList.count=1;}else if(_this7.inputValueList.count<0)_this7.inputValueList.count=0;console.log(_this7.inputValueList.count);};}}),_descriptor16=_applyDecoratedDescriptor(_class.prototype,'setInputValueCountZero',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this8=this;return function(){_this8.inputValueList.count=0;};}}),_descriptor17=_applyDecoratedDescriptor(_class.prototype,'setInputValueList',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this9=this;return function(list){_this9.inputValueList.list=list;};}}),_descriptor18=_applyDecoratedDescriptor(_class.prototype,'pushInputValueList',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this10=this;return function(value){_this10.inputValueList.list.push(value);while(_this10.inputValueList.list.length>__WEBPACK_IMPORTED_MODULE_0__Const__["a" /* default */].count.storageInputValueCount){_this10.inputValueList.list.shift();}};}})),_class);var appState=new AppState();

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return inputState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Const__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mobx__ = __webpack_require__(4);
var _desc,_value,_class,_descriptor,_descriptor2,_descriptor3,_descriptor4,_descriptor5,_descriptor6,_descriptor7,_descriptor8;function _initDefineProp(target,property,descriptor,context){if(!descriptor)return;Object.defineProperty(target,property,{enumerable:descriptor.enumerable,configurable:descriptor.configurable,writable:descriptor.writable,value:descriptor.initializer?descriptor.initializer.call(context):void 0});}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _applyDecoratedDescriptor(target,property,decorators,descriptor,context){var desc={};Object['ke'+'ys'](descriptor).forEach(function(key){desc[key]=descriptor[key];});desc.enumerable=!!desc.enumerable;desc.configurable=!!desc.configurable;if('value'in desc||desc.initializer){desc.writable=true;}desc=decorators.slice().reverse().reduce(function(desc,decorator){return decorator(target,property,desc)||desc;},desc);if(context&&desc.initializer!==void 0){desc.value=desc.initializer?desc.initializer.call(context):void 0;desc.initializer=undefined;}if(desc.initializer===void 0){Object['define'+'Property'](target,property,desc);desc=null;}return desc;}function _initializerWarningHelper(descriptor,context){throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');}var InputState=(_class=function InputState(){_classCallCheck(this,InputState);_initDefineProp(this,'inputValue',_descriptor,this);_initDefineProp(this,'inputIsFocus',_descriptor2,this);_initDefineProp(this,'inputIsComposition',_descriptor3,this);_initDefineProp(this,'clickedUrl',_descriptor4,this);_initDefineProp(this,'changeInputValue',_descriptor5,this);_initDefineProp(this,'changeClickedUrl',_descriptor6,this);_initDefineProp(this,'switchInputFocus',_descriptor7,this);_initDefineProp(this,'switchInputComposition',_descriptor8,this);},(_descriptor=_applyDecoratedDescriptor(_class.prototype,'inputValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return"";}}),_descriptor2=_applyDecoratedDescriptor(_class.prototype,'inputIsFocus',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor3=_applyDecoratedDescriptor(_class.prototype,'inputIsComposition',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:function initializer(){return false;}}),_descriptor4=_applyDecoratedDescriptor(_class.prototype,'clickedUrl',[__WEBPACK_IMPORTED_MODULE_1_mobx__["l" /* observable */]],{enumerable:true,initializer:null}),_descriptor5=_applyDecoratedDescriptor(_class.prototype,'changeInputValue',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this=this;return function(value){_this.inputValue=value;};}}),_descriptor6=_applyDecoratedDescriptor(_class.prototype,'changeClickedUrl',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this2=this;return function(url){if(url!==null&&url!=="")_this2.clickedUrl=url;};}}),_descriptor7=_applyDecoratedDescriptor(_class.prototype,'switchInputFocus',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this3=this;return function(flag){_this3.inputIsFocus=flag;};}}),_descriptor8=_applyDecoratedDescriptor(_class.prototype,'switchInputComposition',[__WEBPACK_IMPORTED_MODULE_1_mobx__["d" /* action */]],{enumerable:true,initializer:function initializer(){var _this4=this;return function(flag){_this4.inputIsComposition=flag;};}})),_class);var inputState=new InputState();

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.675ee2ae.js